        import { initializeApp } from "https://www.gstatic.com/firebasejs/10.11.0/firebase-app.js";
        import { getAuth, createUserWithEmailAndPassword, signInWithEmailAndPassword, sendEmailVerification, signOut, onAuthStateChanged } from "https://www.gstatic.com/firebasejs/10.11.0/firebase-auth.js";
        import { getFirestore, collection, doc, getDoc, setDoc, addDoc, updateDoc, deleteDoc, serverTimestamp, Timestamp, query, where, getDocs, writeBatch } from "https://www.gstatic.com/firebasejs/10.11.0/firebase-firestore.js";
        import { getFunctions, httpsCallable } from "https://www.gstatic.com/firebasejs/10.11.0/firebase-functions.js";
        import { initializeAppCheck, ReCaptchaV3Provider } from "https://www.gstatic.com/firebasejs/10.11.0/firebase-app-check.js";
        import { getStorage, ref, uploadBytes, getDownloadURL } from "https://www.gstatic.com/firebasejs/10.11.0/firebase-storage.js";
        import { evaluatePasswordStrength, normalizeInviteList, getDuplicateEmails, normalizeJoinRole, generateCode, normalizeRate, resolveDraftTimestamp, formatDraftTimestamp, deriveSalesTypesFromProducts, normalizeSubscriptionModules, getSelfInviteEmails, stepLabel, isValidEmail, normalizeWebsite, normalizeEmployeeCount, normalizeMoney, formatCurrency, getSessionBlockedMessage, normalizeBillingCycle, getEnabledAddonCount, getAddonSeatBreakdown, pickLatestDraft } from './register.utils.js';

        const firebaseConfig = {
            apiKey: "AIzaSyBpAHaCoDa799vvxloEB--R0rEwzcxAQhE",
            authDomain: "appnity-for-business.firebaseapp.com",
            projectId: "appnity-for-business",
            storageBucket: "appnity-for-business.firebasestorage.app",
            messagingSenderId: "952421965462",
            appId: "1:952421965462:web:414b548ed79e149c1dacb7",
            measurementId: "G-DJEXRKN9KV"
        };

        const app = initializeApp(firebaseConfig);
        // App Check (Bot-/Skript-Schutz). Site-Key aus Firebase Console → App Check hier eintragen; leer = kein-Op.
        // DEV: Auf localhost/127.0.0.1 einen Debug-Token verwenden, damit reCAPTCHA-App-Check (das auf
        // nicht-registrierten Domains mit "recaptcha-error" scheitert und App-Check-Functions 401 liefert)
        // lokal funktioniert. Den in der Konsole ausgegebenen Token in Firebase → App Check → Debug-Tokens
        // eintragen. In Produktion (echte Domain) NICHT aktiv — dort muss die Domain im reCAPTCHA-Key stehen.
        try {
            const _h = location.hostname;
            if (_h === 'localhost' || _h === '127.0.0.1' || _h === '[::1]') {
                self.FIREBASE_APPCHECK_DEBUG_TOKEN = true;
            }
        } catch (e) {}
        const APP_CHECK_SITE_KEY = '6Le_SUstAAAAAMlGCxVnSmr2znup1XaeJ3G9xdOg';
        if (APP_CHECK_SITE_KEY) {
            try { initializeAppCheck(app, { provider: new ReCaptchaV3Provider(APP_CHECK_SITE_KEY), isTokenAutoRefreshEnabled: true }); }
            catch (e) { console.warn('App Check init fehlgeschlagen', e); }
        }
        const auth = getAuth(app);
        const db = getFirestore(app);
        const storage = getStorage(app);
        let registrationAssistant = null;
        const enableRegistrationAssistant = window.APPNITY_ENABLE_ASSISTANT === true;
        let sendInviteEmailFn = null;
        let resolveOrgCodeFn = null;
        let generateOrgCodeFn = null;
        let sendVerificationEmailFn = null;
        let createSubscriptionCheckoutSessionFn = null;
        let confirmSubscriptionCheckoutFn = null;
        let lookupZefixCompanyFn = null;
        try {
            const functions = getFunctions(app, 'europe-west6');
            registrationAssistant = enableRegistrationAssistant
                ? httpsCallable(functions, 'registrationAssistant')
                : null;
            sendInviteEmailFn = httpsCallable(functions, 'sendInviteEmail');
            resolveOrgCodeFn = httpsCallable(functions, 'resolveOrgCode');
            generateOrgCodeFn = httpsCallable(functions, 'generateOrgCode');
            sendVerificationEmailFn = httpsCallable(functions, 'sendVerificationEmail');
            createSubscriptionCheckoutSessionFn = httpsCallable(functions, 'createSubscriptionCheckoutSession');
            confirmSubscriptionCheckoutFn = httpsCallable(functions, 'confirmSubscriptionCheckout');
            lookupZefixCompanyFn = httpsCallable(functions, 'lookupZefixCompany');
        } catch (error) {
            registrationAssistant = null;
            sendInviteEmailFn = null;
            resolveOrgCodeFn = null;
            generateOrgCodeFn = null;
            sendVerificationEmailFn = null;
            createSubscriptionCheckoutSessionFn = null;
            confirmSubscriptionCheckoutFn = null;
            lookupZefixCompanyFn = null;
        }

        const ui = {
            wizardContent: document.getElementById('wizard-content'),
            assistantPrompt: document.getElementById('assistant-prompt'),
            wizardStepCount: document.getElementById('wizard-step-count'),
            wizardStepTitle: document.getElementById('wizard-step-title'),
            wizardStepDots: document.getElementById('wizard-step-dots'),
            onboardingIntro: document.getElementById('onboarding-intro'),
            draftOverlay: document.getElementById('draft-overlay'),
            draftBanner: document.getElementById('draft-banner'),
            draftBannerMeta: document.getElementById('draft-banner-meta'),
            draftRestore: document.getElementById('draft-restore'),
            draftDiscard: document.getElementById('draft-discard'),
            stepLoadingOverlay: document.getElementById('step-loading-overlay'),
            stepLoadingText: document.getElementById('step-loading-text'),
            formStatus: document.getElementById('form-status'),
            chatReset: document.getElementById('chat-reset'),
            catalogTemplate: document.getElementById('catalog-product-template'),
            formCard: document.querySelector('.form-card'),
            sessionWarning: document.getElementById('session-warning'),
            sessionWarningText: document.getElementById('session-warning-text'),
            sessionLogout: document.getElementById('session-logout'),
            registrationPriceSummary: document.getElementById('registration-price-summary'),
            livePreviewPanel: document.getElementById('live-preview-panel'),
            livePreviewContent: document.getElementById('live-preview-content'),
            livePreviewStatus: document.getElementById('live-preview-status'),
            registrationHealthPanel: document.getElementById('registration-health-panel'),
            registrationHealthList: document.getElementById('registration-health-list'),
            registrationHealthStatus: document.getElementById('registration-health-status'),
            registrationHealthTip: document.getElementById('registration-health-tip'),
            livePreviewMobile: document.getElementById('live-preview-mobile'),
            livePreviewContentMobile: document.getElementById('live-preview-content-mobile'),
            livePreviewStatusMobile: document.getElementById('live-preview-status-mobile')
        };

        const COMMISSION_ROLE_DEFAULTS = {
            Mitarbeiter: 0.1,
            VL: 0.12
        };
        const COMMISSION_RULE_DEFAULTS = {
            appointmentRate: 0.02,
            teamRate: 0.02
        };
        const COMMISSION_ELIGIBLE_ROLES = ['Mitarbeiter', 'VL'];

        const DEFAULT_FEATURE_FLAGS = {
            crmCore: true,
            products: true,
            contracts: false,
            activities: true,
            reports: true,
            commissions: false,
            callLog: false,
            leaderboards: false
        };
        const SUBSCRIPTION_DEFAULT_PLAN = 'core';
        const SEAT_RESERVATION_DAYS = 7;
        const SEAT_RESERVATION_MS = SEAT_RESERVATION_DAYS * 24 * 60 * 60 * 1000;
        // Preis pro Nutzer: alle Funktionen im gewählten Paket, keine zubuchbaren Addons.
        const SUBSCRIPTION_PLANS = {
            starter: {
                label: 'Starter',
                price: 49,
                description: 'Der günstige Einstieg — volle Plattform, weniger KI',
                audience: 'Für Solo & kleine Budgets',
                recommended: false,
                features: [
                    'Leads, Pipeline & Bestandskunden',
                    'Offerten, Verträge & Rechnungen',
                    'Termine, Aufgaben & Call-Log',
                    'Buchhaltung, Provisionen & Banking',
                    'Recruiting, Academy & Statistiken',
                    '50 KI-Aktionen / Nutzer · 25 Beleg-Scans'
                ],
                excludes: [],
                modules: { financePlus: true, mobileApp: true, gamification: true }
            },
            core: {
                label: 'Core',
                price: 99,
                description: 'Die volle appnity-Plattform — alle Funktionen enthalten',
                audience: 'Für Teams und KMU',
                recommended: true,
                features: [
                    'Leads, Pipeline & Bestandskunden',
                    'Offerten, Verträge & Rechnungen',
                    'Termine, Aufgaben & Call-Log',
                    'Buchhaltung, Provisionen & Banking',
                    'Recruiting, Academy & Statistiken',
                    '750 KI-Aktionen / Nutzer · KI-Posteingang · 300 Scans'
                ],
                excludes: [],
                modules: { financePlus: true, mobileApp: true, gamification: true }
            },
            pro: {
                label: 'Pro',
                price: 199,
                description: 'Maximale KI — für intensive Nutzung',
                audience: 'Für Vielnutzer & grössere Teams',
                recommended: false,
                features: [
                    'Alles aus Core',
                    'Offerten, Verträge & Rechnungen',
                    'Buchhaltung, Provisionen & Banking',
                    'Recruiting, Academy & Statistiken',
                    'Voller KI-Posteingang (2000 Mails)',
                    '3000 KI-Aktionen / Nutzer · 1500 Scans'
                ],
                excludes: [],
                modules: { financePlus: true, mobileApp: true, gamification: true }
            }
        };
        // Per-User (wie Pipedrive): keine Gratis-Sitze, jeder Sitz = voller Planpreis.
        const SUBSCRIPTION_INCLUDED_SEATS = {
            starter: 1,
            core: 1,
            pro: 1
        };
        const SUBSCRIPTION_EXTRA_SEAT_PRICE = 0;
        const SUBSCRIPTION_ADDON_PER_SEAT = 0;
        const SUBSCRIPTION_ADDON_PER_SEAT_TIER2 = 0;
        // Addon-Katalog leer: nichts zubuchbar, alles im Core enthalten.
        const SUBSCRIPTION_ADDONS = {};
        const SUBSCRIPTION_ANNUAL_DISCOUNT = 0.1;
        const SUBSCRIPTION_BILLING_DEFAULT = 'month';
        const FEATURE_LABELS = {
            crmCore: 'CRM Core',
            products: 'Produkte/Services',
            activities: 'Aktivitäten',
            reports: 'Reports',
            commissions: 'Provisionen',
            callLog: 'Call-Log',
            leaderboards: 'Leaderboards'
        };

        const PIPELINE_TEMPLATES = {
            agency: {
                label: 'Lead -> Abschluss',
                stages: ['Neuer Lead', 'Qualifiziert', 'Erstgespräch gebucht', 'Bedarf analysiert', 'Angebot gesendet', 'Entscheidung offen', 'Gewonnen', 'Verloren']
            },
            retainer: {
                label: 'Retainer Fokus',
                stages: ['Neuer Lead', 'Qualifiziert', 'Bedarf analysiert', 'Retainer-Check', 'Angebot gesendet', 'Offerte in Prüfung', 'Gewonnen', 'Verloren']
            },
            project: {
                label: 'Projektgeschäft',
                stages: ['Neuer Lead', 'Qualifiziert', 'Kickoff geplant', 'Anforderung geklärt', 'Angebot gesendet', 'Verhandlung', 'Gewonnen', 'Verloren']
            },
            upsell: {
                label: 'Bestandskunden / Upsell',
                stages: ['Kunde aktiv', 'Potenzial identifiziert', 'Strategie-Call', 'Angebot gesendet', 'Entscheidung offen', 'Gewonnen', 'Verloren']
            }
        };
        const DEFAULT_PIPELINE_TEMPLATE = 'agency';

        const REGISTRATION_STORAGE_KEY = 'appnity-registration-chat-v1';
        const REGISTRATION_PAYMENT_KEY = 'appnity-registration-payment-v1';
        const DEFAULT_STATE = {
            mode: null,
            stepId: 'mode',
            data: {
                account: { name: '', phone: '', email: '', password: '' },
                company: {
                    name: '',
                    legalForm: '',
                    street: '',
                    zip: '',
                    city: '',
                    country: 'Schweiz',
                    uid: '',
                    billingEmail: '',
                    billingEmailAuto: true,
                    logoUrl: '',
                    website: '',
                    industry: '',
                    timezone: 'Europe/Zurich',
                    currency: 'CHF'
                },
                features: { ...DEFAULT_FEATURE_FLAGS },
                subscriptionPlan: SUBSCRIPTION_DEFAULT_PLAN,
                subscriptionModules: {
                    financePlus: SUBSCRIPTION_PLANS[SUBSCRIPTION_DEFAULT_PLAN]?.modules?.financePlus || false,
                    mobileApp: SUBSCRIPTION_PLANS[SUBSCRIPTION_DEFAULT_PLAN]?.modules?.mobileApp || false,
                    gamification: SUBSCRIPTION_PLANS[SUBSCRIPTION_DEFAULT_PLAN]?.modules?.gamification || false
                },
                subscriptionBillingCycle: SUBSCRIPTION_BILLING_DEFAULT,
                hasTeam: false,
                employeeCount: 1,
                pipeline: {
                    template: DEFAULT_PIPELINE_TEMPLATE,
                    stages: [...PIPELINE_TEMPLATES[DEFAULT_PIPELINE_TEMPLATE].stages]
                },
                salesTypes: [],
                products: [],
                teamInvites: [],
                consents: {
                    terms: false,
                    privacy: false
                },
                join: { code: '', role: 'Mitarbeiter', codeLocked: false, roleLocked: false, fromInviteLink: false }
            }
        };

        let state = JSON.parse(JSON.stringify(DEFAULT_STATE));
        let currentStepId = 'mode';
        let restoredState = false;
        let pendingDraft = null;
        let draftSaveTimer = null;
        let lastDraftFirestoreSave = 0;
        let localSaveTimer = null;
        let verificationViewActive = false;
        let authStateReady = false;
        let sessionUser = null;
        let registrationInProgress = false;
        let pendingSubscriptionReturn = null;
        let processingSubscriptionReturn = false;
        let successRedirectTimer = null;
        let successCountdownTimer = null;
        let pendingLogoFile = null;

        try {
            const params = new URLSearchParams(window.location.search || '');
            const action = params.get('subscription');
            if (action) {
                pendingSubscriptionReturn = {
                    action,
                    sessionId: params.get('session_id') || '',
                    orgId: params.get('org') || ''
                };
            }
        } catch (error) {
            pendingSubscriptionReturn = null;
        }

        const setStatus = (message, isError = true) => {
            if (!ui.formStatus) return;
            ui.formStatus.textContent = message;
            ui.formStatus.classList.toggle('hidden', !message);
            ui.formStatus.classList.toggle('text-red-300', isError);
            ui.formStatus.classList.toggle('text-green-300', !isError);
        };

        const setSessionWarning = (message) => {
            if (!ui.sessionWarning || !ui.sessionWarningText) return;
            ui.sessionWarningText.textContent = message || '';
            ui.sessionWarning.classList.toggle('hidden', !message);
        };

        // → ausgelagert nach register.utils.js (getSessionBlockedMessage)

        const getPaymentState = () => {
            try {
                return JSON.parse(localStorage.getItem(REGISTRATION_PAYMENT_KEY) || '');
            } catch (error) {
                return null;
            }
        };

        const setPaymentState = (payload) => {
            localStorage.setItem(REGISTRATION_PAYMENT_KEY, JSON.stringify(payload));
        };

        const clearPaymentState = () => {
            localStorage.removeItem(REGISTRATION_PAYMENT_KEY);
        };

        const clearSubscriptionParams = () => {
            const url = new URL(window.location.href);
            ['subscription', 'session_id', 'org'].forEach(key => url.searchParams.delete(key));
            window.history.replaceState({}, '', url.toString());
        };

        const getSubmitButton = () => document.querySelector('[data-action="submit"]');

        const syncSubmitAvailability = () => {
            const submitButton = getSubmitButton();
            if (!submitButton) return;
            let disabled = false;
            let title = '';
            const activeUser = sessionUser || auth.currentUser;
            if (registrationInProgress) {
                disabled = true;
                title = 'Registrierung läuft bereits.';
            }
            // Eine aktive Session blockiert das Absenden NICHT mehr — submitRegistration loggt
            // vor der Kontoerstellung automatisch aus (siehe Auto-Logout dort).
            void activeUser;
            if (currentStepId === 'summary') {
                const consents = state.data?.consents || DEFAULT_STATE.data.consents;
                const account = state.data?.account || {};
                if (!account.email || !account.password) {
                    disabled = true;
                    title = 'Bitte Kontoangaben prüfen.';
                }
                if (!consents.terms || !consents.privacy) {
                    disabled = true;
                    title = 'Bitte AGB und Datenschutzerklärung akzeptieren.';
                }
                // (Kein Zahlungs-Gate: Trial-Registrierung erstellt das Konto kostenlos, ohne Checkout-Callable.)
            }
            submitButton.disabled = disabled;
            if (title) {
                submitButton.setAttribute('title', title);
            } else {
                submitButton.removeAttribute('title');
            }
        };

        const setVerificationViewActive = (active) => {
            verificationViewActive = Boolean(active);
            if (verificationViewActive) {
                setSessionWarning('');
            }
            syncSubmitAvailability();
        };

        const escapeHtml = (value) => {
            return (value ?? '').toString()
                .replace(/&/g, '&amp;')
                .replace(/</g, '&lt;')
                .replace(/>/g, '&gt;')
                .replace(/\"/g, '&quot;')
                .replace(/'/g, '&#039;');
        };

        const escapeAttr = (value) => escapeHtml(value);

        // → ausgelagert nach register.utils.js (isValidEmail)

        const setPrompt = (text) => {
            if (!ui.assistantPrompt) return;
            const content = (text || '').toString();
            ui.assistantPrompt.textContent = content;
            ui.assistantPrompt.classList.toggle('hidden', !content.trim());
        };

        const fetchAiMessage = async (payload) => {
            if (!registrationAssistant) return null;
            try {
                const response = await registrationAssistant(payload);
                const message = response?.data?.message?.toString().trim();
                return message || null;
            } catch (error) {
                console.warn('AI message failed', error);
                registrationAssistant = null;
                return null;
            }
        };

        const addAssistantMessage = (fallback, payload) => {
            setPrompt(fallback);
            if (payload && registrationAssistant) {
                fetchAiMessage(payload).then((text) => {
                    if (text) {
                        setPrompt(text);
                    }
                });
            }
        };

        const addUserMessage = (text) => {
            state.lastAnswer = text;
        };

        const clearChat = () => {
            if (ui.wizardContent) {
                ui.wizardContent.innerHTML = '';
            }
            setPrompt('');
            setStatus('');
        };

        ui.sessionLogout?.addEventListener('click', () => {
            signOut(auth).catch((error) => console.warn('Logout fehlgeschlagen:', error));
        });

        onAuthStateChanged(auth, (user) => {
            authStateReady = true;
            sessionUser = user || null;
            if (pendingSubscriptionReturn && user) {
                handleSubscriptionReturn();
                return;
            }
            if (user && !pendingDraft && !restoredState && !registrationInProgress) {
                restoreState();
            }
            if (registrationInProgress) {
                setSessionWarning('');
                syncSubmitAvailability();
                return;
            }
            if (!user || verificationViewActive) {
                setSessionWarning('');
                syncSubmitAvailability();
                if (user && pendingSubscriptionReturn) {
                    handleSubscriptionReturn();
                }
                return;
            }
            const message = getSessionBlockedMessage(user);
            setSessionWarning(message);
            if (!registrationInProgress && (ui.formStatus?.textContent || '').includes('Registrierung läuft')) {
                setStatus(message);
            }
            syncSubmitAvailability();
        });

        const hydrateState = (stored) => {
            if (!stored || typeof stored !== 'object') return false;
            state = { ...state, ...stored };
            state.data = { ...DEFAULT_STATE.data, ...(stored.data || {}) };
            state.data.account = { ...DEFAULT_STATE.data.account, ...(state.data.account || {}) };
            state.data.company = { ...DEFAULT_STATE.data.company, ...(state.data.company || {}) };
            const accountEmail = (state.data.account?.email || '').toLowerCase();
            const billingEmail = (state.data.company?.billingEmail || '').toLowerCase();
            const billingAutoMissing = typeof state.data.company.billingEmailAuto !== 'boolean';
            const billingIsPrefix = accountEmail && billingEmail && accountEmail.startsWith(billingEmail) && accountEmail !== billingEmail;
            if (billingAutoMissing) {
                state.data.company.billingEmailAuto = !billingEmail || billingEmail === accountEmail || billingIsPrefix;
            }
            if (state.data.company.billingEmailAuto && isValidEmail(accountEmail)) {
                state.data.company.billingEmail = state.data.account.email;
            }
            state.data.subscriptionPlan = normalizeSubscriptionPlan(state.data.subscriptionPlan || 'core');
            state.data.subscriptionModules = normalizeSubscriptionModules({
                ...resolvePlanModules(state.data.subscriptionPlan),
                ...(state.data.subscriptionModules || {})
            });
            state.data.subscriptionBillingCycle = state.data.subscriptionBillingCycle || SUBSCRIPTION_BILLING_DEFAULT;
            state.data.employeeCount = normalizeEmployeeCount(state.data.employeeCount, state.data.subscriptionPlan);
            state.data.features = buildSubscriptionFeatures(state.data.subscriptionModules);
            state.data.hasTeam = state.data.employeeCount > 1;
            state.data.pipeline = { ...DEFAULT_STATE.data.pipeline, ...(state.data.pipeline || {}) };
            if (!PIPELINE_TEMPLATES[state.data.pipeline?.template]) {
                state.data.pipeline.template = DEFAULT_PIPELINE_TEMPLATE;
                state.data.pipeline.stages = [...PIPELINE_TEMPLATES[DEFAULT_PIPELINE_TEMPLATE].stages];
            }
            if (!Array.isArray(state.data.pipeline?.stages) || state.data.pipeline.stages.length === 0) {
                state.data.pipeline.stages = [...PIPELINE_TEMPLATES[state.data.pipeline.template].stages];
            }
            state.data.teamInvites = Array.isArray(state.data.teamInvites) ? state.data.teamInvites : [];
            state.data.consents = { ...DEFAULT_STATE.data.consents, ...(state.data.consents || {}) };
            state.data.join = { ...DEFAULT_STATE.data.join, ...(state.data.join || {}) };
            restoredState = true;
            return true;
        };

        const loadLocalDraft = () => {
            try {
                const stored = JSON.parse(localStorage.getItem(REGISTRATION_STORAGE_KEY) || '');
                if (!stored || typeof stored !== 'object') return null;
                return {
                    source: 'local',
                    data: stored,
                    updatedAt: stored.draftUpdatedAt || null
                };
            } catch (error) {
                return null;
            }
        };

        const buildDraftSnapshot = () => {
            const snapshot = JSON.parse(JSON.stringify(state));
            if (snapshot?.data?.account) {
                snapshot.data.account.password = '';
            }
            return snapshot;
        };

        const saveDraftToFirestore = async () => {
            const user = auth.currentUser;
            if (!user) return;
            const now = Date.now();
            if (now - lastDraftFirestoreSave < 4000) return;
            lastDraftFirestoreSave = now;
            try {
                const snapshot = buildDraftSnapshot();
                await setDoc(doc(db, 'registration_drafts', user.uid), {
                    state: snapshot,
                    updatedAt: serverTimestamp(),
                    source: 'web'
                }, { merge: true });
            } catch (error) {
                console.warn('Draft save failed:', error);
            }
        };

        const queueDraftSave = () => {
            if (!auth.currentUser) return;
            if (draftSaveTimer) clearTimeout(draftSaveTimer);
            draftSaveTimer = setTimeout(() => {
                saveDraftToFirestore();
            }, 800);
        };

        const saveState = () => {
            state.draftUpdatedAt = Date.now();
            const snapshot = buildDraftSnapshot();
            snapshot.draftUpdatedAt = state.draftUpdatedAt;
            localStorage.setItem(REGISTRATION_STORAGE_KEY, JSON.stringify(snapshot));
            queueDraftSave();
            syncSubmitAvailability();
        };

        const queueLocalSave = () => {
            if (localSaveTimer) clearTimeout(localSaveTimer);
            localSaveTimer = setTimeout(() => {
                saveState();
            }, 400);
        };

        const setDraftOverlayVisible = (isVisible) => {
            if (ui.draftOverlay) ui.draftOverlay.classList.toggle('hidden', !isVisible);
            if (ui.draftBanner) ui.draftBanner.classList.toggle('hidden', !isVisible);
        };

        const clearDraftStorage = async () => {
            localStorage.removeItem(REGISTRATION_STORAGE_KEY);
            pendingDraft = null;
            setDraftOverlayVisible(false);
            if (auth.currentUser) {
                try {
                    await deleteDoc(doc(db, 'registration_drafts', auth.currentUser.uid));
                } catch (error) {
                    console.warn('Draft delete failed:', error);
                }
            }
        };

        // → ausgelagert nach register.utils.js (resolveDraftTimestamp)

        // → ausgelagert nach register.utils.js (formatDraftTimestamp)

        const loadRemoteDraft = async (user) => {
            if (!user) return null;
            try {
                const snap = await getDoc(doc(db, 'registration_drafts', user.uid));
                if (!snap.exists()) return null;
                const data = snap.data() || {};
                if (!data.state) return null;
                return {
                    source: 'cloud',
                    data: data.state,
                    updatedAt: resolveDraftTimestamp(data.updatedAt)
                };
            } catch (error) {
                console.warn('Remote draft load failed:', error);
                return null;
            }
        };

        // → ausgelagert nach register.utils.js (pickLatestDraft)

        const showDraftBanner = (draft) => {
            if (!draft || !ui.draftBanner) return;
            pendingDraft = draft;
            const timestampLabel = formatDraftTimestamp(draft.updatedAt);
            const sourceLabel = draft.source === 'cloud' ? 'Cloud-Entwurf' : 'Lokaler Entwurf';
            if (ui.draftBannerMeta) {
                const securityNote = 'Passwort wird nicht gespeichert.';
                ui.draftBannerMeta.textContent = timestampLabel
                    ? `${sourceLabel} · gespeichert am ${timestampLabel} · ${securityNote}`
                    : `${sourceLabel} gefunden. ${securityNote}`;
            }
            setDraftOverlayVisible(true);
        };

        const shouldSkipDraftRestore = () => {
            const params = new URLSearchParams(window.location.search || '');
            const modeParam = params.get('mode');
            const codeParam = params.get('code') || params.get('org') || params.get('orgCode');
            const roleParam = params.get('role');
            return modeParam === 'join' || Boolean(codeParam || roleParam);
        };

        const restoreState = async () => {
            if (shouldSkipDraftRestore()) {
                setDraftOverlayVisible(false);
                pendingDraft = null;
                return;
            }
            const localDraft = loadLocalDraft();
            const remoteDraft = await loadRemoteDraft(auth.currentUser);
            const selected = pickLatestDraft(localDraft, remoteDraft);
            if (selected) {
                showDraftBanner(selected);
            } else {
                setDraftOverlayVisible(false);
            }
        };

        const resetState = () => {
            state = JSON.parse(JSON.stringify(DEFAULT_STATE));
            restoredState = false;
            clearDraftStorage();
        };

        // → ausgelagert nach register.utils.js (normalizeRate)

        // → ausgelagert nach register.utils.js (normalizeMoney)

        // → ausgelagert nach register.utils.js (normalizeWebsite)

        // → ausgelagert nach register.utils.js (formatCurrency)

        // → ausgelagert nach register.utils.js (getDuplicateEmails)

        // → ausgelagert nach register.utils.js (getSelfInviteEmails)

        // → ausgelagert nach register.utils.js (evaluatePasswordStrength)

        const normalizeSubscriptionPlan = (plan) => {
            const normalized = (plan || '').toString().trim().toLowerCase();
            return SUBSCRIPTION_PLANS[normalized] ? normalized : SUBSCRIPTION_DEFAULT_PLAN;
        };

        // → ausgelagert nach register.utils.js (normalizeBillingCycle)

        const resolvePlanModules = (planKey) => {
            const plan = SUBSCRIPTION_PLANS[planKey] || SUBSCRIPTION_PLANS[SUBSCRIPTION_DEFAULT_PLAN];
            const modules = plan?.modules || {};
            return {
                financePlus: Boolean(modules.financePlus),
                mobileApp: Boolean(modules.mobileApp),
                gamification: Boolean(modules.gamification)
            };
        };

        // → ausgelagert nach register.utils.js (normalizeSubscriptionModules)

        // → ausgelagert nach register.utils.js (normalizeEmployeeCount)

        const buildSubscriptionFeatures = (modules) => {
            const base = { ...DEFAULT_FEATURE_FLAGS };
            base.contracts = false;
            base.commissions = false;
            base.callLog = false;
            base.leaderboards = Boolean(modules?.gamification);
            return base;
        };

        const getSubscriptionPlanInfo = (planKey) => {
            return SUBSCRIPTION_PLANS[planKey] || SUBSCRIPTION_PLANS[SUBSCRIPTION_DEFAULT_PLAN];
        };

        // → ausgelagert nach register.utils.js (getEnabledAddonCount)

        const getSubscriptionAddonBaseTotal = (modules) => {
            const data = normalizeSubscriptionModules(modules);
            return Object.entries(data).reduce((sum, [key, enabled]) => {
                if (!enabled) return sum;
                return sum + (SUBSCRIPTION_ADDONS[key]?.price || 0);
            }, 0);
        };

        // → ausgelagert nach register.utils.js (getAddonSeatBreakdown)

        const getAddonSeatFeeTotal = (seatCount) => {
            const breakdown = getAddonSeatBreakdown(seatCount);
            return (breakdown.tier1Seats * SUBSCRIPTION_ADDON_PER_SEAT)
                + (breakdown.tier2Seats * SUBSCRIPTION_ADDON_PER_SEAT_TIER2);
        };

        const getSubscriptionAddonTotal = (modules, employeeCount) => {
            const seatCount = Math.max(1, parseInt(employeeCount ?? '', 10) || 1);
            const enabledCount = getEnabledAddonCount(modules);
            const baseTotal = getSubscriptionAddonBaseTotal(modules);
            if (!enabledCount) return baseTotal;
            const seatFeeTotal = getAddonSeatFeeTotal(seatCount) * enabledCount;
            return baseTotal + seatFeeTotal;
        };

        const getExtraSeatCount = (employeeCount, planKey) => {
            const included = SUBSCRIPTION_INCLUDED_SEATS[planKey] || 1;
            return Math.max(0, employeeCount - included);
        };

        // → ausgelagert nach register.utils.js (deriveSalesTypesFromProducts)

        const buildAiContext = () => {
            const account = state.data.account || {};
            const company = state.data.company || {};
            const join = state.data.join || {};
            return {
                mode: state.mode,
                account: {
                    name: account.name || '',
                    email: account.email || '',
                    phone: account.phone || ''
                },
                company: {
                    name: company.name || '',
                    legalForm: company.legalForm || '',
                    industry: company.industry || '',
                    country: company.country || '',
                    timezone: company.timezone || '',
                    currency: company.currency || '',
                    billingEmail: company.billingEmail || '',
                    website: company.website || ''
                },
                subscriptionPlan: state.data.subscriptionPlan || SUBSCRIPTION_DEFAULT_PLAN,
                subscriptionModules: state.data.subscriptionModules || {},
                employeeCount: state.data.employeeCount ?? 1,
                features: state.data.features || {},
                hasTeam: Boolean(state.data.hasTeam),
                pipeline: {
                    template: state.data.pipeline?.template || '',
                    stages: Array.isArray(state.data.pipeline?.stages) ? state.data.pipeline.stages : []
                },
                salesTypes: state.data.salesTypes || [],
                productCount: Array.isArray(state.data.products) ? state.data.products.length : 0,
                teamInvites: Array.isArray(state.data.teamInvites) ? state.data.teamInvites.length : 0,
                join: {
                    role: join.role || '',
                    codeProvided: Boolean(join.code)
                }
            };
        };

        const buildSubscriptionReturnUrls = (orgId) => {
            const baseUrl = getClientBaseUrl();
            if (!baseUrl) return { successUrl: '', cancelUrl: '' };
            const successUrl = `${baseUrl}/register.html?subscription=success&session_id={CHECKOUT_SESSION_ID}&org=${encodeURIComponent(orgId)}`;
            const cancelUrl = `${baseUrl}/register.html?subscription=cancel&org=${encodeURIComponent(orgId)}`;
            return { successUrl, cancelUrl };
        };

        const getCurrentStepGuidance = () => {
            const tips = {
                mode: 'Lege hier fest, ob du einen neuen Workspace startest oder per Firmencode in ein bestehendes CRM gehst.',
                account: 'Nutze die echte Owner- oder Mitarbeiter-E-Mail. Darüber laufen Login, Verifikation und Systemkommunikation.',
                company: 'Saubere Billing-Daten sparen Rückfragen bei Stripe, Rechnungen und Invite-Kommunikation.',
                features: 'Plane Seats realistisch. Jeder bezahlte Sitz sollte später einer echten Person zugeordnet werden.',
                pipeline: 'Halte die Pipeline schlank. Zu viele Stufen verlangsamen später das Sales-Team.',
                products: 'Lege mindestens ein Kernprodukt an, damit Offerten und Provisionen sofort sauber starten.',
                team: 'Vermeide doppelte oder eigene E-Mails. Das spart Invite-Chaos und falsche Seat-Reservierungen.',
                join: 'Mit Invite-Link ist der Prozess schneller. Ohne Invite landet dein Zugang regulär beim Admin zur Freigabe.',
                summary: 'Vor dem Abschluss kurz auf Seats, Einladungen und Rechtliches schauen. Danach geht es direkt in Stripe.'
            };
            return tips[currentStepId] || 'Registrierung wird vorbereitet.';
        };

        const buildRegistrationHealthModel = () => {
            const account = state.data.account || {};
            const company = state.data.company || {};
            const consents = state.data.consents || DEFAULT_STATE.data.consents;
            const join = state.data.join || {};
            const planKey = normalizeSubscriptionPlan(state.data.subscriptionPlan);
            const employeeCount = normalizeEmployeeCount(state.data.employeeCount, planKey);
            const invites = Array.isArray(state.data.teamInvites) ? state.data.teamInvites : [];
            const paidRoles = ['Admin', 'VL', 'Mitarbeiter', 'Accounting', 'Partner'];
            const paidInvites = invites.filter(invite => paidRoles.includes(invite.role));
            const duplicateEmails = getDuplicateEmails(invites);
            const selfInvites = getSelfInviteEmails(invites, account.email);
            const products = Array.isArray(state.data.products) ? state.data.products : [];
            const pipelineStages = Array.isArray(state.data.pipeline?.stages) ? state.data.pipeline.stages : [];

            const accountReady = Boolean(account.name && isValidEmail(account.email) && (account.password || '').length >= 8);
            const legalReady = Boolean(consents.terms && consents.privacy);
            const companyReady = Boolean(company.name && isValidEmail(company.billingEmail || account.email));
            const subscriptionReady = Boolean(planKey && employeeCount >= 1);
            const teamReady = duplicateEmails.length === 0
                && selfInvites.length === 0
                && paidInvites.length >= Math.max(0, employeeCount - 1);
            const crmReady = pipelineStages.length >= 3 && products.length > 0;
            const brandingReady = Boolean(company.website || company.logoUrl || pendingLogoFile);
            const joinCodeReady = Boolean((join.code || '').trim());
            const joinRoleReady = Boolean((join.role || '').trim());

            const items = state.mode === 'join'
                ? [
                    {
                        label: 'Konto',
                        detail: accountReady ? `${account.name || account.email} ist bereit.` : 'Name, E-Mail oder Passwort fehlen noch.',
                        complete: accountReady,
                        blocking: true
                    },
                    {
                        label: 'Firmencode',
                        detail: joinCodeReady ? `Code ${join.code} wird verwendet.` : 'Firmencode fehlt noch.',
                        complete: joinCodeReady,
                        blocking: true
                    },
                    {
                        label: 'Rolle & Freigabe',
                        detail: joinRoleReady
                            ? (join.fromInviteLink
                                ? `Einladung erkannt. Rolle ${join.role} wurde aus dem Link übernommen.`
                                : `Rolle ${join.role} wird beim Admin eingereicht.`)
                            : 'Gewünschte Rolle fehlt noch.',
                        complete: joinRoleReady,
                        blocking: true
                    },
                    {
                        label: 'Rechtliches',
                        detail: legalReady ? 'AGB und Datenschutz sind bestätigt.' : 'AGB und Datenschutz müssen vor dem Abschluss bestätigt werden.',
                        complete: legalReady,
                        blocking: true
                    }
                ]
                : [
                    {
                        label: 'Konto',
                        detail: accountReady ? `${account.name || account.email} ist startklar.` : 'Name, E-Mail oder Passwort fehlen noch.',
                        complete: accountReady,
                        blocking: true
                    },
                    {
                        label: 'Firma & Billing',
                        detail: companyReady ? `${company.name || 'Firma'} und Billing-E-Mail sind gepflegt.` : 'Firmenname oder Billing-E-Mail fehlen noch.',
                        complete: companyReady,
                        blocking: true
                    },
                    {
                        label: 'Abo & Seats',
                        detail: subscriptionReady ? `${employeeCount} Person${employeeCount === 1 ? '' : 'en'} geplant.` : 'Abo oder Seat-Planung ist noch offen.',
                        complete: subscriptionReady,
                        blocking: true
                    },
                    {
                        label: 'Team-Einladungen',
                        detail: duplicateEmails.length
                            ? `Doppelte Einladungen erkannt: ${duplicateEmails.join(', ')}.`
                            : selfInvites.length
                                ? 'Deine eigene E-Mail ist als Invite erfasst. Das sollte entfernt werden.'
                                : employeeCount > 1
                                    ? (teamReady ? `${paidInvites.length} Team-Zugänge vorbereitet.` : `Für ${employeeCount - 1} weitere Seats fehlen noch Einladungen.`)
                                    : 'Solo-Setup. Keine weiteren Einladungen nötig.',
                        complete: teamReady,
                        blocking: true
                    },
                    {
                        label: 'CRM-Setup',
                        detail: crmReady
                            ? `${products.length} Produkt${products.length === 1 ? '' : 'e'} und ${pipelineStages.length} Pipeline-Stufen vorhanden.`
                            : `Pipeline (${pipelineStages.length}) oder Produktkatalog (${products.length}) noch dünn.`,
                        complete: crmReady,
                        blocking: false
                    },
                    {
                        label: 'Branding & Website',
                        detail: brandingReady ? 'Website oder Branding ist bereits hinterlegt.' : 'Optional, aber sinnvoll für Rechnungen, Vertrauen und saubere Dokumente.',
                        complete: brandingReady,
                        blocking: false
                    },
                    {
                        label: 'Rechtliches',
                        detail: legalReady ? 'AGB und Datenschutz sind bestätigt.' : 'AGB und Datenschutz müssen vor dem Abschluss bestätigt werden.',
                        complete: legalReady,
                        blocking: true
                    }
                ];

            const blockingItems = items.filter(item => item.blocking);
            const openBlocking = blockingItems.filter(item => !item.complete);
            const openRecommendations = items.filter(item => !item.blocking && !item.complete);
            const status = openBlocking.length
                ? { label: 'Draft', className: 'is-draft' }
                : openRecommendations.length
                    ? { label: 'Fast bereit', className: 'is-warning' }
                    : { label: 'Startklar', className: 'is-ready' };

            return { items, openBlocking, openRecommendations, status };
        };

        const renderRegistrationHealth = () => {
            const model = buildRegistrationHealthModel();
            const applyStatus = (element) => {
                if (!element) return;
                element.textContent = model.status.label;
                element.className = `live-preview-badge ${model.status.className}`;
            };
            applyStatus(ui.registrationHealthStatus);
            if (ui.registrationHealthList) {
                ui.registrationHealthList.innerHTML = model.items.map(item => {
                    const variant = item.complete ? 'is-complete' : (item.blocking ? 'is-warning' : 'is-neutral');
                    return `
                        <div class="health-item ${variant}">
                            <span class="health-dot" aria-hidden="true"></span>
                            <div>
                                <div class="health-title">${escapeHtml(item.label)}</div>
                                <div class="health-meta">${escapeHtml(item.detail)}</div>
                            </div>
                        </div>
                    `;
                }).join('');
            }
            if (ui.registrationHealthTip) {
                ui.registrationHealthTip.textContent = getCurrentStepGuidance();
            }
        };

        const uploadOrgLogo = async (orgId, file) => {
            if (!file) return null;
            const safeName = file.name.replace(/[^a-zA-Z0-9._-]/g, '_');
            const storageRef = ref(storage, `orgs/${orgId}/branding/${Date.now()}-${safeName}`);
            await uploadBytes(storageRef, file, { contentType: file.type || 'image/png' });
            const url = await getDownloadURL(storageRef);
            return { url, path: storageRef.fullPath };
        };

        const getCommissionEligibleTeamRoles = () => {
            const invites = Array.isArray(state.data.teamInvites) ? state.data.teamInvites : [];
            return new Set(
                invites
                    .map(invite => invite?.role)
                    .filter(role => COMMISSION_ELIGIBLE_ROLES.includes(role))
            );
        };

        const hasCommissionEligibleTeamMembers = () => {
            return getCommissionEligibleTeamRoles().size > 0;
        };

        const shouldAskCommissions = () => {
            return Boolean(state.data.features?.commissions) || hasCommissionEligibleTeamMembers();
        };

        const getStepSequence = () => {
            if (!state.mode) return ['mode'];
            if (state.mode === 'join') {
                return ['mode', 'account', 'join', 'summary'];
            }
            return ['mode', 'account', 'company', 'pipeline', 'team', 'products', 'features', 'summary'];
        };

        const resolveInitialStep = () => {
            const steps = getStepSequence();
            if (!steps.includes(state.stepId)) {
                state.stepId = steps[0];
            }
            return state.stepId;
        };

        const goToStep = (stepId) => {
            currentStepId = stepId;
            state.stepId = stepId;
            saveState();
            try { window.__track && window.__track('reg_step', { step: stepId }); } catch (e) {}
            runStep(stepId);
            setStepLoading(false);
        };

        const goToNextStep = () => {
            const steps = getStepSequence();
            const idx = steps.indexOf(currentStepId);
            const next = steps[Math.min(idx + 1, steps.length - 1)];
            goToStep(next);
        };

        const goToPrevStep = () => {
            const steps = getStepSequence();
            const idx = steps.indexOf(currentStepId);
            if (idx <= 0) return;
            const prev = steps[Math.max(idx - 1, 0)];
            goToStep(prev);
        };

        const addCard = (card) => {
            if (!ui.wizardContent) return;
            ui.wizardContent.innerHTML = '';
            ui.wizardContent.appendChild(card);
            if (ui.registrationPriceSummary) {
                ui.registrationPriceSummary.innerHTML = '';
                ui.registrationPriceSummary.hidden = true;
            }
        };

        const setStepLoading = (isVisible, message = 'Bitte warten...') => {
            if (!ui.stepLoadingOverlay) return;
            ui.stepLoadingOverlay.classList.toggle('hidden', !isVisible);
            if (ui.stepLoadingText) {
                ui.stepLoadingText.textContent = message;
            }
        };

        const setPriceSummaryAside = (card) => {
            if (!ui.registrationPriceSummary) return;
            ui.registrationPriceSummary.innerHTML = '';
            if (!card) {
                ui.registrationPriceSummary.hidden = true;
                return;
            }
            ui.registrationPriceSummary.appendChild(card);
            ui.registrationPriceSummary.hidden = false;
        };

        const disableForm = (form) => {
            form.querySelectorAll('input, select, textarea, button').forEach(el => {
                el.disabled = true;
            });
        };

        function setupInlineValidation(form) {
            if (!form) return;
            const fields = Array.from(form.querySelectorAll('input, select, textarea'));
            fields.forEach(field => {
                if (!field.willValidate) return;
                const shouldWatch = field.required || field.type === 'email';
                if (!shouldWatch) return;
                let container = field.closest('div');
                if (!container) return;
                // Icon-Felder umschließen das Input mit einem position:relative-Wrapper, in dem
                // das Icon absolut (top:0;bottom:0) vertikal zentriert liegt. Ein zusätzliches
                // Fehler-<p> IN diesem Wrapper würde ihn strecken und das Icon nach unten schieben
                // → deshalb eine Ebene höher (in die Feldgruppe) hängen.
                const containerStyle = container.getAttribute('style') || '';
                if (/position\s*:\s*relative/.test(containerStyle) && container.parentElement) {
                    container = container.parentElement;
                }
                let errorEl = container.querySelector(':scope > .field-error');
                if (!errorEl) {
                    errorEl = document.createElement('p');
                    errorEl.className = 'field-error';
                    container.appendChild(errorEl);
                }
                const validate = () => {
                    if (!field.willValidate) return;
                    if (!field.required && !field.value) {
                        field.classList.remove('input-invalid');
                        if (errorEl) errorEl.textContent = '';
                        return;
                    }
                    if (field.checkValidity()) {
                        field.classList.remove('input-invalid');
                        if (errorEl) errorEl.textContent = '';
                    } else {
                        field.classList.add('input-invalid');
                        if (errorEl) errorEl.textContent = field.validationMessage;
                    }
                };
                field.addEventListener('input', validate);
                field.addEventListener('blur', validate);
            });
        }

        const createFormCard = (title, bodyHtml, onSubmit, options = {}) => {
            const card = document.createElement('div');
            card.className = `chat-card${options.className ? ` ${options.className}` : ''}`;
            const showBack = getStepSequence().indexOf(currentStepId) > 0;
            const allowSkip = Boolean(options.allowSkip);
            const skipLabel = options.skipLabel || 'Überspringen';
            // Schnellstart: optionale Restschritte überspringen und direkt zur Übersicht
            // (Pipeline/Team/Produkte/Plan haben gültige Defaults im State → Konto sofort erstellbar).
            const quickFinish = Boolean(options.quickFinish);
            const quickFinishLabel = options.quickFinishLabel || '⚡ Direkt zur Übersicht';
            card.innerHTML = `
                <form class="chat-form" novalidate>
                    <div class="space-y-2">
                        <h4>${escapeHtml(title)}</h4>
                    </div>
                    <div class="wizard-form-body">
                        ${bodyHtml}
                    </div>
                    <div class="chat-actions">
                        ${showBack ? '<button type="button" data-action="back" class="btn-secondary px-5 py-2 rounded-lg font-semibold">Zurück</button>' : ''}
                        ${allowSkip ? `<button type="button" data-action="skip" class="btn-secondary px-5 py-2 rounded-lg font-semibold">${skipLabel}</button>` : ''}
                        <button type="submit" class="btn-primary px-5 py-2 rounded-lg font-semibold">Weiter</button>
                    </div>
                    ${quickFinish ? `<div style="text-align:center;margin-top:.5rem;"><button type="button" data-action="quickfinish" style="background:none;border:none;color:#00C8BE;font-size:.78rem;font-weight:600;cursor:pointer;text-decoration:underline;">${quickFinishLabel}</button></div>` : ''}
                </form>
            `;
            const form = card.querySelector('form');
            setupInlineValidation(form);
            form.addEventListener('submit', async (event) => {
                event.preventDefault();
                if (!form.checkValidity()) {
                    form.reportValidity();
                    return;
                }
                const startStep = currentStepId;
                setStepLoading(true, 'Weiter...');
                try {
                    const result = onSubmit(form);
                    if (result && typeof result.then === 'function') {
                        await result;
                    }
                } finally {
                    if (currentStepId === startStep) {
                        setStepLoading(false);
                    }
                }
            });
            const backButton = card.querySelector('[data-action="back"]');
            if (backButton) {
                backButton.addEventListener('click', () => {
                    goToPrevStep();
                });
            }
            const skipButton = card.querySelector('[data-action="skip"]');
            if (skipButton) {
                skipButton.addEventListener('click', () => {
                    if (typeof options.onSkip === 'function') {
                        options.onSkip(form);
                    }
                    goToNextStep();
                });
            }
            const quickFinishButton = card.querySelector('[data-action="quickfinish"]');
            if (quickFinishButton) {
                quickFinishButton.addEventListener('click', () => {
                    try { window.__track && window.__track('reg_quickfinish', { from: currentStepId }); } catch (e) {}
                    // Defaults sind bereits im State (DEFAULT_STATE) → direkt zur Zusammenfassung.
                    goToStep('summary');
                });
            }
            return card;
        };

        const updateCatalogEmpty = (container, emptyEl) => {
            if (!container || !emptyEl) return;
            const hasRows = container.querySelectorAll('[data-product-row]').length > 0;
            emptyEl.classList.toggle('hidden', hasRows);
        };

        const getPartnerInvites = () => {
            return (state.data.teamInvites || [])
                .filter(invite => (invite.role || '').toLowerCase() === 'partner' && invite.email)
                .map(invite => ({
                    name: invite.name || invite.email,
                    email: invite.email
                }));
        };

        const buildPartnerOptions = (selectedEmail = '', selectedName = '') => {
            const partnerInvites = getPartnerInvites();
            const existingOption = selectedEmail && !partnerInvites.some(invite => invite.email === selectedEmail)
                ? `<option value="${escapeAttr(selectedEmail)}" data-partner-name="${escapeAttr(selectedName || selectedEmail)}" data-partner-email="${escapeAttr(selectedEmail)}">${escapeHtml(selectedName || selectedEmail)}</option>`
                : '';
            const inviteOptions = partnerInvites.map(invite => (
                `<option value="${escapeAttr(invite.email)}" data-partner-name="${escapeAttr(invite.name)}" data-partner-email="${escapeAttr(invite.email)}">${escapeHtml(invite.name)}</option>`
            )).join('');
            return `<option value="">Kein Partner</option>${existingOption}${inviteOptions}`;
        };

        const fillPartnerSelect = (select, selectedEmail = '', selectedName = '') => {
            if (!select) return;
            select.innerHTML = buildPartnerOptions(selectedEmail, selectedName);
            if (selectedEmail) select.value = selectedEmail;
            select.dataset.partnerName = selectedName || selectedEmail || '';
        };

        const refreshPartnerSelects = (container) => {
            if (!container) return;
            container.querySelectorAll('[data-field="partnerEmail"]').forEach(select => {
                const currentOption = select.selectedOptions?.[0];
                const currentEmail = select.value || '';
                const currentName = currentOption?.dataset.partnerName
                    || select.dataset.partnerName
                    || currentOption?.textContent
                    || '';
                fillPartnerSelect(select, currentEmail, currentName);
            });
        };

        const addPartnerInvite = (name, email) => {
            const trimmedEmail = (email || '').trim().toLowerCase();
            if (!trimmedEmail) return '';
            const trimmedName = (name || '').trim();
            state.data.teamInvites = normalizeInviteList([
                ...(state.data.teamInvites || []),
                { name: trimmedName, email: trimmedEmail, role: 'Partner' }
            ]);
            queueLocalSave();
            updateLivePreview();
            return trimmedEmail;
        };

        const getBillingMonthlyFactor = (billing) => {
            const key = (billing || '').toString().toLowerCase();
            if (key === 'monthly') return 1;
            if (key === 'quarterly') return 1 / 3;
            if (key === 'half_yearly') return 1 / 6;
            if (key === 'yearly') return 1 / 12;
            return 0;
        };

        const isRetainerBilling = (billing) => getBillingMonthlyFactor(billing) > 0;

        const buildCatalogDeductionRow = (deduction = {}) => {
            const label = escapeAttr(deduction.label || '');
            const amountRaw = deduction.amount ?? '';
            const parsedAmount = typeof amountRaw === 'number'
                ? amountRaw
                : parseFloat(amountRaw.toString().replace(',', '.'));
            const amount = Number.isFinite(parsedAmount)
                ? parsedAmount.toFixed(2).replace(/\.00$/, '')
                : '';
            return `
                <div class="flex flex-wrap gap-2 items-center" data-deduction-row>
                    <input type="text" data-deduction-label class="input flex-1 min-w-[160px] rounded-lg px-3 py-2 text-sm" placeholder="Bezeichnung" value="${label}">
                    <input type="number" min="0" step="0.01" data-deduction-amount class="input w-32 rounded-lg px-3 py-2 text-sm text-right" placeholder="0.00" value="${amount}">
                    <button type="button" class="text-xs text-red-300 hover:text-red-200" data-action="remove-deduction">Entfernen</button>
                </div>
            `;
        };

        const renderCatalogDeductions = (list, deductions = []) => {
            if (!list) return;
            const rows = Array.isArray(deductions) ? deductions : [];
            list.innerHTML = rows.map(buildCatalogDeductionRow).join('');
        };

        const appendCatalogDeductionRow = (list, deduction = {}) => {
            if (!list) return;
            list.insertAdjacentHTML('beforeend', buildCatalogDeductionRow(deduction));
        };

        const addCatalogProductRow = (container, emptyEl, data = {}, showCommissions = true) => {
            if (!container || !ui.catalogTemplate) return null;
            const row = ui.catalogTemplate.content.firstElementChild.cloneNode(true);
            const setValue = (selector, value) => {
                const el = row.querySelector(selector);
                if (el && value !== undefined && value !== null) {
                    el.value = value;
                }
            };
            const setChecked = (selector, value) => {
                const el = row.querySelector(selector);
                if (el) {
                    el.checked = Boolean(value);
                }
            };

            const allowedTypes = new Set(['service', 'product', 'insurance']);
            const resolvedType = allowedTypes.has(data.type) ? data.type : 'service';
            const allowedBilling = new Set(['one_time', 'monthly', 'quarterly', 'half_yearly', 'yearly']);
            const resolvedBilling = allowedBilling.has(data.billing) ? data.billing : 'one_time';
            const payoutDefault = isRetainerBilling(resolvedBilling) ? 'monthly' : 'one_time';
            const currencyFallback = state?.data?.company?.currency || 'CHF';
            const commissionBaseValue = data.commissionBase === 'profit' ? 'profit' : 'revenue';
            const vatRaw = data.vatRate ?? '';
            const vatValue = Number.isFinite(vatRaw) ? vatRaw.toFixed(3) : vatRaw.toString().trim();
            const vatResolved = ['0.081', '0.026', '0.038'].includes(vatValue) ? vatValue : '0.081';
            setValue('[data-field="name"]', data.name || '');
            setValue('[data-field="type"]', resolvedType);
            setValue('[data-field="billing"]', resolvedBilling);
            setValue('[data-field="price"]', data.price ?? '');
            setValue('[data-field="currency"]', data.currency || currencyFallback);
            setValue('[data-field="vatRate"]', vatResolved);
            setValue('[data-field="defaultQty"]', data.defaultQty ?? 1);
            setValue('[data-field="description"]', data.description || '');
            const retainerMonthsRaw = parseInt(data.retainerMonths ?? '', 10);
            setValue('[data-field="retainerMonths"]', Number.isFinite(retainerMonthsRaw) ? retainerMonthsRaw : '');
            setChecked('[data-field="isActive"]', data.isActive !== false);
            setChecked('[data-field="allowQuantity"]', data.allowQuantity !== false);

            const commissionBaseName = `commission-base-${Date.now()}-${Math.floor(Math.random() * 100000)}`;
            row.querySelectorAll('[data-field="commissionBase"]').forEach(input => {
                input.name = commissionBaseName;
                if (input.value === commissionBaseValue) {
                    input.checked = true;
                }
            });

            const deductionsBlock = row.querySelector('[data-deductions-block]');
            const deductionsList = row.querySelector('[data-deductions-list]');
            renderCatalogDeductions(deductionsList, data.commissionDeductions || []);
            const toggleDeductions = () => {
                const base = row.querySelector('[data-field="commissionBase"]:checked')?.value || 'revenue';
                const isProfit = base === 'profit';
                if (deductionsBlock) deductionsBlock.classList.toggle('hidden', !isProfit);
                if (isProfit && deductionsList && !deductionsList.querySelector('[data-deduction-row]')) {
                    appendCatalogDeductionRow(deductionsList);
                }
            };
            row.querySelectorAll('[data-field="commissionBase"]').forEach(input => {
                input.addEventListener('change', toggleDeductions);
            });

            const addDeductionBtn = row.querySelector('[data-action="add-deduction"]');
            if (addDeductionBtn) {
                addDeductionBtn.addEventListener('click', () => {
                    appendCatalogDeductionRow(deductionsList);
                    toggleDeductions();
                });
            }
            if (deductionsList) {
                deductionsList.addEventListener('click', (event) => {
                    const removeBtn = event.target.closest('[data-action="remove-deduction"]');
                    if (!removeBtn) return;
                    removeBtn.closest('[data-deduction-row]')?.remove();
                });
            }

            const visibleCommissionRoles = getCommissionEligibleTeamRoles();
            const roleRates = data.roleRates || data.commissionRatesByRole || {};
            row.querySelectorAll('[data-role-commission]').forEach(input => {
                const role = input.dataset.roleCommission;
                if (!role) return;
                const roleBlock = input.closest('[data-role-commission-block]');
                const roleVisible = showCommissions && visibleCommissionRoles.has(role);
                if (roleBlock) {
                    roleBlock.classList.toggle('hidden', !roleVisible);
                }
                if (roleVisible && roleRates[role] !== undefined && roleRates[role] !== null) {
                    input.value = roleRates[role];
                }
                if (!roleVisible) {
                    input.value = '';
                }
                input.disabled = !roleVisible;
            });

            const partnerSelect = row.querySelector('[data-field="partnerEmail"]');
            if (partnerSelect) {
                const selectedPartnerEmail = data.partnerEmail || '';
                const selectedPartnerName = data.partnerName || '';
                fillPartnerSelect(partnerSelect, selectedPartnerEmail, selectedPartnerName);
            }
            const partnerInline = row.querySelector('[data-partner-inline]');
            const partnerToggleBtn = row.querySelector('[data-action="add-partner-inline"]');
            const partnerSaveBtn = row.querySelector('[data-action="save-partner-inline"]');
            const partnerNameInput = row.querySelector('[data-partner-name]');
            const partnerEmailInput = row.querySelector('input[data-partner-email]');
            if (partnerToggleBtn && partnerInline) {
                partnerToggleBtn.addEventListener('click', () => {
                    partnerInline.classList.toggle('hidden');
                    const target = partnerNameInput || partnerEmailInput;
                    target?.focus();
                });
            }
            if (partnerSaveBtn && partnerEmailInput) {
                partnerSaveBtn.addEventListener('click', () => {
                    const email = partnerEmailInput.value.trim();
                    if (!email) {
                        setStatus('Bitte eine Partner-E-Mail eingeben.', true);
                        partnerEmailInput.focus();
                        return;
                    }
                    if (typeof partnerEmailInput.checkValidity === 'function' && !partnerEmailInput.checkValidity()) {
                        partnerEmailInput.reportValidity();
                        return;
                    }
                    const name = partnerNameInput?.value.trim() || '';
                    const addedEmail = addPartnerInvite(name, email);
                    // Refresh all partner selects in the form (not just this row)
                    const wholeForm = container.closest('form') || document.getElementById('wizard-content');
                    refreshPartnerSelects(wholeForm || container);
                    if (partnerSelect && addedEmail) {
                        partnerSelect.value = addedEmail;
                        partnerSelect.dataset.partnerName = name || addedEmail;
                        partnerSelect.dispatchEvent(new Event('change', { bubbles: true }));
                    }
                    if (partnerInline) partnerInline.classList.add('hidden');
                    if (partnerNameInput) partnerNameInput.value = '';
                    partnerEmailInput.value = '';
                    setStatus('');
                });
            }

            const payoutSelect = row.querySelector('[data-field="commissionPayout"]');
            const billingSelect = row.querySelector('[data-field="billing"]');
            const retainerBlock = row.querySelector('[data-retainer-months-block]');
            const retainerInput = row.querySelector('[data-field="retainerMonths"]');
            const setPayoutDefault = () => {
                if (!payoutSelect || !billingSelect) return;
                if (payoutSelect.dataset.manual === 'true') return;
                payoutSelect.value = isRetainerBilling(billingSelect.value) ? 'monthly' : 'one_time';
            };
            const syncRetainerMonthsField = () => {
                if (!billingSelect || !retainerInput) return;
                const isRetainer = isRetainerBilling(billingSelect.value);
                retainerInput.disabled = !isRetainer;
                if (!isRetainer) retainerInput.value = '';
                if (retainerBlock) retainerBlock.classList.toggle('opacity-60', !isRetainer);
            };
            if (payoutSelect) {
                const payoutValue = (data.commissionPayout || '').toString().toLowerCase();
                const allowedPayouts = new Set(['monthly', 'half_yearly', 'yearly', 'one_time']);
                payoutSelect.value = allowedPayouts.has(payoutValue) ? payoutValue : payoutDefault;
                if (payoutValue) {
                    payoutSelect.dataset.manual = 'true';
                }
                payoutSelect.addEventListener('change', () => {
                    payoutSelect.dataset.manual = 'true';
                });
            }
            if (billingSelect) {
                billingSelect.addEventListener('change', () => {
                    setPayoutDefault();
                    syncRetainerMonthsField();
                });
            }
            setPayoutDefault();
            syncRetainerMonthsField();
            toggleDeductions();

            row.querySelector('[data-action="remove"]')?.addEventListener('click', () => {
                row.remove();
                updateCatalogEmpty(container, emptyEl);
            });

            container.appendChild(row);
            updateCatalogEmpty(container, emptyEl);
            return row;
        };

        const collectCatalogProductsRaw = (container) => {
            if (!container) return [];
            return Array.from(container.querySelectorAll('[data-product-row]')).map(row => {
                const getValue = (selector) => row.querySelector(selector)?.value ?? '';
                const getChecked = (selector, fallback = false) => row.querySelector(selector)?.checked ?? fallback;
                const partnerSelect = row.querySelector('[data-field="partnerEmail"]');
                const partnerOption = partnerSelect?.selectedOptions?.[0];
                const partnerEmail = partnerSelect?.value || '';
                const partnerName = partnerOption?.dataset.partnerName || partnerOption?.textContent?.trim() || '';
                const partnerId = partnerOption?.dataset.partnerId || '';
                const commissionBase = row.querySelector('[data-field="commissionBase"]:checked')?.value || 'revenue';
                const commissionDeductions = Array.from(row.querySelectorAll('[data-deduction-row]'))
                    .map(deductionRow => {
                        const label = deductionRow.querySelector('[data-deduction-label]')?.value.trim() || '';
                        const amountRaw = deductionRow.querySelector('[data-deduction-amount]')?.value.trim() || '';
                        const amount = amountRaw ? parseFloat(amountRaw.toString().replace(',', '.')) : NaN;
                        if (!label || !Number.isFinite(amount) || amount <= 0) return null;
                        return { label, amount };
                    })
                    .filter(Boolean);
                const roleRates = {};
                row.querySelectorAll('[data-role-commission]').forEach(input => {
                    const role = input.dataset.roleCommission;
                    if (!role) return;
                    roleRates[role] = input.value;
                });
                return {
                    name: getValue('[data-field="name"]'),
                    type: getValue('[data-field="type"]'),
                    partnerEmail,
                    partnerName,
                    partnerId,
                    billing: getValue('[data-field="billing"]'),
                    commissionPayout: getValue('[data-field="commissionPayout"]'),
                    price: getValue('[data-field="price"]'),
                    currency: getValue('[data-field="currency"]'),
                    vatRate: getValue('[data-field="vatRate"]'),
                    description: getValue('[data-field="description"]'),
                    retainerMonths: getValue('[data-field="retainerMonths"]'),
                    isActive: getChecked('[data-field="isActive"]', true),
                    allowQuantity: getChecked('[data-field="allowQuantity"]', true),
                    defaultQty: getValue('[data-field="defaultQty"]'),
                    commissionBase,
                    commissionDeductions,
                    roleRates
                };
            });
        };

        const buildCatalogProductsPayload = (orgData, rawProducts) => {
            const currency = orgData?.currency || 'CHF';
            const allowedTypes = new Set(['service', 'product', 'insurance']);
            const allowedBilling = new Set(['one_time', 'monthly', 'quarterly', 'half_yearly', 'yearly']);
            const allowedPayouts = new Set(['monthly', 'half_yearly', 'yearly', 'one_time']);

            return (rawProducts || []).map(product => {
                const name = (product.name || '').trim();
                const price = normalizeMoney(product.price);
                if (!name || price === null) return null;

                const commissionRate = normalizeRate(product.commissionRate, null);
                const roleRates = {};
                let hasRoleRates = false;
                Object.entries(product.roleRates || {}).forEach(([role, value]) => {
                    const normalized = normalizeRate(value, null);
                    if (normalized !== null) {
                        roleRates[role] = normalized;
                        hasRoleRates = true;
                    }
                });

                const normalizedType = allowedTypes.has(product.type) ? product.type : 'service';
                const normalizedBilling = allowedBilling.has(product.billing) ? product.billing : 'one_time';
                const commissionPayoutRaw = (product.commissionPayout || '').toString().toLowerCase();
                const commissionPayout = allowedPayouts.has(commissionPayoutRaw)
                    ? commissionPayoutRaw
                    : (isRetainerBilling(normalizedBilling) ? 'monthly' : 'one_time');
                const retainerMonthsRaw = parseInt(product.retainerMonths ?? '', 10);
                const retainerMonths = Number.isFinite(retainerMonthsRaw) && retainerMonthsRaw > 0
                    ? retainerMonthsRaw
                    : null;
                const vatValue = (product.vatRate ?? '').toString().trim();
                let vatRate = null;
                if (vatValue !== '') {
                    const parsed = parseFloat(vatValue);
                    if (Number.isFinite(parsed)) vatRate = parsed;
                }
                const commissionBase = product.commissionBase === 'profit' ? 'profit' : 'revenue';
                const deductionRows = Array.isArray(product.commissionDeductions) ? product.commissionDeductions : [];
                const commissionDeductions = deductionRows
                    .map(row => {
                        const label = (row?.label || '').trim();
                        const amount = normalizeMoney(row?.amount);
                        if (!label || amount === null || amount <= 0) return null;
                        return { label, amount };
                    })
                    .filter(Boolean);
                if (commissionBase === 'profit' && commissionDeductions.length === 0) {
                    return null;
                }
                const isActive = product.isActive !== false;
                const allowQuantity = product.allowQuantity !== false;
                const defaultQty = Math.max(1, parseInt(product.defaultQty || '1', 10));
                const currencyValue = (product.currency || currency).toString().trim() || currency;
                const partnerId = (product.partnerId || '').toString().trim();
                const partnerName = (product.partnerName || '').toString().trim();
                const partnerEmail = (product.partnerEmail || '').toString().trim();
                const payload = {
                    name,
                    type: normalizedType,
                    billing: normalizedBilling,
                    price,
                    description: (product.description || '').trim(),
                    commissionPayout,
                    currency: currencyValue,
                    vatRate,
                    commissionRate,
                    commissionRatesByRole: hasRoleRates ? roleRates : null,
                    commissionBase,
                    commissionDeductions: commissionBase === 'profit' ? commissionDeductions : null,
                    isActive,
                    allowQuantity,
                    defaultQty,
                    retainerMonths: isRetainerBilling(normalizedBilling) ? retainerMonths : null,
                    partnerId: partnerId || null,
                    partnerName: partnerName || null,
                    partnerEmail: partnerEmail || null
                };
                return payload;
            }).filter(Boolean);
        };

        const formatRateForInput = (rate) => {
            return Number.isFinite(rate) ? (rate * 100).toFixed(1).replace(/\.0$/, '') : '';
        };

        const runStep = (stepId) => {
            clearChat();
            updateWizardProgress();
            const prompts = {
                mode: 'Willst du eine neue Firma registrieren oder einer bestehenden beitreten?',
                account: '',
                company: 'Erzähl mir kurz etwas über deine Firma. Nur Name & Abrechnungs-E-Mail sind Pflicht — den Rest kannst du später ergänzen.',
                features: 'Das steckt in appnity — die Pläne siehst du hier zur Übersicht. Auswählen musst du jetzt nichts, das machst du nach der 14-Tage-Testphase. Wie gross ist dein Team?',
                pipeline: 'Wähle eine Pipeline-Vorlage — du kannst sie jederzeit in den Einstellungen anpassen.',
                products: 'Erfasse jetzt deine ersten Produkte oder Services — oder hol das später nach.',
                team: 'Möchtest du bereits Teammitglieder einladen? Du kannst sie auch später ins Dashboard einladen.',
                join: 'Bitte Firmencode und gewünschte Rolle angeben.',
                summary: 'Hier ist deine Zusammenfassung. Prüfe bitte alles und bestätige.'
            };

            const aiPayload = { kind: 'prompt', step: stepId, context: buildAiContext() };

            if (stepId === 'summary') {
                addAssistantMessage(prompts.summary, { kind: 'summary', context: buildAiContext() });
                renderSummaryCard();
                return;
            }

            const stepPrompt = prompts[stepId];
            if (typeof stepPrompt === 'string' && stepPrompt.trim()) {
                addAssistantMessage(stepPrompt, aiPayload);
            } else if (stepPrompt === undefined) {
                addAssistantMessage('Alles klar, weiter gehts.', aiPayload);
            }

            switch (stepId) {
                case 'mode':
                    renderModeStep();
                    break;
                case 'account':
                    renderAccountStep();
                    break;
                case 'company':
                    renderCompanyStep();
                    break;
                case 'features':
                    renderFeaturesStep();
                    break;
                case 'pipeline':
                    renderPipelineStep();
                    break;
                case 'products':
                    renderProductsStep();
                    break;
                case 'team':
                    renderTeamStep();
                    break;
                case 'join':
                    renderJoinStep();
                    break;
                default:
                    renderModeStep();
            }
        };

        const renderModeStep = () => {
            const card = document.createElement('div');
            card.className = 'chat-card';
            card.innerHTML = `
                <div style="display:flex;flex-direction:column;gap:1.5rem;">

                    <div style="text-align:center;padding:.5rem 0 .25rem;">
                        <div style="font-size:.65rem;font-weight:700;text-transform:uppercase;letter-spacing:.14em;color:var(--cyan);margin-bottom:.6rem;display:flex;align-items:center;justify-content:center;gap:.5rem;">
                            <span style="display:inline-block;width:18px;height:1px;background:var(--cyan);opacity:.5;"></span>
                            Jetzt starten
                            <span style="display:inline-block;width:18px;height:1px;background:var(--cyan);opacity:.5;"></span>
                        </div>
                        <h4 style="font-size:1.15rem;margin-bottom:.3rem;">Wie möchtest du loslegen?</h4>
                        <p style="font-size:.78rem;color:var(--t3);line-height:1.5;">14 Tage gratis testen · Bis zu 5 Leads frei · Keine Kreditkarte nötig.</p>
                    </div>

                    <div style="display:flex;flex-direction:column;gap:.75rem;">

                        <!-- NEW FIRM -->
                        <button type="button" data-mode="new" style="
                            position:relative;overflow:hidden;
                            display:flex;align-items:stretch;gap:0;
                            width:100%;text-align:left;cursor:pointer;font-family:inherit;
                            background:linear-gradient(135deg,rgba(0,200,190,.07),rgba(0,200,190,.03));
                            border:1.5px solid rgba(0,200,190,.22);
                            border-radius:16px;
                            padding:0;
                            transition:all .18s ease;
                        "
                        onmouseover="
                            this.style.borderColor='rgba(0,200,190,.5)';
                            this.style.transform='translateY(-2px)';
                            this.style.boxShadow='0 12px 32px rgba(0,200,190,.12)';
                            this.querySelector('.mc-arrow').style.transform='translateX(3px)';
                        "
                        onmouseout="
                            this.style.borderColor='rgba(0,200,190,.22)';
                            this.style.transform='none';
                            this.style.boxShadow='none';
                            this.querySelector('.mc-arrow').style.transform='none';
                        "
                        >
                            <!-- Glow strip -->
                            <div style="width:4px;background:linear-gradient(180deg,var(--cyan),rgba(0,200,190,.3));border-radius:12px 0 0 12px;flex-shrink:0;"></div>

                            <!-- Icon -->
                            <div style="
                                display:flex;align-items:center;justify-content:center;
                                width:72px;flex-shrink:0;
                                border-right:1px solid rgba(0,200,190,.12);
                            ">
                                <div style="
                                    width:42px;height:42px;border-radius:12px;
                                    background:rgba(0,200,190,.12);
                                    border:1px solid rgba(0,200,190,.25);
                                    display:flex;align-items:center;justify-content:center;
                                    color:var(--cyan);
                                ">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="width:19px;height:19px;">
                                        <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/>
                                    </svg>
                                </div>
                            </div>

                            <!-- Content -->
                            <div style="flex:1;padding:1.1rem 1rem 1.1rem .85rem;">
                                <div style="display:flex;align-items:center;justify-content:space-between;margin-bottom:.4rem;">
                                    <span style="font-size:.92rem;font-weight:700;color:var(--t1);font-family:'Plus Jakarta Sans',sans-serif;letter-spacing:-.02em;">Neue Firma registrieren</span>
                                    <svg class="mc-arrow" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" style="width:14px;height:14px;color:var(--cyan);flex-shrink:0;transition:transform .18s;"><polyline points="9 18 15 12 9 6"/></svg>
                                </div>
                                <p style="font-size:.77rem;color:var(--t3);line-height:1.55;margin-bottom:.65rem;">Organisation erstellen, Team einladen und sofort loslegen.</p>
                                <div style="display:flex;flex-wrap:wrap;gap:.35rem;">
                                    <span style="font-size:.66rem;font-weight:600;padding:.12rem .5rem;border-radius:99px;background:rgba(0,200,190,.1);color:var(--cyan);border:1px solid rgba(0,200,190,.2);">CRM & Pipeline</span>
                                    <span style="font-size:.66rem;font-weight:600;padding:.12rem .5rem;border-radius:99px;background:rgba(0,200,190,.1);color:var(--cyan);border:1px solid rgba(0,200,190,.2);">Offerten & Billing</span>
                                    <span style="font-size:.66rem;font-weight:600;padding:.12rem .5rem;border-radius:99px;background:rgba(148,163,184,.07);color:var(--t3);border:1px solid rgba(148,163,184,.12);">ca. 3 Min.</span>
                                </div>
                            </div>
                        </button>

                        <!-- JOIN -->
                        <button type="button" data-mode="join" style="
                            position:relative;overflow:hidden;
                            display:flex;align-items:stretch;gap:0;
                            width:100%;text-align:left;cursor:pointer;font-family:inherit;
                            background:linear-gradient(135deg,rgba(124,58,237,.07),rgba(124,58,237,.03));
                            border:1.5px solid rgba(124,58,237,.22);
                            border-radius:16px;
                            padding:0;
                            transition:all .18s ease;
                        "
                        onmouseover="
                            this.style.borderColor='rgba(124,58,237,.5)';
                            this.style.transform='translateY(-2px)';
                            this.style.boxShadow='0 12px 32px rgba(124,58,237,.12)';
                            this.querySelector('.mc-arrow').style.transform='translateX(3px)';
                        "
                        onmouseout="
                            this.style.borderColor='rgba(124,58,237,.22)';
                            this.style.transform='none';
                            this.style.boxShadow='none';
                            this.querySelector('.mc-arrow').style.transform='none';
                        "
                        >
                            <!-- Glow strip -->
                            <div style="width:4px;background:linear-gradient(180deg,var(--violet),rgba(124,58,237,.3));border-radius:12px 0 0 12px;flex-shrink:0;"></div>

                            <!-- Icon -->
                            <div style="
                                display:flex;align-items:center;justify-content:center;
                                width:72px;flex-shrink:0;
                                border-right:1px solid rgba(124,58,237,.12);
                            ">
                                <div style="
                                    width:42px;height:42px;border-radius:12px;
                                    background:rgba(124,58,237,.12);
                                    border:1px solid rgba(124,58,237,.25);
                                    display:flex;align-items:center;justify-content:center;
                                    color:var(--violet);
                                ">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="width:19px;height:19px;">
                                        <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/>
                                    </svg>
                                </div>
                            </div>

                            <!-- Content -->
                            <div style="flex:1;padding:1.1rem 1rem 1.1rem .85rem;">
                                <div style="display:flex;align-items:center;justify-content:space-between;margin-bottom:.4rem;">
                                    <span style="font-size:.92rem;font-weight:700;color:var(--t1);font-family:'Plus Jakarta Sans',sans-serif;letter-spacing:-.02em;">Bestehender Firma beitreten</span>
                                    <svg class="mc-arrow" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" style="width:14px;height:14px;color:var(--violet);flex-shrink:0;transition:transform .18s;"><polyline points="9 18 15 12 9 6"/></svg>
                                </div>
                                <p style="font-size:.77rem;color:var(--t3);line-height:1.55;margin-bottom:.65rem;">Du hast einen Firmencode oder eine Einladung erhalten.</p>
                                <div style="display:flex;flex-wrap:wrap;gap:.35rem;">
                                    <span style="font-size:.66rem;font-weight:600;padding:.12rem .5rem;border-radius:99px;background:rgba(124,58,237,.1);color:#C4B5FD;border:1px solid rgba(124,58,237,.2);">Schnell & einfach</span>
                                    <span style="font-size:.66rem;font-weight:600;padding:.12rem .5rem;border-radius:99px;background:rgba(148,163,184,.07);color:var(--t3);border:1px solid rgba(148,163,184,.12);">unter 1 Min.</span>
                                </div>
                            </div>
                        </button>

                    </div>
                </div>
            `;
            card.querySelectorAll('button').forEach(button => {
                button.addEventListener('click', () => {
                    state.mode = button.dataset.mode === 'join' ? 'join' : 'new';
                    saveState();
                    addUserMessage(state.mode === 'join' ? 'Bestehender Firma beitreten' : 'Neue Firma registrieren');
                    card.querySelectorAll('button').forEach(btn => btn.disabled = true);
                    goToNextStep();
                });
            });
            addCard(card);
        };

        const renderAccountStep = () => {
            const account = state.data.account;
            const eyeIconShow = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="w-4 h-4"><path d="M10 12.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z"/><path fill-rule="evenodd" d="M.664 10.59a1.651 1.651 0 0 1 0-1.186A10.004 10.004 0 0 1 10 3c4.257 0 7.893 2.66 9.336 6.41.147.381.146.804 0 1.186A10.004 10.004 0 0 1 10 17c-4.257 0-7.893-2.66-9.336-6.41ZM14 10a4 4 0 1 1-8 0 4 4 0 0 1 8 0Z" clip-rule="evenodd"/></svg>`;
            const eyeIconHide = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="w-4 h-4"><path fill-rule="evenodd" d="M3.28 2.22a.75.75 0 0 0-1.06 1.06l14.5 14.5a.75.75 0 1 0 1.06-1.06l-1.745-1.745a10.029 10.029 0 0 0 3.3-4.38 1.651 1.651 0 0 0 0-1.185A10.004 10.004 0 0 0 9.999 3a9.956 9.956 0 0 0-4.744 1.194L3.28 2.22ZM7.752 6.69l1.092 1.092a2.5 2.5 0 0 1 3.374 3.373l1.091 1.092a4 4 0 0 0-5.557-5.557Z" clip-rule="evenodd"/><path d="m10.748 13.93 2.523 2.523a10.003 10.003 0 0 1-3.27.547c-4.258 0-7.894-2.66-9.337-6.41a1.651 1.651 0 0 1 0-1.186A10.007 10.007 0 0 1 2.839 6.02L6.07 9.252a4 4 0 0 0 4.678 4.678Z"/></svg>`;
            const body = `
                <div style="display:flex;flex-direction:column;gap:.85rem;">

                    <!-- Name + Phone row -->
                    <div style="display:grid;grid-template-columns:1fr 1fr;gap:.65rem;">
                        <div>
                            <label style="display:block;font-size:.72rem;font-weight:600;color:var(--t3);margin-bottom:.3rem;letter-spacing:.02em;">Vor- & Nachname</label>
                            <div style="position:relative;">
                                <span style="position:absolute;left:.7rem;top:0;bottom:0;display:flex;align-items:center;color:var(--t4);pointer-events:none;">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="width:14px;height:14px;"><circle cx="12" cy="8" r="4"/><path d="M4 20c0-4 3.6-7 8-7s8 3 8 7"/></svg>
                                </span>
                                <input name="account-name" type="text" autocomplete="name" required autofocus
                                    value="${escapeAttr(account.name)}" placeholder="Max Mustermann"
                                    style="background:#FFFFFF;border:1.5px solid var(--border2);color:var(--t1);border-radius:10px;padding:.6rem .75rem .6rem 2.1rem;font-size:.83rem;font-family:inherit;width:100%;outline:none;transition:border-color .15s,box-shadow .15s;"
                                    onfocus="this.style.borderColor='rgba(0,200,190,.5)';this.style.boxShadow='0 0 0 3px rgba(0,200,190,.1)'"
                                    onblur="this.style.borderColor='var(--border2)';this.style.boxShadow='none'">
                            </div>
                        </div>
                        <div>
                            <label style="display:block;font-size:.72rem;font-weight:600;color:var(--t3);margin-bottom:.3rem;letter-spacing:.02em;">Telefon <span style="font-weight:400;color:var(--t4);">(optional)</span></label>
                            <div style="position:relative;">
                                <span style="position:absolute;left:.7rem;top:0;bottom:0;display:flex;align-items:center;color:var(--t4);pointer-events:none;">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="width:14px;height:14px;"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.14 13a19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 3.05 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L7.09 9.91a16 16 0 0 0 6 6z"/></svg>
                                </span>
                                <input name="account-phone" type="tel" autocomplete="tel"
                                    value="${escapeAttr(account.phone)}" placeholder="+41 79 123 45 67"
                                    pattern="^[+]?[0-9 \\-\\(\\)\\/]{6,20}$"
                                    title="Schweizer Format: +41 79 123 45 67 oder 079 123 45 67"
                                    style="background:#FFFFFF;border:1.5px solid var(--border2);color:var(--t1);border-radius:10px;padding:.6rem .75rem .6rem 2.1rem;font-size:.83rem;font-family:inherit;width:100%;outline:none;transition:border-color .15s,box-shadow .15s;"
                                    onfocus="this.style.borderColor='rgba(0,200,190,.5)';this.style.boxShadow='0 0 0 3px rgba(0,200,190,.1)'"
                                    onblur="this.style.borderColor='var(--border2)';this.style.boxShadow='none'">
                            </div>
                        </div>
                    </div>

                    <!-- E-Mail -->
                    <div>
                        <label style="display:block;font-size:.72rem;font-weight:600;color:var(--t3);margin-bottom:.3rem;letter-spacing:.02em;">E-Mail</label>
                        <div style="position:relative;">
                            <span style="position:absolute;left:.7rem;top:0;bottom:0;display:flex;align-items:center;color:var(--t4);pointer-events:none;">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="width:14px;height:14px;"><rect x="2" y="4" width="20" height="16" rx="2"/><path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"/></svg>
                            </span>
                            <input name="account-email" type="text" inputmode="email" autocomplete="email" inputmode="email" required
                                value="${escapeAttr(account.email)}" placeholder="name@firma.ch"
                                style="background:#FFFFFF;border:1.5px solid var(--border2);color:var(--t1);border-radius:10px;padding:.6rem .75rem .6rem 2.1rem;font-size:.83rem;font-family:inherit;width:100%;outline:none;transition:border-color .15s,box-shadow .15s;"
                                onfocus="this.style.borderColor='rgba(0,200,190,.5)';this.style.boxShadow='0 0 0 3px rgba(0,200,190,.1)'"
                                onblur="this.style.borderColor='var(--border2)';this.style.boxShadow='none'">
                        </div>
                    </div>

                    <!-- Divider -->
                    <div style="display:flex;align-items:center;gap:.75rem;margin:.1rem 0;">
                        <div style="flex:1;height:1px;background:var(--border);"></div>
                        <span style="font-size:.65rem;font-weight:700;text-transform:uppercase;letter-spacing:.1em;color:var(--t4);">Passwort</span>
                        <div style="flex:1;height:1px;background:var(--border);"></div>
                    </div>

                    <!-- Passwort: EIN Feld + Auge-Umschalter zum Prüfen. Bewusst KEIN separates
                         "Bestätigen"-Feld mehr — Safari/Passwort-Manager füllte es unsichtbar mit einem
                         abweichenden Wert → falsche "Passwörter stimmen nicht überein"-Meldung trotz
                         identischer Eingabe. Tippfehler prüft man jetzt via Sichtbar-Schalten (Auge). -->
                    <div>
                        <label style="display:block;font-size:.72rem;font-weight:600;color:var(--t3);margin-bottom:.3rem;letter-spacing:.02em;">Passwort</label>
                        <!-- Augen-Toggle links: rechter Rand bleibt frei für den nativen Passwort-Button des Browsers (kein Overlap) -->
                        <div style="position:relative;">
                            <button type="button" data-toggle-pw="account-password" tabindex="-1" aria-label="Passwort anzeigen/verbergen"
                                style="position:absolute;left:.6rem;top:50%;transform:translateY(-50%);background:none;border:none;cursor:pointer;color:var(--t4);display:flex;padding:0;transition:color .12s;"
                                onmouseover="this.style.color='var(--t1)'" onmouseout="this.style.color='var(--t4)'">${eyeIconShow}</button>
                            <input name="account-password" type="password" autocomplete="new-password" required minlength="8"
                                placeholder="Mindestens 8 Zeichen"
                                style="background:#FFFFFF;border:1.5px solid var(--border2);color:var(--t1);border-radius:10px;padding:.6rem 2.2rem .6rem 2.1rem;font-size:.83rem;font-family:inherit;width:100%;outline:none;transition:border-color .15s,box-shadow .15s;"
                                onfocus="this.style.borderColor='rgba(0,200,190,.5)';this.style.boxShadow='0 0 0 3px rgba(0,200,190,.1)'"
                                onblur="this.style.borderColor='var(--border2)';this.style.boxShadow='none'">
                        </div>
                    </div>

                    <!-- Password strength -->
                    <div style="background:#FFFFFF;border:1px solid var(--border);border-radius:10px;padding:.6rem .8rem;display:flex;flex-direction:column;gap:.4rem;">
                        <div style="display:flex;align-items:center;justify-content:space-between;gap:.5rem;">
                            <span style="font-size:.72rem;font-weight:600;color:var(--t3);">Passwortstärke</span>
                            <span data-password-strength-value style="font-size:.7rem;font-weight:700;color:#EF4444;">Zu kurz</span>
                        </div>
                        <!-- Segmented bar -->
                        <div style="display:grid;grid-template-columns:1fr 1fr 1fr 1fr;gap:3px;height:4px;">
                            <div style="border-radius:99px;background:var(--border2);overflow:hidden;">
                                <div data-password-strength-fill style="height:100%;width:0%;border-radius:99px;transition:width .3s,background .3s;background:var(--border2);"></div>
                            </div>
                            <div data-pw-seg-2 style="border-radius:99px;background:var(--border);"></div>
                            <div data-pw-seg-3 style="border-radius:99px;background:var(--border);"></div>
                            <div data-pw-seg-4 style="border-radius:99px;background:var(--border);"></div>
                        </div>
                        <p data-password-strength-hint style="font-size:.65rem;color:var(--t3);line-height:1.4;display:block;">Mindestens 8 Zeichen — Mix aus Buchstaben &amp; Zahlen empfohlen.</p>
                    </div>

                </div>
            `;
            const card = createFormCard('Konto anlegen', body, (form) => {
                const pw = form.querySelector('[name="account-password"]').value;
                state.data.account = {
                    name: form.querySelector('[name="account-name"]').value.trim(),
                    phone: form.querySelector('[name="account-phone"]').value.trim(),
                    email: form.querySelector('[name="account-email"]').value.trim().toLowerCase(),
                    password: pw
                };
                const billingLooksValid = isValidEmail(state.data.company?.billingEmail);
                if (state.data.company?.billingEmailAuto !== false && isValidEmail(state.data.account.email)) {
                    state.data.company.billingEmail = state.data.account.email;
                    state.data.company.billingEmailAuto = true;
                } else if (!billingLooksValid && isValidEmail(state.data.account.email)) {
                    state.data.company.billingEmail = state.data.account.email;
                    state.data.company.billingEmailAuto = true;
                }
                saveState();
                disableForm(form);
                addUserMessage(`${state.data.account.name} · ${state.data.account.email}`);
                goToNextStep();
            });
            const form = card.querySelector('form');
            const passwordValueEl = form.querySelector('[data-password-strength-value]');
            const passwordFillEl = form.querySelector('[data-password-strength-fill]');
            const passwordHintEl = form.querySelector('[data-password-strength-hint]');
            // Show/hide password toggles
            form.querySelectorAll('[data-toggle-pw]').forEach(btn => {
                btn.addEventListener('click', () => {
                    const targetName = btn.dataset.togglePw;
                    const input = form.querySelector(`[name="${targetName}"]`);
                    if (!input) return;
                    const isHidden = input.type === 'password';
                    input.type = isHidden ? 'text' : 'password';
                    btn.innerHTML = isHidden
                        ? `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="w-4 h-4"><path fill-rule="evenodd" d="M3.28 2.22a.75.75 0 0 0-1.06 1.06l14.5 14.5a.75.75 0 1 0 1.06-1.06l-1.745-1.745a10.029 10.029 0 0 0 3.3-4.38 1.651 1.651 0 0 0 0-1.185A10.004 10.004 0 0 0 9.999 3a9.956 9.956 0 0 0-4.744 1.194L3.28 2.22ZM7.752 6.69l1.092 1.092a2.5 2.5 0 0 1 3.374 3.373l1.091 1.092a4 4 0 0 0-5.557-5.557Z" clip-rule="evenodd"/><path d="m10.748 13.93 2.523 2.523a10.003 10.003 0 0 1-3.27.547c-4.258 0-7.894-2.66-9.337-6.41a1.651 1.651 0 0 1 0-1.186A10.007 10.007 0 0 1 2.839 6.02L6.07 9.252a4 4 0 0 0 4.678 4.678Z"/></svg>`
                        : `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="w-4 h-4"><path d="M10 12.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z"/><path fill-rule="evenodd" d="M.664 10.59a1.651 1.651 0 0 1 0-1.186A10.004 10.004 0 0 1 10 3c4.257 0 7.893 2.66 9.336 6.41.147.381.146.804 0 1.186A10.004 10.004 0 0 1 10 17c-4.257 0-7.893-2.66-9.336-6.41ZM14 10a4 4 0 1 1-8 0 4 4 0 0 1 8 0Z" clip-rule="evenodd"/></svg>`;
                    btn.setAttribute('aria-label', isHidden ? 'Passwort verbergen' : 'Passwort anzeigen');
                });
            });
            const syncPasswordStrength = () => {
                const strength = evaluatePasswordStrength(form.querySelector('[name="account-password"]').value);

                // Ampel-Farbe pro Stärke — Schlüssel MÜSSEN deckungsgleich mit den Levels aus
                // evaluatePasswordStrength sein (weak | okay | strong). Vorher hatte die Map die
                // Schlüssel weak/warning/ready/strong → 'okay' fehlte, Label fiel auf Rot zurück,
                // während der Balken grün war (rotes Label + grüner Balken = die komische Anzeige).
                const LEVEL_COLOR = { weak: '#EF4444', okay: '#F59E0B', strong: '#22C55E' };
                const levelColor = LEVEL_COLOR[strength.level] || '#EF4444';

                // Update label + color
                if (passwordValueEl) {
                    passwordValueEl.textContent = strength.label;
                    passwordValueEl.style.color = levelColor;
                }

                // Update segmented bars — gleiche Ampelfarbe wie das Label
                const seg1 = form.querySelector('[data-password-strength-fill]');
                const seg2 = form.querySelector('[data-pw-seg-2]');
                const seg3 = form.querySelector('[data-pw-seg-3]');
                const seg4 = form.querySelector('[data-pw-seg-4]');
                const segColor = levelColor;
                const segsActive = strength.percent < 30 ? 1
                    : strength.percent < 60 ? 2
                    : strength.percent < 85 ? 3 : 4;
                [seg1, seg2, seg3, seg4].forEach((seg, i) => {
                    if (!seg) return;
                    seg.style.background = i < segsActive ? segColor : 'var(--border)';
                    if (i === 0 && seg1) { seg1.style.width = '100%'; }
                });

                if (passwordFillEl) {
                    passwordFillEl.style.width = `${strength.percent}%`;
                    passwordFillEl.className = 'password-strength-fill' + (strength.level === 'weak' ? '' : ' is-' + strength.level);
                }
                if (passwordHintEl) {
                    passwordHintEl.textContent = strength.hint;
                }
            };
            const syncDraft = () => {
                state.data.account = {
                    name: form.querySelector('[name="account-name"]').value.trim(),
                    phone: form.querySelector('[name="account-phone"]').value.trim(),
                    email: form.querySelector('[name="account-email"]').value.trim().toLowerCase(),
                    password: form.querySelector('[name="account-password"]').value
                };
                const billingLooksValid = isValidEmail(state.data.company?.billingEmail);
                if (state.data.company?.billingEmailAuto !== false && isValidEmail(state.data.account.email)) {
                    state.data.company.billingEmail = state.data.account.email;
                    state.data.company.billingEmailAuto = true;
                } else if (!billingLooksValid && isValidEmail(state.data.account.email)) {
                    state.data.company.billingEmail = state.data.account.email;
                    state.data.company.billingEmailAuto = true;
                }
                queueLocalSave();
                updateLivePreview();
                syncPasswordStrength();
            };
            form.addEventListener('input', syncDraft);
            syncPasswordStrength();
            addCard(card);
        };

        const renderCompanyStep = () => {
            const company = state.data.company;
            const accountEmail = (state.data.account?.email || '').toLowerCase();
            const billingEmail = (company.billingEmail || '').toLowerCase();
            const billingAuto = company.billingEmailAuto !== false;
            const billingLooksValid = isValidEmail(billingEmail);
            const billingIsPrefix = accountEmail && billingEmail && accountEmail.startsWith(billingEmail) && accountEmail !== billingEmail;
            if (isValidEmail(accountEmail) && (billingAuto || billingIsPrefix || !billingLooksValid)) {
                company.billingEmail = state.data.account.email;
                company.billingEmailAuto = true;
            }
            const _inp = 'background:#FFFFFF;border:1.5px solid rgba(148,163,184,.16);color:#1A2433;border-radius:10px;padding:.55rem .75rem .55rem 2.1rem;font-size:.82rem;font-family:inherit;width:100%;outline:none;transition:border-color .15s,box-shadow .15s;';
            const _sel = 'background:#FFFFFF;border:1.5px solid rgba(148,163,184,.16);color:#1A2433;border-radius:10px;padding:.55rem .75rem;font-size:.82rem;font-family:inherit;width:100%;outline:none;transition:border-color .15s,box-shadow .15s;';
            const _lbl = 'display:block;font-size:.7rem;font-weight:600;color:#7A8AA0;margin-bottom:.28rem;letter-spacing:.02em;';
            const _foc = 'this.style.borderColor="rgba(0,200,190,.5)";this.style.boxShadow="0 0 0 3px rgba(0,200,190,.1)"';
            const _blu = 'this.style.borderColor="rgba(148,163,184,.16)";this.style.boxShadow="none"';
            const _icon = (path) => `<span style="position:absolute;left:.68rem;top:50%;transform:translateY(-50%);color:#7A8AA0;pointer-events:none;display:flex;"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="width:13px;height:13px;">${path}</svg></span>`;
            const _wrap = (inner) => `<div style="position:relative;display:flex;align-items:stretch;">${inner}</div>`;

            const buildFeaturesCard = (key, billingCycle, currency) => {
                const info = getSubscriptionPlanInfo(key);
                const allFeatures = info.features || [];
                const includedSeats = SUBSCRIPTION_INCLUDED_SEATS[key] || 1;
                const cyclePrice = billingCycle === 'year'
                    ? Math.round(info.price * (1 - SUBSCRIPTION_ANNUAL_DISCOUNT))
                    : info.price;
                const cycleLabel = billingCycle === 'year' ? 'pro Nutzer/Mt (−10%)' : 'pro Nutzer/Monat';
                const extraFeatures = allFeatures.slice(3);
                const extraCount = extraFeatures.length;
                const extrasBlock = extraCount ? `
                    <button type="button" data-action="toggle-features" data-extra-count="${extraCount}" aria-expanded="false"
                        style="font-size:.68rem;font-weight:600;color:#00C8BE;background:none;border:none;cursor:pointer;font-family:inherit;padding:0;margin-top:.2rem;display:flex;align-items:center;gap:.25rem;"
                        onmouseover="this.style.opacity='.7'" onmouseout="this.style.opacity='1'">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" style="width:11px;height:11px;"><polyline points="6 9 12 15 18 9"/></svg>
                        +${extraCount} weitere Features
                    </button>
                    <div data-extra-features style="display:none;margin-top:.4rem;display:flex;flex-direction:column;gap:.2rem;" class="hidden">
                        ${extraFeatures.map(f => `<div style="display:flex;align-items:center;gap:.35rem;font-size:.7rem;color:#56657A;"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="#00C8BE" stroke-width="2.5" style="width:10px;height:10px;flex-shrink:0;"><polyline points="20 6 9 17 4 12"/></svg>${f}</div>`).join('')}
                    </div>
                ` : '';
                return `
                    <div class="plan-stack">
                        
                        <label class="subscription-card ${info.recommended ? 'featured' : ''}" data-subscription-plan="${key}">
                            <input type="radio" name="subscription-plan" value="${key}" ${key === normalizeSubscriptionPlan(state.data.subscriptionPlan) ? 'checked' : ''} style="display:none;">

                            <!-- Top row: name + price -->
                            <div style="display:flex;align-items:flex-start;justify-content:space-between;gap:1rem;margin-bottom:.9rem;">
                                <div style="flex:1;">
                                    <div style="display:flex;align-items:center;gap:.5rem;margin-bottom:.3rem;">
                                        <span style="font-size:.97rem;font-weight:800;color:#1A2433;font-family:'Plus Jakarta Sans',sans-serif;letter-spacing:-.03em;">${info.label}</span>
                                        <span class="subscription-badge">Alles enthalten</span>
                                    </div>
                                    <p style="font-size:.73rem;color:#7A8AA0;line-height:1.4;">${info.description || ''}</p>
                                    ${info.audience ? `<p style="font-size:.68rem;color:#7A8AA0;margin-top:.15rem;">${info.audience}</p>` : ''}
                                </div>
                                <div style="text-align:right;flex-shrink:0;">
                                    <div style="font-size:.62rem;color:#7A8AA0;margin-bottom:.1rem;" data-plan-price-label>${cycleLabel}</div>
                                    <div style="font-size:1.5rem;font-weight:800;color:#1A2433;font-family:'Plus Jakarta Sans',sans-serif;letter-spacing:-.04em;line-height:1;" data-plan-price>${formatCurrency(cyclePrice, currency)}</div>
                                    <div style="font-size:.6rem;color:#7A8AA0;margin-top:.1rem;">exkl. MWST</div>
                                </div>
                            </div>

                            <!-- Seats chip -->
                            <div style="display:inline-flex;align-items:center;gap:.35rem;padding:.22rem .6rem;border-radius:99px;background:rgba(0,200,190,.08);border:1px solid rgba(0,200,190,.18);font-size:.68rem;color:#00C8BE;margin-bottom:.8rem;">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="width:10px;height:10px;"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/></svg>
                                ${includedSeats > 1 ? `Bis zu ${includedSeats} Sitze inklusive` : '1 Sitz inklusive'}
                            </div>

                            <!-- Features grid -->
                            <div style="display:grid;grid-template-columns:1fr 1fr;gap:.25rem .75rem;margin-bottom:.6rem;">
                                ${allFeatures.slice(0,6).map(f => `
                                    <div style="display:flex;align-items:flex-start;gap:.35rem;font-size:.71rem;color:#56657A;line-height:1.35;">
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="#00C8BE" stroke-width="2.5" style="width:10px;height:10px;flex-shrink:0;margin-top:2px;"><polyline points="20 6 9 17 4 12"/></svg>
                                        ${f}
                                    </div>
                                `).join('')}
                            </div>

                            ${extrasBlock}

                            ${(info.excludes || []).length ? `
                            <div style="margin-top:.55rem;padding:.35rem .6rem;background:rgba(148,163,184,.05);border-radius:7px;border:1px solid rgba(148,163,184,.1);">
                                <span style="font-size:.62rem;color:#4A6080;">Nicht enthalten: ${(info.excludes || []).join(', ')}</span>
                            </div>` : ''}

                        </label>
                    </div>
                `;
            };

            const updateAddonCardState = (row, on) => {
                if (!row) return;
                row.dataset.active = on;
                row.style.background  = on ? 'rgba(0,200,190,.07)' : '#FFFFFF';
                row.style.borderColor = on ? 'rgba(0,200,190,.3)'  : 'rgba(148,163,184,.15)';
                const ico = row.querySelector('.addon-icon-wrap');
                if (ico) {
                    ico.style.background  = on ? 'rgba(0,200,190,.15)' : 'rgba(148,163,184,.08)';
                    ico.style.borderColor = on ? 'rgba(0,200,190,.3)'  : 'rgba(148,163,184,.15)';
                    ico.style.color       = on ? '#00C8BE' : '#607A96';
                }
                const pv = row.querySelector('.addon-price-val');
                if (pv) pv.style.color = on ? '#00C8BE' : '#A8BAD0';
                const track = row.querySelector('.addon-switch-track');
                if (track) {
                    track.style.background   = on ? 'rgba(0,200,190,.25)' : 'rgba(148,163,184,.15)';
                    track.style.borderColor  = on ? 'rgba(0,200,190,.5)'  : 'rgba(148,163,184,.2)';
                }
                const dot = row.querySelector('.addon-switch-dot');
                if (dot) {
                    dot.style.background  = on ? '#00C8BE' : '#607A96';
                    dot.style.transform   = on ? 'translateX(16px)' : 'translateX(0)';
                }
            };
            const buildAddonRow = (key, addon, isActive, currency = 'CHF') => {
                const icons = {
                    financePlus: '<path d="M12 1v22M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/>',
                    mobileApp:   '<rect x="5" y="2" width="14" height="20" rx="2"/><line x1="12" y1="18" x2="12.01" y2="18"/>',
                    gamification:'<polyline points="23 6 13.5 15.5 8.5 10.5 1 18"/><polyline points="17 6 23 6 23 12"/>'
                };
                const iconPath = icons[key] || '<circle cx="12" cy="12" r="10"/>';
                return `
                    <div class="addon-card" data-addon-row="${key}" data-active="${isActive}"
                        onclick="(function(el){
                            var cb = el.querySelector('[data-addon-toggle]');
                            if(!cb) return;
                            cb.checked = !cb.checked;
                            cb.dispatchEvent(new Event('change', {bubbles:true}));
                        })(this)"
                        style="
                            display:flex;align-items:center;gap:.85rem;
                            padding:.9rem 1rem;border-radius:12px;
                            border:1.5px solid ${isActive ? 'rgba(0,200,190,.3)' : 'rgba(148,163,184,.15)'};
                            background:${isActive ? 'rgba(0,200,190,.07)' : '#FFFFFF'};
                            cursor:pointer;transition:background .15s,border-color .15s;
                            user-select:none;
                        ">

                        <!-- Icon -->
                        <div class="addon-icon-wrap" style="width:36px;height:36px;border-radius:10px;flex-shrink:0;
                            display:flex;align-items:center;justify-content:center;
                            background:${isActive ? 'rgba(0,200,190,.15)' : 'rgba(148,163,184,.08)'};
                            border:1px solid ${isActive ? 'rgba(0,200,190,.3)' : 'rgba(148,163,184,.15)'};
                            color:${isActive ? '#00C8BE' : '#607A96'};
                            transition:all .2s;">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="width:15px;height:15px;">${iconPath}</svg>
                        </div>

                        <!-- Text -->
                        <div style="flex:1;min-width:0;">
                            <div style="font-size:.83rem;font-weight:700;color:#1A2433;margin-bottom:.12rem;">${addon.label}</div>
                            ${addon.description ? `<div style="font-size:.68rem;color:#7A8AA0;line-height:1.35;">${addon.description}</div>` : ''}
                        </div>

                        <!-- Price -->
                        <div style="text-align:right;flex-shrink:0;margin-right:.5rem;">
                            <div class="addon-price-val" style="font-size:.92rem;font-weight:800;
                                color:${isActive ? '#00C8BE' : '#A8BAD0'};
                                font-family:'Plus Jakarta Sans',sans-serif;letter-spacing:-.02em;
                                transition:color .2s;">
                                +${formatCurrency(addon.price || 0, currency)}
                            </div>
                            <div style="font-size:.62rem;color:#4A6080;">/ Monat</div>
                        </div>

                        <!-- Visual toggle (non-interactive, driven by JS) -->
                        <div style="position:relative;width:44px;height:24px;flex-shrink:0;pointer-events:none;">
                            <!-- Hidden real checkbox -->
                            <input type="checkbox" data-addon-toggle="${key}" ${isActive ? 'checked' : ''}
                                style="position:absolute;opacity:0;width:0;height:0;pointer-events:none;">
                            <!-- Track -->
                            <div class="addon-switch-track" style="
                                position:absolute;inset:0;border-radius:99px;
                                background:${isActive ? 'rgba(0,200,190,.28)' : 'rgba(148,163,184,.15)'};
                                border:1px solid ${isActive ? 'rgba(0,200,190,.6)' : 'rgba(148,163,184,.2)'};
                                box-shadow:${isActive ? '0 0 0 3px rgba(0,200,190,.12)' : 'none'};
                                transition:background .25s,border-color .25s,box-shadow .25s;">
                            </div>
                            <!-- Dot -->
                            <div class="addon-switch-dot" style="
                                position:absolute;width:18px;height:18px;border-radius:50%;
                                background:${isActive ? '#00C8BE' : '#607A96'};
                                top:3px;left:3px;
                                box-shadow:${isActive ? '0 0 8px rgba(0,200,190,.5),0 1px 4px rgba(0,0,0,.2)' : '0 1px 4px rgba(0,0,0,.35)'};
                                transform:${isActive ? 'translateX(20px)' : 'translateX(0)'};
                                transition:transform .28s cubic-bezier(.34,1.56,.64,1),background .25s,box-shadow .25s;">
                            </div>
                        </div>

                    </div>
                `;
            };
            const buildFeaturesBody = () => {
                const _planInfo    = getSubscriptionPlanInfo(normalizeSubscriptionPlan(state.data.subscriptionPlan));
                const _billingCycle = normalizeBillingCycle(state.data.subscriptionBillingCycle || SUBSCRIPTION_BILLING_DEFAULT);
                const _employeeCount = normalizeEmployeeCount(state.data.employeeCount, normalizeSubscriptionPlan(state.data.subscriptionPlan));
                const _currency    = state.data.company?.currency || 'CHF';
                const _initModules = normalizeSubscriptionModules({
                    ...resolvePlanModules(normalizeSubscriptionPlan(state.data.subscriptionPlan)),
                    ...(state.data.subscriptionModules || {})
                });
                const _extraSeats    = getExtraSeatCount(_employeeCount, normalizeSubscriptionPlan(state.data.subscriptionPlan));
                const _extraSeatTotal = _extraSeats * _planInfo.price;
                const _addonTotal    = getSubscriptionAddonTotal(_initModules, _employeeCount);
                const _monthlyTotal  = _planInfo.price + _extraSeatTotal + _addonTotal;
                const _annualTotal   = Math.round(_monthlyTotal * 12 * (1 - SUBSCRIPTION_ANNUAL_DISCOUNT));
                const _addonSummary  = Object.entries(_initModules).filter(([k,v])=>v&&SUBSCRIPTION_ADDONS[k]).map(([k])=>SUBSCRIPTION_ADDONS[k].label);
                const _addonRows     = Object.entries(SUBSCRIPTION_ADDONS).map(([k,a])=>buildAddonRow(k,a,_initModules[k],_currency)).join('');
                return `
                <div style="display:flex;flex-direction:column;gap:1rem;">

                    <!-- ── Handelsregister (ZEFIX) Schnellsuche ── -->
                    <div style="background:rgba(0,200,190,.05);border:1.5px solid rgba(0,200,190,.22);border-radius:12px;padding:.8rem .85rem;">
                        <label style="display:block;font-size:.72rem;font-weight:600;color:#00A79C;margin-bottom:.4rem;">🏛️ Firma im Handelsregister suchen <span style="font-weight:400;color:#7A8AA0;">— füllt Name, UID, Rechtsform &amp; Adresse automatisch</span></label>
                        <div style="display:flex;gap:.5rem;">
                            <input name="zefix-query" type="search" autocomplete="off" placeholder="Firmenname oder CHE-Nummer"
                                style="flex:1;min-width:0;background:#fff;border:1.5px solid rgba(148,163,184,.25);border-radius:9px;padding:.5rem .7rem;font-size:.82rem;color:#1F2937;outline:none;">
                            <button type="button" data-zefix-search
                                style="flex-shrink:0;background:#00C8BE;color:#fff;border:none;border-radius:9px;padding:.5rem .9rem;font-size:.8rem;font-weight:600;cursor:pointer;white-space:nowrap;">Suchen</button>
                        </div>
                        <div data-zefix-results style="display:none;margin-top:.5rem;max-height:11rem;overflow-y:auto;"></div>
                        <p style="font-size:.63rem;color:#7A8AA0;margin-top:.35rem;">Nur für Schweizer Firmen. Alles bleibt danach editierbar.</p>
                    </div>

                    <!-- ── Pflichtfelder ── -->
                    <div style="display:grid;grid-template-columns:1fr 1fr;gap:.65rem;">

                        <!-- Firmenname -->
                        <div>
                            <label style="${_lbl}">Firmenname <span style="color:var(--cyan);">*</span></label>
                            ${_wrap(`
                                ${_icon('<path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/>')}
                                <input name="company-name" type="text" autocomplete="organization" required autofocus
                                    value="${escapeAttr(company.name)}" placeholder="Muster GmbH"
                                    style="${_inp}" onfocus="${_foc}" onblur="${_blu}">
                            `)}
                        </div>

                        <!-- Branche -->
                        <div>
                            <label style="${_lbl}">Branche</label>
                            <select name="company-industry" style="${_sel}" onfocus="${_foc}" onblur="${_blu}">
                                <option value="">Bitte wählen...</option>
                                <option value="Technologie/IT" ${company.industry === 'Technologie/IT' ? 'selected' : ''}>Technologie / IT</option>
                                <option value="Beratung" ${company.industry === 'Beratung' ? 'selected' : ''}>Beratung</option>
                                <option value="Finanzdienstleistungen" ${company.industry === 'Finanzdienstleistungen' ? 'selected' : ''}>Finanzdienstleistungen</option>
                                <option value="Versicherung" ${company.industry === 'Versicherung' ? 'selected' : ''}>Versicherung</option>
                                <option value="Gesundheitswesen" ${company.industry === 'Gesundheitswesen' ? 'selected' : ''}>Gesundheitswesen</option>
                                <option value="Bildung" ${company.industry === 'Bildung' ? 'selected' : ''}>Bildung</option>
                                <option value="Handel" ${company.industry === 'Handel' ? 'selected' : ''}>Handel</option>
                                <option value="E-Commerce" ${company.industry === 'E-Commerce' ? 'selected' : ''}>E-Commerce</option>
                                <option value="Produktion" ${company.industry === 'Produktion' ? 'selected' : ''}>Produktion</option>
                                <option value="Bau/Immobilien" ${company.industry === 'Bau/Immobilien' ? 'selected' : ''}>Bau / Immobilien</option>
                                <option value="Logistik/Transport" ${company.industry === 'Logistik/Transport' ? 'selected' : ''}>Logistik / Transport</option>
                                <option value="Gastronomie/Hotellerie" ${company.industry === 'Gastronomie/Hotellerie' ? 'selected' : ''}>Gastronomie / Hotellerie</option>
                                <option value="Medien/Marketing" ${company.industry === 'Medien/Marketing' ? 'selected' : ''}>Medien / Marketing</option>
                                <option value="Energie/Versorgung" ${company.industry === 'Energie/Versorgung' ? 'selected' : ''}>Energie / Versorgung</option>
                                <option value="Öffentliche Verwaltung" ${company.industry === 'Öffentliche Verwaltung' ? 'selected' : ''}>Öffentliche Verwaltung</option>
                                <option value="Non-Profit" ${company.industry === 'Non-Profit' ? 'selected' : ''}>Non-Profit</option>
                                <option value="Sonstiges" ${company.industry === 'Sonstiges' ? 'selected' : ''}>Sonstiges</option>
                            </select>
                        </div>

                        <!-- Billing E-Mail -->
                        <div>
                            <label style="${_lbl}">Abrechnungs-E-Mail <span style="color:var(--cyan);">*</span></label>
                            ${_wrap(`
                                ${_icon('<rect x="2" y="4" width="20" height="16" rx="2"/><path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"/>')}
                                <input name="company-billing-email" type="text" inputmode="email" autocomplete="email" required
                                    value="${escapeAttr(company.billingEmail || state.data.account?.email || '')}"
                                    placeholder="billing@firma.ch"
                                    style="${_inp}" onfocus="${_foc}" onblur="${_blu}">
                            `)}
                            <p style="font-size:.63rem;color:#7A8AA0;margin-top:.18rem;">Rechnungen & Hinweise.</p>
                        </div>

                        <!-- Rechtsform + Währung -->
                        <div style="display:grid;grid-template-columns:1fr 1fr;gap:.5rem;">
                            <div>
                                <label style="${_lbl}">Rechtsform</label>
                                <select name="company-legal" style="${_sel}" onfocus="${_foc}" onblur="${_blu}">
                                    <option value="">— wählen</option>
                                    <option ${company.legalForm === 'GmbH' ? 'selected' : ''}>GmbH</option>
                                    <option ${company.legalForm === 'AG' ? 'selected' : ''}>AG</option>
                                    <option ${company.legalForm === 'Einzelunternehmen' ? 'selected' : ''}>Einzelunternehmen</option>
                                    <option ${company.legalForm === 'KG' ? 'selected' : ''}>KG</option>
                                    <option ${company.legalForm === 'Verein' ? 'selected' : ''}>Verein</option>
                                    <option ${company.legalForm === 'Andere' ? 'selected' : ''}>Andere</option>
                                </select>
                            </div>
                            <div>
                                <label style="${_lbl}">Währung</label>
                                <select name="company-currency" style="${_sel}" onfocus="${_foc}" onblur="${_blu}">
                                    <option value="CHF" ${company.currency === 'CHF' ? 'selected' : ''}>CHF</option>
                                    <option value="EUR" ${company.currency === 'EUR' ? 'selected' : ''}>EUR</option>
                                    <option value="USD" ${company.currency === 'USD' ? 'selected' : ''}>USD</option>
                                    <option value="GBP" ${company.currency === 'GBP' ? 'selected' : ''}>GBP</option>
                                </select>
                            </div>
                        </div>
                    </div>

                    <!-- ── Divider: Adresse & Details ── -->
                    <div style="display:flex;align-items:center;gap:.75rem;">
                        <div style="flex:1;height:1px;background:rgba(148,163,184,.1);"></div>
                        <span style="font-size:.62rem;font-weight:700;text-transform:uppercase;letter-spacing:.11em;color:#7A8AA0;">Adresse & Details</span>
                        <div style="flex:1;height:1px;background:rgba(148,163,184,.1);"></div>
                    </div>

                    <!-- Adresse -->
                    <div style="display:grid;grid-template-columns:2fr 1fr 1fr;gap:.5rem;">
                        <div>
                            <label style="${_lbl}">Strasse & Nr.</label>
                            ${_wrap(`
                                ${_icon('<path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/>')}
                                <input name="company-street" type="text" value="${escapeAttr(company.street)}" placeholder="Musterstrasse 1"
                                    style="${_inp}" onfocus="${_foc}" onblur="${_blu}">
                            `)}
                        </div>
                        <div>
                            <label style="${_lbl}">PLZ</label>
                            ${_wrap(`
                                ${_icon('<path d="M12 2a7 7 0 0 1 7 7c0 5.25-7 13-7 13S5 14.25 5 9a7 7 0 0 1 7-7z"/><circle cx="12" cy="9" r="2.5"/>')}
                                <input name="company-zip" type="text" value="${escapeAttr(company.zip)}" placeholder="8000"
                                    style="${_inp}" onfocus="${_foc}" onblur="${_blu}">
                            `)}
                        </div>
                        <div>
                            <label style="${_lbl}">Ort</label>
                            ${_wrap(`
                                ${_icon('<circle cx="12" cy="12" r="10"/><line x1="2" y1="12" x2="22" y2="12"/>')}
                                <input name="company-city" type="text" value="${escapeAttr(company.city)}" placeholder="Zürich"
                                    style="${_inp}" onfocus="${_foc}" onblur="${_blu}">
                            `)}
                        </div>
                    </div>

                    <!-- Land + Website + UID + Zeitzone -->
                    <div style="display:grid;grid-template-columns:1fr 1fr;gap:.5rem;">
                        <div>
                            <label style="${_lbl}">Land</label>
                            ${_wrap(`
                                ${_icon('<circle cx="12" cy="12" r="10"/><line x1="2" y1="12" x2="22" y2="12"/><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/>')}
                                <input name="company-country" type="text" value="${escapeAttr(company.country)}" placeholder="Schweiz"
                                    style="${_inp}" onfocus="${_foc}" onblur="${_blu}">
                            `)}
                        </div>
                        <div>
                            <label style="${_lbl}">Website</label>
                            ${_wrap(`
                                ${_icon('<path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"/><path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"/>')}
                                <input name="company-website" type="text" inputmode="url" value="${escapeAttr(company.website)}" placeholder="beispiel.ch"
                                    style="${_inp}" onfocus="${_foc}" onblur="${_blu}">
                            `)}
                        </div>
                        <div>
                            <label style="${_lbl}">UID / MWST</label>
                            ${_wrap(`
                                ${_icon('<rect x="2" y="3" width="20" height="18" rx="2"/><path d="M7 7h10M7 12h10M7 17h5"/>')}
                                <input name="company-uid" type="text" value="${escapeAttr(company.uid)}" placeholder="CHE-123.456.789"
                                    style="${_inp}" onfocus="${_foc}" onblur="${_blu}">
                            `)}
                        </div>
                        <div>
                            <label style="${_lbl}">Zeitzone</label>
                            <select name="company-timezone" style="${_sel}" onfocus="${_foc}" onblur="${_blu}">
                                <option value="Europe/Zurich" ${company.timezone === 'Europe/Zurich' ? 'selected' : ''}>Europe/Zurich</option>
                                <option value="Europe/Berlin" ${company.timezone === 'Europe/Berlin' ? 'selected' : ''}>Europe/Berlin</option>
                                <option value="Europe/Vienna" ${company.timezone === 'Europe/Vienna' ? 'selected' : ''}>Europe/Vienna</option>
                                <option value="Europe/London" ${company.timezone === 'Europe/London' ? 'selected' : ''}>Europe/London</option>
                                <option value="America/New_York" ${company.timezone === 'America/New_York' ? 'selected' : ''}>America/New_York</option>
                                <option value="UTC" ${company.timezone === 'UTC' ? 'selected' : ''}>UTC</option>
                            </select>
                        </div>
                    </div>

                    <!-- ── Logo Upload ── -->
                    <div style="display:flex;align-items:center;gap:.85rem;padding:.85rem;background:#FFFFFF;border:1.5px dashed rgba(148,163,184,.15);border-radius:12px;transition:border-color .15s;"
                        onmouseover="this.style.borderColor='rgba(0,200,190,.3)'" onmouseout="this.style.borderColor='rgba(148,163,184,.15)'">
                        <div style="width:40px;height:40px;border-radius:10px;background:rgba(0,200,190,.08);border:1px solid rgba(0,200,190,.18);display:flex;align-items:center;justify-content:center;flex-shrink:0;color:#00C8BE;">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="width:16px;height:16px;"><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><polyline points="21 15 16 10 5 21"/></svg>
                        </div>
                        <div style="flex:1;min-width:0;">
                            <div style="font-size:.75rem;font-weight:600;color:#56657A;margin-bottom:.2rem;">Logo <span style="font-weight:400;color:#7A8AA0;">(optional · PNG)</span></div>
                            <input name="company-logo-file" type="file" accept="image/png"
                                style="font-size:.72rem;color:#7A8AA0;width:100%;background:transparent;border:none;padding:0;cursor:pointer;outline:none;">
                            <p style="font-size:.67rem;color:#7A8AA0;margin-top:.15rem;" data-logo-status></p>
                        </div>
                    </div>

                </div>
            `;
            };
            const body = buildFeaturesBody();
            const updateCompany = (form) => {
                const getValue = (name) => form.querySelector(`[name="${name}"]`)?.value?.trim() || '';
                const fallbackEmail = (state.data.account?.email || '').toLowerCase();
                const rawBillingEmail = getValue('company-billing-email');
                const normalizedBillingEmail = (rawBillingEmail || '').toLowerCase();
                const hasValidCustom = isValidEmail(normalizedBillingEmail) && normalizedBillingEmail !== fallbackEmail;
                const billingEmail = hasValidCustom
                    ? normalizedBillingEmail
                    : (isValidEmail(fallbackEmail) ? fallbackEmail : normalizedBillingEmail);
                state.data.company = {
                    ...company,
                    name: getValue('company-name'),
                    legalForm: form.querySelector('[name="company-legal"]').value,
                    street: getValue('company-street'),
                    zip: getValue('company-zip'),
                    city: getValue('company-city'),
                    country: getValue('company-country') || company.country,
                    uid: getValue('company-uid'),
                    billingEmail,
                    billingEmailAuto: !hasValidCustom,
                    logoUrl: company.logoUrl || '',
                    website: normalizeWebsite(getValue('company-website')),
                    industry: form.querySelector('[name="company-industry"]').value,
                    timezone: form.querySelector('[name="company-timezone"]').value || company.timezone,
                    currency: form.querySelector('[name="company-currency"]').value || company.currency
                };
            };
            const card = createFormCard('Firmendaten', body, (form) => {
                updateCompany(form);
                state.data.company = {
                    ...state.data.company,
                    name: state.data.company.name || 'Neue Firma'
                };
                saveState();
                disableForm(form);
                addUserMessage(`${state.data.company.name} · ${state.data.company.currency}`);
                goToNextStep();
            }, { className: 'chat-card--scroll chat-card--config' });
            const form = card.querySelector('form');
            // Handelsregister-Suche (ZEFIX): füllt Firmenfelder automatisch aus dem CH-Register — alles editierbar.
            (function setupZefixSearch(){
                const qEl = form.querySelector('[name="zefix-query"]');
                const btn = form.querySelector('[data-zefix-search]');
                const box = form.querySelector('[data-zefix-results]');
                if (!qEl || !btn || !box) return;
                const mapLegalForm = (lf) => {
                    const s = (lf || '').toLowerCase();
                    if (/gmbh|beschränk/.test(s)) return 'GmbH';
                    if (/aktiengesell|\bag\b/.test(s)) return 'AG';
                    if (/einzel/.test(s)) return 'Einzelunternehmen';
                    if (/kommandit|\bkg\b/.test(s)) return 'KG';
                    if (/verein/.test(s)) return 'Verein';
                    return lf ? 'Andere' : '';
                };
                const setField = (name, val) => { const el = form.querySelector('[name="' + name + '"]'); if (el && val) el.value = val; };
                const applyCompany = (c) => {
                    setField('company-name', c.name);
                    setField('company-street', c.street);
                    setField('company-zip', c.zip);
                    setField('company-city', c.city);
                    setField('company-country', c.country === 'CH' ? 'Schweiz' : c.country);
                    setField('company-uid', c.uidFormatted || c.uid);
                    const lf = mapLegalForm(c.legalForm);
                    const sel = form.querySelector('[name="company-legal"]');
                    if (sel && lf) sel.value = lf;
                    box.style.display = 'none'; box.textContent = '';
                };
                const run = async () => {
                    const q = (qEl.value || '').trim();
                    if (q.length < 3){ box.style.display = 'block'; box.textContent = 'Bitte mindestens 3 Zeichen eingeben.'; return; }
                    box.style.display = 'block'; box.textContent = 'Suche im Handelsregister…';
                    if (typeof lookupZefixCompanyFn !== 'function'){ box.textContent = 'Handelsregister-Suche momentan nicht verfügbar.'; return; }
                    try {
                        const r = await lookupZefixCompanyFn({ query: q });
                        const results = (r && r.data && r.data.results) || [];
                        box.textContent = '';
                        if (!results.length){ box.textContent = 'Keine Treffer im Handelsregister.'; return; }
                        results.slice(0, 6).forEach((c) => {
                            const b = document.createElement('button');
                            b.type = 'button';
                            b.style.cssText = 'display:block;width:100%;text-align:left;background:#fff;border:1px solid rgba(148,163,184,.25);border-radius:8px;padding:.45rem .6rem;margin-bottom:.35rem;font-size:.76rem;color:#374151;cursor:pointer;';
                            b.textContent = (c.name + ' · ' + (c.legalForm || '') + ' · ' + (c.zip || '') + ' ' + (c.city || '') + ' · ' + (c.uidFormatted || c.uid || '')).replace(/\s+/g, ' ').trim();
                            b.addEventListener('click', () => applyCompany(c));
                            box.appendChild(b);
                        });
                    } catch (e) { box.textContent = 'Handelsregister-Fehler: ' + ((e && e.message) || 'unbekannt'); }
                };
                btn.addEventListener('click', run);
                qEl.addEventListener('keydown', (e) => { if (e.key === 'Enter'){ e.preventDefault(); run(); } });
            })();
            const logoInput = form.querySelector('[name="company-logo-file"]');
            const logoStatus = form.querySelector('[data-logo-status]');
            const setLogoStatus = (message, isError = false) => {
                if (!logoStatus) return;
                logoStatus.textContent = message;
                logoStatus.classList.toggle('text-rose-300', isError);
                logoStatus.classList.toggle('text-slate-400', !isError);
            };
            const syncLogoStatus = () => {
                if (pendingLogoFile) {
                    setLogoStatus(`Ausgewählt:\n${pendingLogoFile.name}`);
                } else if (state.data.company?.logoUrl) {
                    setLogoStatus('Logo hinterlegt.');
                } else {
                    setLogoStatus('Kein Logo ausgewählt.');
                }
            };
            if (logoInput) {
                logoInput.addEventListener('change', () => {
                    const file = logoInput.files && logoInput.files[0] ? logoInput.files[0] : null;
                    if (!file) {
                        pendingLogoFile = null;
                        syncLogoStatus();
                        return;
                    }
                    const isPng = file.type === 'image/png' || file.name.toLowerCase().endsWith('.png');
                    if (!isPng) {
                        pendingLogoFile = null;
                        logoInput.value = '';
                        setLogoStatus('Bitte eine PNG-Datei auswählen.', true);
                        return;
                    }
                    if (file.size > 2 * 1024 * 1024) {
                        pendingLogoFile = null;
                        logoInput.value = '';
                        setLogoStatus('PNG ist zu gross (max. 2 MB).', true);
                        return;
                    }
                    pendingLogoFile = file;
                    setLogoStatus(`Ausgewählt:\n${file.name}`);
                });
            }
            syncLogoStatus();
            const syncDraft = () => {
                updateCompany(form);
                if (!state.data.company.name) {
                    state.data.company.name = 'Neue Firma';
                }
                queueLocalSave();
                updateLivePreview();
            };
            form.addEventListener('input', syncDraft);
            form.addEventListener('change', syncDraft);
            addCard(card);
        };

        const renderFeaturesStep = () => {
            const planKey = normalizeSubscriptionPlan(state.data.subscriptionPlan);
            const planInfo = getSubscriptionPlanInfo(planKey);
            const currency = state.data.company?.currency || 'CHF';
            const employeeCount = normalizeEmployeeCount(state.data.employeeCount, planKey);
            const billingCycle = normalizeBillingCycle(state.data.subscriptionBillingCycle || SUBSCRIPTION_BILLING_DEFAULT);
            const seatMax = 20;
            const initialModules = normalizeSubscriptionModules({
                ...resolvePlanModules(planKey),
                ...(state.data.subscriptionModules || {})
            });

            const getPaidRolesForModules = () => {
                // Single-Plan-Modell: Alle Rollen außer Owner zählen als kostenpflichtige Sitze.
                return ['Admin', 'VL', 'Mitarbeiter', 'Accounting', 'Partner'];
            };
            const getAddonLabels = (modules) => Object.entries(modules)
                .filter(([key, enabled]) => enabled && SUBSCRIPTION_ADDONS[key])
                .map(([key]) => SUBSCRIPTION_ADDONS[key].label);
            const getSeatInviteRows = (formEl) => {
                const list = formEl.querySelector('[data-seat-invite-list]');
                return Array.from(list.querySelectorAll('[data-seat-invite-row]')).map(row => {
                    const name = row.querySelector('[data-seat-field="name"]')?.value?.trim() || '';
                    const email = row.querySelector('[data-seat-field="email"]')?.value?.trim().toLowerCase() || '';
                    const role = row.dataset.inviteRole || 'Mitarbeiter';
                    return { name, email, role };
                });
            };
            const getPaidSeatInviteRows = (formEl, paidRoles) => {
                return getSeatInviteRows(formEl).filter(item => paidRoles.includes(item.role));
            };
            const collectSeatInvites = (formEl, paidRoles) => {
                const rows = paidRoles ? getPaidSeatInviteRows(formEl, paidRoles) : getSeatInviteRows(formEl);
                return rows.filter(item => item.name && item.email);
            };
            const collectSupportSeatInvites = (formEl, paidRoles) => {
                return getSeatInviteRows(formEl)
                    .filter(item => !paidRoles.includes(item.role))
                    .filter(item => item.name && item.email);
            };
            const updateAddonCardState = (row, on) => {
                if (!row) return;
                row.dataset.active = on;
                row.style.background = on ? 'rgba(0,200,190,.07)' : '#FFFFFF';
                row.style.borderColor = on ? 'rgba(0,200,190,.3)' : 'rgba(148,163,184,.15)';
                const ico = row.querySelector('.addon-icon-wrap');
                if (ico) {
                    ico.style.background = on ? 'rgba(0,200,190,.15)' : 'rgba(148,163,184,.08)';
                    ico.style.borderColor = on ? 'rgba(0,200,190,.3)' : 'rgba(148,163,184,.15)';
                    ico.style.color = on ? '#00C8BE' : '#607A96';
                }
                const pv = row.querySelector('.addon-price-val');
                if (pv) pv.style.color = on ? '#00C8BE' : '#A8BAD0';
                const track = row.querySelector('.addon-switch-track');
                if (track) {
                    track.style.background  = on ? 'rgba(0,200,190,.28)' : 'rgba(148,163,184,.15)';
                    track.style.borderColor = on ? 'rgba(0,200,190,.6)'  : 'rgba(148,163,184,.2)';
                    track.style.boxShadow   = on ? '0 0 0 3px rgba(0,200,190,.12)' : 'none';
                }
                const dot = row.querySelector('.addon-switch-dot');
                if (dot) {
                    dot.style.background  = on ? '#00C8BE' : '#607A96';
                    dot.style.transform   = on ? 'translateX(20px)' : 'translateX(0)';
                    dot.style.boxShadow   = on ? '0 0 8px rgba(0,200,190,.5),0 1px 4px rgba(0,0,0,.2)' : '0 1px 4px rgba(0,0,0,.35)';
                }
            };
            const buildAddonRow = (key, addon, isActive, currencyValue = 'CHF') => {
                const icons = {
                    financePlus: '<path d="M12 1v22M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/>',
                    mobileApp: '<rect x="5" y="2" width="14" height="20" rx="2"/><line x1="12" y1="18" x2="12.01" y2="18"/>',
                    gamification: '<polyline points="23 6 13.5 15.5 8.5 10.5 1 18"/><polyline points="17 6 23 6 23 12"/>'
                };
                const iconPath = icons[key] || '<circle cx="12" cy="12" r="10"/>';
                return `
                    <div class="addon-card" data-addon-row="${key}" data-active="${isActive}"
                        onclick="(function(el){
                            var cb = el.querySelector('[data-addon-toggle]');
                            if(!cb) return;
                            cb.checked = !cb.checked;
                            cb.dispatchEvent(new Event('change', {bubbles:true}));
                        })(this)"
                        style="
                            display:flex;align-items:center;gap:.85rem;
                            padding:.9rem 1rem;border-radius:12px;
                            border:1.5px solid ${isActive ? 'rgba(0,200,190,.3)' : 'rgba(148,163,184,.15)'};
                            background:${isActive ? 'rgba(0,200,190,.07)' : '#FFFFFF'};
                            cursor:pointer;transition:background .15s,border-color .15s;
                            user-select:none;
                        ">
                        <div class="addon-icon-wrap" style="width:36px;height:36px;border-radius:10px;flex-shrink:0;
                            display:flex;align-items:center;justify-content:center;
                            background:${isActive ? 'rgba(0,200,190,.15)' : 'rgba(148,163,184,.08)'};
                            border:1px solid ${isActive ? 'rgba(0,200,190,.3)' : 'rgba(148,163,184,.15)'};
                            color:${isActive ? '#00C8BE' : '#607A96'};
                            transition:all .2s;">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="width:15px;height:15px;">${iconPath}</svg>
                        </div>
                        <div style="flex:1;min-width:0;">
                            <div style="font-size:.83rem;font-weight:700;color:#1A2433;margin-bottom:.12rem;">${addon.label}</div>
                            ${addon.description ? `<div style="font-size:.68rem;color:#7A8AA0;line-height:1.35;">${addon.description}</div>` : ''}
                        </div>
                        <div style="text-align:right;flex-shrink:0;margin-right:.5rem;">
                            <div class="addon-price-val" style="font-size:.92rem;font-weight:800;
                                color:${isActive ? '#00C8BE' : '#A8BAD0'};
                                font-family:'Plus Jakarta Sans',sans-serif;letter-spacing:-.02em;
                                transition:color .2s;">
                                +${formatCurrency(addon.price || 0, currencyValue)}
                            </div>
                            <div style="font-size:.62rem;color:#4A6080;">/ Monat</div>
                        </div>
                        <div style="position:relative;width:44px;height:24px;flex-shrink:0;pointer-events:none;">
                            <input type="checkbox" data-addon-toggle="${key}" ${isActive ? 'checked' : ''}
                                style="position:absolute;opacity:0;width:0;height:0;pointer-events:none;">
                            <div class="addon-switch-track" style="
                                position:absolute;inset:0;border-radius:99px;
                                background:${isActive ? 'rgba(0,200,190,.28)' : 'rgba(148,163,184,.15)'};
                                border:1px solid ${isActive ? 'rgba(0,200,190,.6)' : 'rgba(148,163,184,.2)'};
                                box-shadow:${isActive ? '0 0 0 3px rgba(0,200,190,.12)' : 'none'};
                                transition:background .25s,border-color .25s,box-shadow .25s;">
                            </div>
                            <div class="addon-switch-dot" style="
                                position:absolute;width:18px;height:18px;border-radius:50%;
                                background:${isActive ? '#00C8BE' : '#607A96'};
                                top:3px;left:3px;
                                box-shadow:${isActive ? '0 0 8px rgba(0,200,190,.5),0 1px 4px rgba(0,0,0,.2)' : '0 1px 4px rgba(0,0,0,.35)'};
                                transform:${isActive ? 'translateX(20px)' : 'translateX(0)'};
                                transition:transform .28s cubic-bezier(.34,1.56,.64,1),background .25s,box-shadow .25s;">
                            </div>
                        </div>
                    </div>
                `;
            };
            // Info-Karte (KEINE Auswahl): Während der 14-Tage-Testphase wird kein Paket festgelegt.
            // Die Karten zeigen die Pläne nur zur Orientierung nebeneinander; die Wahl trifft der
            // Kunde nach der Testphase im Dashboard. Kein <input type="radio"> → nichts auswählbar.
            const buildFeaturesCard = (key, cycle, currencyValue) => {
                const info = getSubscriptionPlanInfo(key);
                const allFeatures = info.features || [];
                const cyclePrice = cycle === 'year'
                    ? Math.round(info.price * (1 - SUBSCRIPTION_ANNUAL_DISCOUNT))
                    : info.price;
                const cycleLabel = cycle === 'year' ? '/Nutzer·Mt (-10%)' : '/Nutzer·Mt';
                return `
                    <div class="plan-info-card${info.recommended ? ' featured' : ''}" data-subscription-plan="${key}"
                        style="position:relative;display:flex;flex-direction:column;gap:.5rem;background:#FFFFFF;border:1.5px solid ${info.recommended ? 'rgba(0,200,190,.4)' : 'rgba(148,163,184,.16)'};border-radius:14px;padding:.95rem .8rem .85rem;${info.recommended ? 'box-shadow:0 0 0 3px rgba(0,200,190,.08);' : ''}">
                        ${info.recommended ? `<span style="position:absolute;top:-.62rem;left:50%;transform:translateX(-50%);font-size:.56rem;font-weight:700;letter-spacing:.03em;padding:.12rem .55rem;border-radius:99px;background:#00C8BE;color:#fff;white-space:nowrap;">Empfohlen</span>` : ''}
                        <div>
                            <div style="font-size:.92rem;font-weight:800;color:#1A2433;font-family:'Plus Jakarta Sans',sans-serif;letter-spacing:-.02em;">${info.label}</div>
                            <div style="font-size:.62rem;color:#7A8AA0;line-height:1.3;margin-top:.15rem;min-height:2.4em;">${info.audience || info.description || ''}</div>
                        </div>
                        <div style="display:flex;align-items:baseline;gap:.25rem;flex-wrap:wrap;">
                            <span style="font-size:1.3rem;font-weight:800;color:#1A2433;font-family:'Plus Jakarta Sans',sans-serif;letter-spacing:-.03em;line-height:1;" data-plan-price>${formatCurrency(cyclePrice, currencyValue)}</span>
                            <span style="font-size:.6rem;color:#7A8AA0;" data-plan-price-label>${cycleLabel}</span>
                        </div>
                        <div style="font-size:.56rem;color:#7A8AA0;margin-top:-.3rem;">exkl. MWST · 1 Sitz inkl.</div>
                        <div style="display:flex;flex-direction:column;gap:.22rem;border-top:1px solid rgba(148,163,184,.1);padding-top:.5rem;">
                            ${allFeatures.slice(0, 5).map(feature => `
                                <div style="display:flex;align-items:flex-start;gap:.3rem;font-size:.63rem;color:#56657A;line-height:1.3;">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="#00C8BE" stroke-width="3" style="width:9px;height:9px;flex-shrink:0;margin-top:2px;"><polyline points="20 6 9 17 4 12"/></svg>
                                    ${feature}
                                </div>
                            `).join('')}
                        </div>
                    </div>
                `;
            };
            const initialAddonSummary = getAddonLabels(initialModules);
            const initialExtraSeatTotal = getExtraSeatCount(employeeCount, planKey) * getSubscriptionPlanInfo(planKey).price;
            const initialAddonTotal = getSubscriptionAddonTotal(initialModules, employeeCount);
            const initialMonthlyTotal = planInfo.price + initialExtraSeatTotal + initialAddonTotal;
            const initialAnnualTotal = Math.round(initialMonthlyTotal * 12 * (1 - SUBSCRIPTION_ANNUAL_DISCOUNT));
            const initialSeatUnitLabel = formatCurrency(getSubscriptionPlanInfo(planKey).price, currency);
            const initialBillingLabel = billingCycle === 'year' ? 'Jährlich (-10%)' : 'Monatlich';

            const priceSummaryCard = `
                <div class="live-preview-header">
                    <p class="font-semibold text-slate-100">Preisübersicht</p>
                    <span class="live-preview-badge">${initialBillingLabel}</span>
                </div>
                <div class="price-summary">
                    <div class="price-summary-total">
                        <div>
                            <p class="price-summary-meta" data-subscription-primary-label>Gesamt / Monat</p>
                            <p class="price-summary-amount" data-subscription-total>${formatCurrency(initialMonthlyTotal, currency)}</p>
                            <p class="price-summary-meta" data-subscription-secondary-row>
                                <span data-subscription-secondary-label>Jährlich:</span>
                                <span data-subscription-secondary-amount>${formatCurrency(initialAnnualTotal, currency)}</span>
                                <span data-subscription-secondary-suffix> (-10%)</span>
                            </p>
                        </div>
                        <p class="price-summary-meta text-right">Zahlung: <span data-billing-label>${initialBillingLabel}</span></p>
                    </div>
                    <div class="price-summary-list">
                        <div class="price-summary-row">
                            <span data-cost-plan-label>${planInfo.label} Modul</span>
                            <span data-cost-plan>${formatCurrency(planInfo.price, currency)}</span>
                        </div>
                        <div class="price-summary-row">
                            <span data-cost-addons-label>Inklusive Module</span>
                            <span data-cost-addons>${formatCurrency(initialAddonTotal, currency)}</span>
                        </div>
                        <div class="price-summary-row">
                            <span data-cost-seats-label>Zusätzliche Plätze (pro MA ${initialSeatUnitLabel})</span>
                            <span data-cost-seats>${formatCurrency(initialExtraSeatTotal, currency)}</span>
                        </div>
                        <div class="price-summary-divider"></div>
                        <div class="price-summary-row total">
                            <span>Gesamt / Monat</span>
                            <span data-cost-total>${formatCurrency(initialMonthlyTotal, currency)}</span>
                        </div>
                        <div style="display:none;" data-cost-yearly>${formatCurrency(initialAnnualTotal, currency)}</div>
                        <p class="price-summary-meta">Preise exkl. MWST</p>
                    </div>
                </div>
            `;

            const buildFeaturesBody = () => {
                // Nur noch das Nötige: Plan-Info-Karten (Preis/Feature-Anzeige) + Team-Grösse.
                // Keine Kosten-Summen mehr (Paket/Zahlweise erst nach der Testphase) → kein
                // _monthlyTotal/_annualTotal/_extraSeatTotal etc. mehr berechnen.
                const _billingCycle = billingCycle;
                const _currency = currency;
                const _employeeCount = normalizeEmployeeCount(state.data.employeeCount, planKey);
                const _initModules = normalizeSubscriptionModules({
                    ...resolvePlanModules(planKey),
                    ...(state.data.subscriptionModules || {})
                });
                const _addonRows = Object.entries(SUBSCRIPTION_ADDONS).map(([k, a]) => buildAddonRow(k, a, _initModules[k], _currency)).join('');

            const body = `
                <div style="display:flex;flex-direction:column;gap:1rem;">

                    <!-- Trial banner -->
                    <div style="display:flex;align-items:center;gap:.75rem;padding:.85rem 1rem;background:linear-gradient(135deg,rgba(34,197,94,.08),rgba(0,200,190,.05));border:1.5px solid rgba(34,197,94,.25);border-radius:14px;">
                        <div style="width:32px;height:32px;border-radius:9px;background:rgba(34,197,94,.15);border:1px solid rgba(34,197,94,.3);display:flex;align-items:center;justify-content:center;flex-shrink:0;color:#15803D;">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" style="width:14px;height:14px;"><polyline points="20 6 9 17 4 12"/></svg>
                        </div>
                        <div>
                            <div style="font-size:.85rem;font-weight:700;color:#1A2433;">14 Tage kostenlos testen</div>
                            <div style="font-size:.7rem;color:#7A8AA0;margin-top:.1rem;">Heute CHF 0 — keine automatische Abbuchung ohne aktive Abo-Bestätigung.</div>
                        </div>
                        <span style="margin-left:auto;font-size:.65rem;font-weight:700;padding:.18rem .55rem;border-radius:99px;background:rgba(34,197,94,.12);color:#15803D;border:1px solid rgba(34,197,94,.25);white-space:nowrap;flex-shrink:0;">Gratis starten</span>
                    </div>

                    <!-- Plan-Übersicht (nur Info, KEINE Auswahl — Paket wird erst nach der Testphase gewählt) -->
                    <div style="display:flex;flex-direction:column;gap:.55rem;">
                        <div style="display:flex;align-items:baseline;justify-content:space-between;gap:.5rem;flex-wrap:wrap;">
                            <span style="font-size:.7rem;font-weight:700;color:#7A8AA0;text-transform:uppercase;letter-spacing:.08em;">Unsere Pläne</span>
                            <span style="font-size:.62rem;color:#7A8AA0;">Auswahl erst nach der Testphase — jetzt nichts festlegen</span>
                        </div>
                        <div style="display:grid;grid-template-columns:repeat(auto-fit,minmax(150px,1fr));gap:.55rem;align-items:stretch;">
                            ${['core','pro'].map(k => buildFeaturesCard(k, _billingCycle, _currency)).join('')}
                        </div>
                    </div>

                    <!-- Addons (nur sichtbar, wenn der Addon-Katalog Einträge hat — im Single-Plan-Modell leer) -->
                    ${Object.keys(SUBSCRIPTION_ADDONS).length ? `
                    <div style="display:flex;flex-direction:column;gap:.4rem;">
                        <div style="display:flex;align-items:center;justify-content:space-between;margin-bottom:.1rem;">
                            <span style="font-size:.7rem;font-weight:700;color:#7A8AA0;text-transform:uppercase;letter-spacing:.08em;">Inklusive Module</span>
                            <span style="font-size:.62rem;font-weight:600;padding:.1rem .45rem;border-radius:99px;background:rgba(34,197,94,.08);color:#15803D;border:1px solid rgba(34,197,94,.18);">Enthalten</span>
                        </div>
                        ${_addonRows}
                    </div>
                    ` : ''}

                    <!-- Team size -->
                    <div style="background:#FFFFFF;border:1.5px solid rgba(148,163,184,.12);border-radius:14px;padding:.85rem 1rem;" data-seat-wrapper>
                        <div style="display:flex;align-items:center;justify-content:space-between;gap:.75rem;margin-bottom:.5rem;">
                            <div>
                                <p style="font-size:.83rem;font-weight:700;color:#1A2433;">Teamgrösse</p>
                                <p style="font-size:.67rem;color:#7A8AA0;margin-top:.1rem;">Personen im CRM (inkl. dir)</p>
                            </div>
                            <div style="display:flex;align-items:center;gap:.65rem;">
                                <button type="button" data-seat-plus
                                    style="width:28px;height:28px;border-radius:8px;background:rgba(0,200,190,.12);border:1.5px solid rgba(0,200,190,.25);color:#00C8BE;font-size:1rem;font-weight:700;cursor:pointer;display:flex;align-items:center;justify-content:center;line-height:1;"
                                    onmouseover="this.style.background='rgba(0,200,190,.22)'" onmouseout="this.style.background='rgba(0,200,190,.12)'">+</button>
                                <span style="font-size:1.1rem;font-weight:800;color:#1A2433;font-family:'Plus Jakarta Sans',sans-serif;min-width:1.5rem;text-align:center;" data-seat-count>${_employeeCount}</span>
                                <span style="font-size:.72rem;color:#7A8AA0;">Personen</span>
                            </div>
                        </div>
                        <p style="font-size:.67rem;color:#7A8AA0;margin-bottom:.4rem;" data-seat-hint></p>
                        <div data-seat-invite-empty style="font-size:.72rem;color:#7A8AA0;padding:.45rem .65rem;border:1px dashed rgba(148,163,184,.12);border-radius:8px;text-align:center;">Noch keine Einladungen.</div>
                        <div style="display:flex;flex-direction:column;gap:.4rem;" data-seat-invite-list></div>
                        <p style="font-size:.63rem;color:#4A6080;margin-top:.35rem;">Für jede zusätzliche Person Name und E-Mail eintragen.</p>
                    </div>

                    <!-- Kein Paket-/Zahlweise-Auswahl während der Gratis-Testphase.
                         Plan & Abrechnung wählt der Kunde nach den 14 Tagen im Dashboard. -->
                    <p style="font-size:.66rem;color:#7A8AA0;text-align:center;line-height:1.5;margin-top:.1rem;">
                        Nach der 14-tägigen Testphase wählst du Plan &amp; Zahlweise — jederzeit kündbar. Preise exkl. MWST.
                    </p>

                </div>
            `;
                return body;
            };
            const body = buildFeaturesBody();
            const card = createFormCard('Pläne & Teamgrösse', body, (form) => {
                const selectedPlan = normalizeSubscriptionPlan(form.querySelector('input[name="subscription-plan"]:checked')?.value || planKey);
                const selectedModules = normalizeSubscriptionModules({
                    ...initialModules,
                    ...Object.fromEntries(Array.from(form.querySelectorAll('[data-addon-toggle]')).map(input => [input.dataset.addonToggle, input.checked]))
                });
                const paidRoles = getPaidRolesForModules(selectedModules);
                const seatRows = getSeatInviteRows(form).filter(row => row.name || row.email);
                const incompleteRows = seatRows.filter(row => (row.name || row.email) && (!row.name || !row.email));
                if (incompleteRows.length) {
                    setStatus('Bitte Name und E-Mail für jede zusätzliche Person eintragen.', true);
                    return;
                }
                const duplicateSeatEmails = getDuplicateEmails(seatRows);
                if (duplicateSeatEmails.length) {
                    setStatus(`Doppelte Team-E-Mails erkannt: ${duplicateSeatEmails.join(', ')}`, true);
                    return;
                }
                const selfInviteEmails = getSelfInviteEmails(seatRows, state.data.account?.email);
                if (selfInviteEmails.length) {
                    setStatus('Deine eigene E-Mail muss nicht als zusätzlicher Seat eingetragen werden.', true);
                    return;
                }
                const paidInvites = collectSeatInvites(form, paidRoles);
                const supportFromSeats = collectSupportSeatInvites(form, paidRoles);
                const normalizedEmployees = normalizeEmployeeCount(paidInvites.length + 1, selectedPlan);
                const selectedBilling = normalizeBillingCycle(form.querySelector('[data-billing-cycle].is-active')?.dataset.billingCycle || billingCycle);
                state.data.subscriptionPlan = selectedPlan;
                state.data.subscriptionModules = selectedModules;
                state.data.subscriptionBillingCycle = selectedBilling;
                state.data.employeeCount = normalizedEmployees;
                state.data.hasTeam = normalizedEmployees > 1;
                const supportInvites = (state.data.teamInvites || []).filter(invite => !paidRoles.includes(invite.role));
                state.data.teamInvites = normalizeInviteList([...paidInvites, ...supportFromSeats, ...supportInvites]);
                state.data.features = buildSubscriptionFeatures(state.data.subscriptionModules);
                saveState();
                disableForm(form);
                const addonsLabel = getAddonLabels(selectedModules);
                const addonText = addonsLabel.length ? ` + ${addonsLabel.join(', ')}` : '';
                addUserMessage(`CRM Basis${addonText}${selectedBilling === 'year' ? ' · jährlich (-10%)' : ''}`);
                goToNextStep();
            }, {
                // Kein "Plan später wählen"-Skip mehr: In der Registrierung wird ohnehin kein Paket
                // ausgewählt (Info-Übersicht). Nur "Zurück" und "Weiter". Default-Plan (core) bleibt im State.
                className: 'scroll-card'
            });
            card.classList.add('chat-card--scroll');
            const priceCard = document.createElement('div');
            priceCard.className = 'live-preview-card text-sm text-slate-200';
            priceCard.innerHTML = priceSummaryCard;
            const planInputs = Array.from(card.querySelectorAll('input[name="subscription-plan"]'));
            const planCards = Array.from(card.querySelectorAll('[data-subscription-plan]'));
            const billingButtons = Array.from(card.querySelectorAll('[data-billing-cycle]'));
            const billingLabelEl = priceCard.querySelector('[data-billing-label]');
            const primaryLabelEl = priceCard.querySelector('[data-subscription-primary-label]');
            const totalEl = priceCard.querySelector('[data-subscription-total]');
            const secondaryRowEl = priceCard.querySelector('[data-subscription-secondary-row]');
            const secondaryLabelEl = priceCard.querySelector('[data-subscription-secondary-label]');
            const secondaryAmountEl = priceCard.querySelector('[data-subscription-secondary-amount]');
            const secondarySuffixEl = priceCard.querySelector('[data-subscription-secondary-suffix]');
            const planCostEl = priceCard.querySelector('[data-cost-plan]');
            const planCostLabelEl = priceCard.querySelector('[data-cost-plan-label]');
            const addonCostEl = priceCard.querySelector('[data-cost-addons]');
            const addonLabelEl = priceCard.querySelector('[data-cost-addons-label]');
            const addonSummaryEl = card.querySelector('[data-addon-summary]');
            const seatLabelEl = priceCard.querySelector('[data-cost-seats-label]');
            const seatCostEl = priceCard.querySelector('[data-cost-seats]');
            const totalCostEl = priceCard.querySelector('[data-cost-total]');
            const yearlyCostEl = priceCard.querySelector('[data-cost-yearly]');
            const seatCountEl = card.querySelector('[data-seat-count]');
            const addSeatBtn = card.querySelector('[data-seat-plus]');
            const seatInviteList = card.querySelector('[data-seat-invite-list]');
            const seatInviteEmpty = card.querySelector('[data-seat-invite-empty]');
            const seatHint = card.querySelector('[data-seat-hint]');
            const featureToggles = Array.from(card.querySelectorAll('[data-action="toggle-features"]'));
            const addonInputs = Array.from(card.querySelectorAll('[data-addon-toggle]'));

            const readAddonSelection = () => {
                const next = { ...initialModules };
                addonInputs.forEach(input => {
                    next[input.dataset.addonToggle] = input.checked;
                });
                return normalizeSubscriptionModules(next);
            };
            const syncPlanCardPrices = (cycle) => {
                planCards.forEach(cardEl => {
                    const key = cardEl.dataset.subscriptionPlan;
                    const info = getSubscriptionPlanInfo(key);
                    const price = cycle === 'year'
                        ? Math.round(info.price * (1 - SUBSCRIPTION_ANNUAL_DISCOUNT))
                        : info.price;
                    const priceEl = cardEl.querySelector('[data-plan-price]');
                    const labelEl = cardEl.querySelector('[data-plan-price-label]');
                    if (priceEl) priceEl.textContent = formatCurrency(price, currency);
                    if (labelEl) labelEl.textContent = cycle === 'year' ? '/Nutzer·Mt (-10%)' : '/Nutzer·Mt';
                });
            };
            const setSeatCount = (value) => {
                if (seatCountEl) seatCountEl.textContent = value.toString();
            };
            const setBillingToggle = (cycle) => {
                billingButtons.forEach(btn => {
                    const active = btn.dataset.billingCycle === cycle;
                    btn.classList.toggle('is-active', active);
                });
                if (billingLabelEl) {
                    billingLabelEl.textContent = cycle === 'year' ? 'Jährlich (-10%)' : 'Monatlich';
                }
                syncPlanCardPrices(cycle);
            };
            const updateAddonSummary = (modules) => {
                if (!addonSummaryEl) return;
                const labels = getAddonLabels(modules);
                addonSummaryEl.textContent = labels.length ? labels.join(', ') : 'Alle Module enthalten';
            };
            featureToggles.forEach(btn => {
                btn.addEventListener('click', (event) => {
                    event.preventDefault();
                    event.stopPropagation();
                    const cardEl = btn.closest('.subscription-card');
                    const extraList = cardEl?.querySelector('[data-extra-features]');
                    if (!extraList) return;
                    const isOpen = !extraList.classList.contains('hidden');
                    extraList.classList.toggle('hidden', isOpen);
                    const count = btn.dataset.extraCount || extraList.children.length.toString();
                    btn.textContent = isOpen ? `+ ${count} weitere` : 'Weniger';
                    btn.setAttribute('aria-expanded', (!isOpen).toString());
                });
            });
            const addSeatInviteRow = (data = {}) => {
                if (!seatInviteList) return;
                const row = document.createElement('div');
                row.style.cssText = 'display:grid;grid-template-columns:1fr 1fr auto;gap:.5rem;align-items:end;background:#FFFFFF;border:1px solid rgba(148,163,184,.14);border-radius:10px;padding:.7rem .8rem;';
                row.dataset.seatInviteRow = 'true';
                row.dataset.inviteRole = data.role || 'Mitarbeiter';
                row.innerHTML = `
                    <div>
                        <label style="display:block;font-size:.68rem;font-weight:600;color:#7A8AA0;margin-bottom:.25rem;">Name</label>
                        <input data-seat-field="name" type="text"
                            style="background:#FFFFFF;border:1.5px solid rgba(148,163,184,.16);color:#1A2433;border-radius:8px;padding:.45rem .65rem;font-size:.8rem;font-family:inherit;width:100%;outline:none;"
                            value="${escapeAttr(data.name || '')}" placeholder="Max Mustermann"
                            onfocus="this.style.borderColor='rgba(0,200,190,.5)'" onblur="this.style.borderColor='rgba(148,163,184,.16)'">
                    </div>
                    <div>
                        <label style="display:block;font-size:.68rem;font-weight:600;color:#7A8AA0;margin-bottom:.25rem;">E-Mail</label>
                        <input data-seat-field="email" type="text" inputmode="email"
                            style="background:#FFFFFF;border:1.5px solid rgba(148,163,184,.16);color:#1A2433;border-radius:8px;padding:.45rem .65rem;font-size:.8rem;font-family:inherit;width:100%;outline:none;"
                            value="${escapeAttr(data.email || '')}" placeholder="mail@firma.ch"
                            onfocus="this.style.borderColor='rgba(0,200,190,.5)'" onblur="this.style.borderColor='rgba(148,163,184,.16)'">
                    </div>
                    <button type="button" data-action="remove-seat"
                        style="padding:.42rem .7rem;border-radius:8px;background:rgba(239,68,68,.08);border:1px solid rgba(239,68,68,.2);color:#DC2626;font-size:.72rem;font-weight:600;cursor:pointer;font-family:inherit;white-space:nowrap;"
                        onmouseover="this.style.background='rgba(239,68,68,.16)'" onmouseout="this.style.background='rgba(239,68,68,.08)'">×</button>
                `;
                row.querySelector('[data-action="remove-seat"]').addEventListener('click', () => {
                    row.remove();
                    if (seatInviteEmpty) {
                        seatInviteEmpty.classList.toggle('hidden', seatInviteList.children.length > 0);
                    }
                    syncTotals();
                });
                seatInviteList.appendChild(row);
                if (seatInviteEmpty) {
                    seatInviteEmpty.classList.add('hidden');
                }
            };
            const syncSeatInvitesFromState = (selectedPlan, modules) => {
                if (!seatInviteList) return;
                seatInviteList.innerHTML = '';
                const paidRoles = getPaidRolesForModules(modules);
                const paidInvites = (state.data.teamInvites || []).filter(invite => paidRoles.includes(invite.role));
                paidInvites.forEach(invite => addSeatInviteRow(invite));
                const plannedInvites = Math.max(0, employeeCount - 1);
                const missing = Math.max(0, plannedInvites - paidInvites.length);
                for (let i = 0; i < missing; i += 1) {
                    addSeatInviteRow();
                }
                if (seatInviteEmpty) {
                    seatInviteEmpty.classList.toggle('hidden', seatInviteList.children.length > 0);
                }
            };
            const syncDraft = () => {
                const selectedPlan = normalizeSubscriptionPlan(planInputs.find(input => input.checked)?.value || planKey);
                const selectedModules = readAddonSelection();
                const paidRoles = getPaidRolesForModules(selectedModules);
                const paidSeatRows = getPaidSeatInviteRows(card, paidRoles);
                const seatValue = normalizeEmployeeCount(paidSeatRows.length + 1, selectedPlan);
                const selectedBilling = normalizeBillingCycle(card.querySelector('[data-billing-cycle].is-active')?.dataset.billingCycle || billingCycle);
                state.data.subscriptionPlan = selectedPlan;
                state.data.subscriptionModules = selectedModules;
                state.data.subscriptionBillingCycle = selectedBilling;
                state.data.employeeCount = seatValue;
                state.data.hasTeam = seatValue > 1;
                const supportInvites = (state.data.teamInvites || []).filter(invite => !paidRoles.includes(invite.role));
                const paidInvites = collectSeatInvites(card, paidRoles);
                const supportFromSeats = collectSupportSeatInvites(card, paidRoles);
                state.data.teamInvites = normalizeInviteList([
                    ...paidInvites,
                    ...supportFromSeats,
                    ...supportInvites
                ]);
                state.data.features = buildSubscriptionFeatures(state.data.subscriptionModules);
                queueLocalSave();
                updateLivePreview();
            };
            const syncTotals = () => {
                const activeBilling = normalizeBillingCycle(card.querySelector('[data-billing-cycle].is-active')?.dataset.billingCycle || billingCycle);
                const selectedPlan = normalizeSubscriptionPlan(planInputs.find(input => input.checked)?.value || planKey);
                const selectedModules = readAddonSelection();
                planCards.forEach(option => {
                    option.classList.toggle('selected', option.dataset.subscriptionPlan === selectedPlan);
                });
                syncPlanCardPrices(activeBilling);
                const paidRoles = getPaidRolesForModules(selectedModules);
                const paidSeatRows = getPaidSeatInviteRows(card, paidRoles);
                const seatValue = normalizeEmployeeCount(paidSeatRows.length + 1, selectedPlan);
                setSeatCount(seatValue);
                if (addSeatBtn) {
                    addSeatBtn.disabled = seatValue >= seatMax;
                }
                const extraSeatsValue = getExtraSeatCount(seatValue, selectedPlan);
                const extraSeatPrice = extraSeatsValue * getSubscriptionPlanInfo(selectedPlan).price;
                const addonTotalValue = getSubscriptionAddonTotal(selectedModules, seatValue);
                const planPrice = getSubscriptionPlanInfo(selectedPlan).price;
                const monthlyValue = planPrice + extraSeatPrice + addonTotalValue;
                const annualValue = Math.round(monthlyValue * 12 * (1 - SUBSCRIPTION_ANNUAL_DISCOUNT));
                const discountFactor = activeBilling === 'year' ? (1 - SUBSCRIPTION_ANNUAL_DISCOUNT) : 1;
                const discountedPlan = Math.round(planPrice * discountFactor);
                const discountedSeats = Math.round(extraSeatPrice * discountFactor);
                const discountedAddons = Math.round(addonTotalValue * discountFactor);
                const discountedMonthly = discountedPlan + discountedSeats + discountedAddons;
                const addonLabels = getAddonLabels(selectedModules);

                if (seatLabelEl) {
                    const seatUnit = Math.round(getSubscriptionPlanInfo(selectedPlan).price * discountFactor);
                    const seatUnitLabel = formatCurrency(seatUnit, currency);
                    const suffix = activeBilling === 'year' ? ' (-10%)' : '';
                    seatLabelEl.textContent = extraSeatsValue
                        ? `Zusätzliche Plätze (${extraSeatsValue} × ${seatUnitLabel}${suffix})`
                        : `Zusätzliche Plätze (pro MA ${seatUnitLabel}${suffix})`;
                }
                if (seatHint) {
                    // Bewusst ohne Preis: Während der Gratis-Testphase wird nichts abgerechnet.
                    seatHint.textContent = extraSeatsValue > 0
                        ? `${extraSeatsValue} zusätzliche ${extraSeatsValue === 1 ? 'Person' : 'Personen'} zum Einladen (optional).`
                        : 'Lade optional weitere Personen zu deinem Team ein.';
                }
                if (primaryLabelEl) {
                    primaryLabelEl.textContent = 'Gesamt / Monat';
                }
                if (totalEl) totalEl.textContent = formatCurrency(discountedMonthly, currency);
                if (secondaryLabelEl) {
                    secondaryLabelEl.textContent = activeBilling === 'year' ? 'Monatlich (umgerechnet):' : 'Jährlich:';
                }
                if (secondaryAmountEl) {
                    secondaryAmountEl.textContent = formatCurrency(
                        activeBilling === 'year' ? discountedMonthly : annualValue,
                        currency
                    );
                }
                if (secondarySuffixEl) {
                    secondarySuffixEl.textContent = activeBilling === 'year' ? '' : ' (-10%)';
                }
                if (secondaryRowEl) secondaryRowEl.classList.remove('hidden');
                if (planCostEl) planCostEl.textContent = formatCurrency(discountedPlan, currency);
                if (planCostLabelEl) planCostLabelEl.textContent = `${getSubscriptionPlanInfo(selectedPlan).label} Modul`;
                if (addonCostEl) addonCostEl.textContent = formatCurrency(discountedAddons, currency);
                if (addonLabelEl) addonLabelEl.textContent = addonLabels.length
                    ? `Inklusive Module (${addonLabels.join(', ')})`
                    : 'Inklusive Module';
                if (seatCostEl) seatCostEl.textContent = formatCurrency(discountedSeats, currency);
                if (totalCostEl) totalCostEl.textContent = formatCurrency(discountedMonthly, currency);
                if (yearlyCostEl) yearlyCostEl.textContent = formatCurrency(annualValue, currency);
                updateAddonSummary(selectedModules);
                syncDraft();
            };

            planInputs.forEach(input => input.addEventListener('change', syncTotals));
            addonInputs.forEach(input => {
                input.addEventListener('change', () => {
                    updateAddonCardState(input.closest('.addon-card'), input.checked);
                    syncTotals();
                });
            });
            if (seatInviteList) {
                seatInviteList.addEventListener('input', syncTotals);
                seatInviteList.addEventListener('change', syncTotals);
            }
            addSeatBtn?.addEventListener('click', () => {
                const current = getSeatInviteRows(card).length + 1;
                if (current >= seatMax) return;
                addSeatInviteRow();
                syncTotals();
            });
            billingButtons.forEach(btn => {
                btn.addEventListener('click', () => {
                    const cycle = normalizeBillingCycle(btn.dataset.billingCycle || 'month');
                    state.data.subscriptionBillingCycle = cycle;
                    setBillingToggle(cycle);
                    syncTotals();
                });
            });
            setBillingToggle(billingCycle);
            syncSeatInvitesFromState(planKey, initialModules);
            syncTotals();
            addCard(card);
            // Keine Preis-/Kosten-Seitenleiste während der Gratis-Testphase: In der Registrierung
            // wird kein Paket festgelegt, daher auch keine "Gesamt/Monat"-Aufstellung zeigen.
            setPriceSummaryAside(null);
        };

        const renderPipelineStep = () => {
            const pipeline = state.data.pipeline || { template: DEFAULT_PIPELINE_TEMPLATE, stages: [] };
            const templateOptions = Object.entries(PIPELINE_TEMPLATES).map(([key, info]) => `
                <option value="${key}" ${pipeline.template === key ? 'selected' : ''}>${info.label}</option>
            `).join('');
            const _s = 'background:#FFFFFF;border:1.5px solid rgba(148,163,184,.16);color:#1A2433;border-radius:10px;padding:.55rem .75rem;font-size:.82rem;font-family:inherit;width:100%;outline:none;transition:border-color .15s,box-shadow .15s;';
            const _f = 'this.style.borderColor="rgba(0,200,190,.5)";this.style.boxShadow="0 0 0 3px rgba(0,200,190,.1)"';
            const _b = 'this.style.borderColor="rgba(148,163,184,.16)";this.style.boxShadow="none"';
            const body = `
                <div style="display:flex;flex-direction:column;gap:.85rem;">

                    <div style="background:rgba(0,200,190,.05);border:1px solid rgba(0,200,190,.15);border-radius:12px;padding:.85rem 1rem;">
                        <p style="font-size:.75rem;font-weight:600;color:#00C8BE;margin-bottom:.2rem;">Was ist die Pipeline?</p>
                        <p style="font-size:.72rem;color:#7A8AA0;line-height:1.5;">Die Pipeline zeigt, in welchem Stadium sich deine Leads befinden. Du kannst sie jederzeit anpassen.</p>
                    </div>

                    <div>
                        <label style="display:block;font-size:.7rem;font-weight:600;color:#7A8AA0;margin-bottom:.28rem;letter-spacing:.02em;">Template wählen</label>
                        <select name="pipeline-template" style="${_s}" onfocus="${_f}" onblur="${_b}">
                            ${templateOptions}
                        </select>
                    </div>

                    <div>
                        <label style="display:block;font-size:.7rem;font-weight:600;color:#7A8AA0;margin-bottom:.28rem;letter-spacing:.02em;">Stages <span style="color:#7A8AA0;font-weight:400;">(kommagetrennt, anpassbar)</span></label>
                        <textarea name="pipeline-stages" rows="3"
                            placeholder="Neuer Lead, Qualifiziert, Angebot gesendet, Gewonnen, Verloren"
                            style="background:#FFFFFF;border:1.5px solid rgba(148,163,184,.16);color:#1A2433;border-radius:10px;padding:.6rem .75rem;font-size:.82rem;font-family:inherit;width:100%;outline:none;resize:vertical;transition:border-color .15s,box-shadow .15s;line-height:1.5;"
                            onfocus="${_f}" onblur="${_b}">${escapeHtml((pipeline.stages || []).join(', '))}</textarea>
                        <p style="font-size:.68rem;color:#7A8AA0;margin-top:.25rem;">Tipp: Stages werden beim Speichern automatisch getrennt.</p>
                    </div>

                </div>
            `;
            const card = createFormCard('Pipeline Template', body, (form) => {
                const template = form.querySelector('[name="pipeline-template"]').value;
                const stagesRaw = form.querySelector('[name="pipeline-stages"]').value;
                const stages = stagesRaw.split(',').map(stage => stage.trim()).filter(Boolean);
                state.data.pipeline = {
                    template,
                    stages: stages.length ? stages : (PIPELINE_TEMPLATES[template]?.stages || [])
                };
                saveState();
                disableForm(form);
                addUserMessage(`${PIPELINE_TEMPLATES[template]?.label || 'Pipeline'} · ${state.data.pipeline.stages.length} Stages`);
                goToNextStep();
            }, {
                allowSkip: true,
                skipLabel: 'Später anpassen',
                quickFinish: true,
                quickFinishLabel: '⚡ Rest überspringen & Konto erstellen',
                onSkip: (form) => {
                    const template = form.querySelector('[name="pipeline-template"]').value;
                    state.data.pipeline = {
                        template,
                        stages: PIPELINE_TEMPLATES[template]?.stages || []
                    };
                    saveState();
                    addUserMessage('Pipeline übersprungen');
                }
            });
            const templateSelect = card.querySelector('[name="pipeline-template"]');
            const stagesInput = card.querySelector('[name="pipeline-stages"]');
            if (templateSelect && stagesInput) {
                const syncDraft = () => {
                    const template = templateSelect.value;
                    const stages = stagesInput.value.split(',').map(stage => stage.trim()).filter(Boolean);
                    state.data.pipeline = {
                        template,
                        stages: stages.length ? stages : (PIPELINE_TEMPLATES[template]?.stages || [])
                    };
                    queueLocalSave();
                    updateLivePreview();
                };
                templateSelect.addEventListener('change', () => {
                    const template = templateSelect.value;
                    const stages = PIPELINE_TEMPLATES[template]?.stages || [];
                    stagesInput.value = stages.join(', ');
                    syncDraft();
                });
                stagesInput.addEventListener('input', syncDraft);
            }
            addCard(card);
        };

        const mergePartnerInvitesFromProducts = (products = []) => {
            const partnerInvitesFromProducts = (products || [])
                .map(product => ({
                    name: (product.partnerName || '').toString().trim(),
                    email: (product.partnerEmail || '').toString().trim().toLowerCase(),
                    role: 'Partner'
                }))
                .filter(invite => invite.email);
            if (!partnerInvitesFromProducts.length) return;
            state.data.teamInvites = normalizeInviteList([
                ...(state.data.teamInvites || []),
                ...partnerInvitesFromProducts
            ]);
            queueLocalSave();
            updateLivePreview();
        };

        const renderProductsStep = () => {
            const showCommissions = shouldAskCommissions();
            const body = `
                <div style="display:flex;flex-direction:column;gap:.85rem;">

                    <div style="display:flex;align-items:center;justify-content:space-between;gap:1rem;flex-wrap:wrap;">
                        <div>
                            <p style="font-size:.78rem;font-weight:600;color:#56657A;">Dienstleistungen, Produkte oder Pakete</p>
                            <p style="font-size:.7rem;color:#7A8AA0;margin-top:.1rem;">Optional — du kannst jederzeit ergänzen.</p>
                        </div>
                        <!-- Button-Gruppe: umbruchfähig, damit der per JS ergänzte CSV-Import-Button
                             auf schmalen Karten unter den Add-Button rutscht statt rechts abzuschneiden. -->
                        <div style="display:flex;flex-wrap:wrap;align-items:center;gap:.5rem;justify-content:flex-end;">
                            <button type="button" data-action="add-product"
                                style="display:inline-flex;align-items:center;gap:.4rem;padding:.5rem 1rem;border-radius:10px;background:rgba(0,200,190,.12);color:#00C8BE;border:1px solid rgba(0,200,190,.25);font-size:.78rem;font-weight:700;cursor:pointer;font-family:inherit;white-space:nowrap;transition:background .12s;"
                                onmouseover="this.style.background='rgba(0,200,190,.2)'" onmouseout="this.style.background='rgba(0,200,190,.12)'">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" style="width:13px;height:13px;"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>
                                Produkt hinzufügen
                            </button>
                        </div>
                    </div>

                    <div data-catalog-empty style="display:flex;flex-direction:column;align-items:center;gap:.5rem;padding:1.75rem;border:1.5px dashed rgba(148,163,184,.12);border-radius:12px;text-align:center;">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" style="width:28px;height:28px;color:#7A8AA0;"><path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 0 1-8 0"/></svg>
                        <p style="font-size:.78rem;color:#7A8AA0;">Noch keine Produkte. Klick auf "Produkt hinzufügen".</p>
                    </div>

                    <div data-catalog-products style="display:flex;flex-direction:column;gap:.6rem;"></div>

                </div>
            `;
            const card = createFormCard('Produktkatalog', body, (form) => {
                const container = form.querySelector('[data-catalog-products]');
                const rawProducts = collectCatalogProductsRaw(container);
                const products = rawProducts.filter(product => {
                    const name = (product.name || '').trim();
                    const price = (product.price || '').toString().trim();
                    return name || price;
                });
                const invalidDeductions = products.some(product => (
                    product.commissionBase === 'profit'
                    && (!Array.isArray(product.commissionDeductions) || product.commissionDeductions.length === 0)
                ));
                if (invalidDeductions) {
                    setStatus('Bitte mindestens einen Abzug erfassen, wenn die Provisionsbasis auf Gewinn steht.');
                    return;
                }
                setStatus('');
                state.data.salesTypes = deriveSalesTypesFromProducts(products);
                state.data.products = products;
                mergePartnerInvitesFromProducts(products);
                saveState();
                disableForm(form);
                addUserMessage(`${products.length} Produkte gespeichert`);
                goToNextStep();
            }, {
                allowSkip: true,
                skipLabel: 'Später erfassen',
                onSkip: () => {
                    saveState();
                    addUserMessage('Produkte übersprungen');
                },
                className: 'chat-card--scroll chat-card--products'
            });
            const form = card.querySelector('form');
            const addButton = form.querySelector('[data-action="add-product"]');
            const container = form.querySelector('[data-catalog-products]');
            const emptyEl = form.querySelector('[data-catalog-empty]');
            if (Array.isArray(state.data.products) && state.data.products.length > 0) {
                state.data.products.forEach(product => addCatalogProductRow(container, emptyEl, product, showCommissions));
            } else {
                addCatalogProductRow(container, emptyEl, {}, showCommissions);
            }
            updateCatalogEmpty(container, emptyEl);
            if (addButton) {
                addButton.addEventListener('click', () => {
                    addCatalogProductRow(container, emptyEl, {}, showCommissions);
                });
            }

            // ── Produktkatalog-Import (CSV/Excel-Export) ──────────────────────────
            // Robuster CSV-Parser (Quotes + Delimiter-Autoerkennung Komma/Semikolon).
            const parseCsvRows = (text) => {
                const nl = text.indexOf('\n');
                const firstLine = nl >= 0 ? text.slice(0, nl) : text;
                const delim = (firstLine.split(';').length > firstLine.split(',').length) ? ';' : ',';
                const rows = []; let cur = [], field = '', inQuotes = false;
                for (let i = 0; i < text.length; i++) {
                    const c = text[i];
                    if (inQuotes) {
                        if (c === '"') { if (text[i + 1] === '"') { field += '"'; i++; } else inQuotes = false; }
                        else field += c;
                    } else if (c === '"') { inQuotes = true; }
                    else if (c === delim) { cur.push(field); field = ''; }
                    else if (c === '\n') { cur.push(field); rows.push(cur); cur = []; field = ''; }
                    else if (c !== '\r') { field += c; }
                }
                if (field.length || cur.length) { cur.push(field); rows.push(cur); }
                return rows.filter(r => r.some(cell => (cell || '').trim() !== ''));
            };
            const HEADER_ALIASES = {
                name: ['name', 'produkt', 'product', 'bezeichnung', 'titel', 'title', 'artikel', 'leistung', 'dienstleistung'],
                price: ['price', 'preis', 'betrag', 'amount', 'kosten', 'chf', 'preis chf', 'netto', 'preis netto'],
                description: ['description', 'beschreibung', 'details', 'info', 'text', 'beschrieb'],
                vatRate: ['vat', 'mwst', 'vatrate', 'mwst-satz', 'mwstsatz', 'steuer', 'tax', 'vat %', 'mwst %']
            };
            const matchColumn = (header) => {
                const h = (header || '').trim().toLowerCase();
                for (const field of Object.keys(HEADER_ALIASES)) { if (HEADER_ALIASES[field].includes(h)) return field; }
                return null;
            };
            const importProductsFromText = (text) => {
                const rows = parseCsvRows(text);
                if (!rows.length) { setStatus('Keine Zeilen in der Datei gefunden.'); return; }
                let headerMap = {}; let hasHeader = false;
                rows[0].forEach((cell, idx) => { const f = matchColumn(cell); if (f && headerMap[f] == null) { headerMap[f] = idx; hasHeader = true; } });
                let dataRows;
                if (hasHeader) { dataRows = rows.slice(1); }
                else { headerMap = { name: 0, price: 1, description: 2 }; dataRows = rows; }
                if (headerMap.name == null) headerMap.name = 0;
                if (headerMap.price == null) headerMap.price = 1;
                let added = 0;
                dataRows.forEach(r => {
                    const name = (r[headerMap.name] || '').trim();
                    if (!name) return;
                    const priceRaw = headerMap.price != null ? (r[headerMap.price] || '').toString().trim() : '';
                    const price = priceRaw.replace(/[^0-9.,-]/g, '').replace(/\.(?=\d{3}\b)/g, '').replace(',', '.');
                    const description = headerMap.description != null ? (r[headerMap.description] || '').toString().trim() : '';
                    const product = { name, price, description };
                    if (headerMap.vatRate != null) {
                        const v = (r[headerMap.vatRate] || '').toString().trim().replace(/[^0-9.,]/g, '').replace(',', '.');
                        if (v) product.vatRate = v;
                    }
                    addCatalogProductRow(container, emptyEl, product, showCommissions);
                    added++;
                });
                updateCatalogEmpty(container, emptyEl);
                if (typeof syncDraft === 'function') syncDraft();
                setStatus(added ? `${added} Produkte importiert — bitte prüfen und ergänzen.` : 'Keine gültigen Produkte gefunden (erste Spalte = Name, zweite = Preis).');
            };
            if (addButton && addButton.parentElement && !addButton.parentElement.querySelector('[data-action="import-products"]')) {
                const fileInput = document.createElement('input');
                fileInput.type = 'file'; fileInput.accept = '.csv,.tsv,.txt'; fileInput.style.display = 'none';
                const importBtn = document.createElement('button');
                importBtn.type = 'button'; importBtn.dataset.action = 'import-products';
                importBtn.style.cssText = 'display:inline-flex;align-items:center;gap:.4rem;padding:.5rem 1rem;border-radius:10px;background:rgba(148,163,184,.1);color:#475569;border:1px solid rgba(148,163,184,.25);font-size:.78rem;font-weight:700;cursor:pointer;font-family:inherit;white-space:nowrap;';
                importBtn.textContent = '⬆︎ CSV importieren';
                importBtn.title = 'Excel/Numbers als CSV exportieren und hier hochladen. Spalten: Name, Preis, Beschreibung, MwSt.';
                importBtn.addEventListener('click', () => fileInput.click());
                fileInput.addEventListener('change', () => {
                    const file = fileInput.files && fileInput.files[0]; if (!file) return;
                    if (/\.xlsx?$/i.test(file.name)) { setStatus('Bitte die Excel-Datei als CSV exportieren (Datei → Speichern unter → CSV UTF-8) und erneut hochladen.'); fileInput.value = ''; return; }
                    const reader = new FileReader();
                    reader.onload = () => { try { importProductsFromText(String(reader.result || '')); } catch (e) { console.error('CSV-Import', e); setStatus('Import fehlgeschlagen: ' + (e.message || e)); } fileInput.value = ''; };
                    reader.readAsText(file, 'utf-8');
                });
                addButton.parentElement.appendChild(importBtn);
                addButton.parentElement.appendChild(fileInput);
            }

            const syncDraft = () => {
                const rawProducts = collectCatalogProductsRaw(container);
                state.data.products = rawProducts;
                state.data.salesTypes = deriveSalesTypesFromProducts(rawProducts);
                queueLocalSave();
                updateLivePreview();
            };
            container?.addEventListener('input', syncDraft);
            container?.addEventListener('change', syncDraft);
            addCard(card);
        };

        const renderTeamStep = () => {
            const products = Array.isArray(state.data.products) ? state.data.products : [];
            mergePartnerInvitesFromProducts(products);
            const invites = Array.isArray(state.data.teamInvites) ? state.data.teamInvites : [];
            const planKey = normalizeSubscriptionPlan(state.data.subscriptionPlan);
            const baseEmployeeCount = normalizeEmployeeCount(state.data.employeeCount, planKey);
            const includedSeats = SUBSCRIPTION_INCLUDED_SEATS[planKey] || 1;
            // Single-Plan-Modell: alle Rollen kosten als Sitz, alle Funktionen aktiv.
            const paidRoles = ['Admin', 'VL', 'Mitarbeiter', 'Accounting', 'Partner'];
            const paidInvites = invites.filter(invite => paidRoles.includes(invite.role));
            const employeeCount = normalizeEmployeeCount(Math.max(baseEmployeeCount, paidInvites.length + 1), planKey);
            const hasTeam = employeeCount > 1;
            const partnerInvites = invites.filter(invite => invite.role === 'Partner');
            const accountingInvites = invites.filter(invite => invite.role === 'Accounting');
            const plannedInvites = Math.max(0, employeeCount - 1);
            const roleHint = 'Rollen: Admin (Vollzugriff), VL (Team Lead), Mitarbeiter (Sales), Accounting (Finance/Backoffice). Alle Rollen zählen als Sitz.';

            const _addBtn = (action, label, color='#00C8BE', bg='rgba(0,200,190,.12)', border='rgba(0,200,190,.25)', hbg='rgba(0,200,190,.2)') =>
                `<button type="button" data-action="${action}"
                    style="display:inline-flex;align-items:center;gap:.35rem;padding:.45rem .9rem;border-radius:10px;background:${bg};color:${color};border:1px solid ${border};font-size:.75rem;font-weight:700;cursor:pointer;font-family:inherit;white-space:nowrap;flex-shrink:0;transition:background .12s;"
                    onmouseover="this.style.background='${hbg}'" onmouseout="this.style.background='${bg}'">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" style="width:12px;height:12px;"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>
                    ${label}
                </button>`;
            const _section = (title, sub, badge, addBtn, emptyAttr, listAttr, hint, extra='') =>
                `<div style="background:#FFFFFF;border:1.5px solid rgba(148,163,184,.12);border-radius:14px;padding:1rem;display:flex;flex-direction:column;gap:.75rem;">
                    <div style="display:flex;align-items:flex-start;justify-content:space-between;gap:.75rem;">
                        <div>
                            <div style="display:flex;align-items:center;gap:.5rem;margin-bottom:.2rem;">
                                <span style="font-size:.85rem;font-weight:700;color:#1A2433;font-family:'Plus Jakarta Sans',sans-serif;">${title}</span>
                                ${badge}
                            </div>
                            <p style="font-size:.7rem;color:#7A8AA0;line-height:1.4;">${sub}</p>
                        </div>
                        ${addBtn}
                    </div>
                    ${extra}
                    <div ${emptyAttr} style="font-size:.75rem;color:#7A8AA0;padding:.6rem .75rem;border:1px dashed rgba(148,163,184,.1);border-radius:8px;text-align:center;">Noch keine Einladungen.</div>
                    <div ${listAttr} style="display:flex;flex-direction:column;gap:.5rem;"></div>
                    <p style="font-size:.67rem;color:#7A8AA0;">${hint}</p>
                </div>`;

            const body = `
                <div style="display:flex;flex-direction:column;gap:.75rem;">

                    ${_section(
                        'Teammitglieder',
                        `Aktuell geplant: <strong style="color:#56657A;">${employeeCount} ${employeeCount === 1 ? 'Sitz' : 'Sitze'}</strong> inkl. dir · Abo enthält ${includedSeats > 1 ? `bis zu ${includedSeats} Sitze` : '1 Sitz'}`,
                        `<span style="font-size:.62rem;font-weight:700;padding:.1rem .45rem;border-radius:99px;background:rgba(0,200,190,.1);color:#00C8BE;border:1px solid rgba(0,200,190,.2);">Sitz-basiert</span>`,
                        _addBtn('add-team-invite','Mitglied hinzufügen'),
                        'data-team-invite-empty', 'data-team-invite-list',
                        `${roleHint}`,
                        `<div style="display:flex;align-items:center;justify-content:space-between;font-size:.7rem;color:#7A8AA0;background:rgba(20,40,70,.025);border:1px solid rgba(148,163,184,.08);border-radius:8px;padding:.45rem .7rem;">
                            <span>Aktuelle Teamgrösse (inkl. dir)</span>
                            <strong style="color:#1A2433;" data-team-size-value>${employeeCount}</strong>
                        </div>`
                    )}

                    <!-- Partner- und Accounting-Sektionen bewusst entfernt: In der Registrierung
                         werden nur Teammitglieder eingeladen. Weitere Rollen (Partner, Accounting)
                         lassen sich später im CRM anlegen und verwalten. -->

                    <p style="font-size:.68rem;color:#7A8AA0;text-align:center;">Einladungen werden nach Abschluss versendet.</p>
                </div>
            `;

            const card = createFormCard('Team einladen', body, (form) => {
                const teamList = form.querySelector('[data-team-invite-list]');
                const partnerList = form.querySelector('[data-partner-invite-list]');
                const accountingList = form.querySelector('[data-accounting-invite-list]');
                const collectRows = (list) => Array.from(list.querySelectorAll('[data-invite-row]')).map(row => {
                    const getValue = (selector) => row.querySelector(selector)?.value?.trim() || '';
                    return {
                        name: getValue('[data-invite-field="name"]'),
                        email: getValue('[data-invite-field="email"]').toLowerCase(),
                        role: row.dataset.inviteRole
                            || row.querySelector('[data-invite-field="role"]')?.value
                            || 'Mitarbeiter'
                    };
                }).filter(item => item.email);
                const payload = [
                    ...collectRows(teamList),
                    ...(partnerList ? collectRows(partnerList) : []),
                    ...(accountingList ? collectRows(accountingList) : [])
                ];
                const duplicateInviteEmails = getDuplicateEmails(payload);
                if (duplicateInviteEmails.length) {
                    setStatus(`Doppelte Einladungen erkannt: ${duplicateInviteEmails.join(', ')}`, true);
                    return;
                }
                const selfInviteEmails = getSelfInviteEmails(payload, state.data.account?.email);
                if (selfInviteEmails.length) {
                    setStatus('Deine eigene E-Mail muss nicht eingeladen werden.', true);
                    return;
                }
                const normalizedInvites = normalizeInviteList(payload);
                const paidInviteCount = normalizedInvites.filter(invite => paidRoles.includes(invite.role)).length;
                const nextEmployeeCount = normalizeEmployeeCount(paidInviteCount + 1, planKey);
                state.data.employeeCount = nextEmployeeCount;
                state.data.hasTeam = nextEmployeeCount > 1;
                state.data.teamInvites = normalizedInvites;
                saveState();
                disableForm(form);
                addUserMessage(normalizedInvites.length ? `${normalizedInvites.length} Einladungen` : 'Keine Einladungen');
                goToNextStep();
            }, {
                allowSkip: true,
                skipLabel: 'Später einladen',
                onSkip: () => {
                    state.data.teamInvites = invites;
                    saveState();
                    addUserMessage('Team-Einladungen übersprungen');
                },
                className: 'chat-card--scroll chat-card--team'
            });

            const teamList = card.querySelector('[data-team-invite-list]');
            const teamEmpty = card.querySelector('[data-team-invite-empty]');
            const partnerList = card.querySelector('[data-partner-invite-list]');
            const partnerEmpty = card.querySelector('[data-partner-invite-empty]');
            const accountingList = card.querySelector('[data-accounting-invite-list]');
            const accountingEmpty = card.querySelector('[data-accounting-invite-empty]');
            const teamSizeValue = card.querySelector('[data-team-size-value]');
            const addInviteRow = (list, emptyEl, roleOptions, data = {}) => {
                const selectedRole = roleOptions.some(option => option.value === data.role)
                    ? data.role
                    : (roleOptions[0]?.value || 'Mitarbeiter');
                const row = document.createElement('div');
                row.style.cssText = 'display:grid;grid-template-columns:1fr 1fr 1fr auto;gap:.5rem;align-items:end;background:#FFFFFF;border:1.5px solid rgba(148,163,184,.14);border-radius:12px;padding:.75rem .85rem;';
                row.dataset.inviteRow = 'true';
                const _inp = 'background:#FFFFFF;border:1.5px solid rgba(148,163,184,.16);color:#1A2433;border-radius:8px;padding:.42rem .65rem;font-size:.8rem;font-family:inherit;width:100%;outline:none;';
                const _lbl = 'display:block;font-size:.68rem;font-weight:600;color:#56657A;margin-bottom:.22rem;';
                const _foc = 'this.style.borderColor="rgba(0,200,190,.5)"';
                const _blu = 'this.style.borderColor="rgba(148,163,184,.16)"';
                row.innerHTML = `
                    <div>
                        <label style="${_lbl}">Name</label>
                        <input data-invite-field="name" type="text" style="${_inp}"
                            value="${escapeAttr(data.name || '')}" placeholder="Max Mustermann"
                            onfocus="${_foc}" onblur="${_blu}">
                    </div>
                    <div>
                        <label style="${_lbl}">E-Mail</label>
                        <input data-invite-field="email" type="text" inputmode="email" style="${_inp}"
                            value="${escapeAttr(data.email || '')}" placeholder="mail@firma.ch"
                            onfocus="${_foc}" onblur="${_blu}">
                    </div>
                    <div>
                        <label style="${_lbl}">Rolle</label>
                        <select data-invite-field="role" style="${_inp}">
                            ${roleOptions.map(option => `
                                <option value="${option.value}" ${option.value === selectedRole ? 'selected' : ''}>${option.label}</option>
                            `).join('')}
                        </select>
                    </div>
                    <button type="button" data-action="remove-invite"
                        style="padding:.42rem .55rem;border-radius:8px;background:rgba(239,68,68,.08);border:1px solid rgba(239,68,68,.2);color:#DC2626;font-size:.82rem;cursor:pointer;font-family:inherit;line-height:1;height:fit-content;align-self:flex-end;"
                        onmouseover="this.style.background='rgba(239,68,68,.16)'" onmouseout="this.style.background='rgba(239,68,68,.08)'">×</button>
                `;
                row.querySelector('[data-action="remove-invite"]').addEventListener('click', () => {
                    row.remove();
                    emptyEl.classList.toggle('hidden', list.children.length > 0);
                    syncDraft();
                });
                list.appendChild(row);
                emptyEl.classList.toggle('hidden', list.children.length > 0);
            };
            const addFixedInviteRow = (list, emptyEl, role, data = {}) => {
                const row = document.createElement('div');
                row.style.cssText = 'display:grid;grid-template-columns:1fr 1fr auto;gap:.5rem;align-items:end;background:#FFFFFF;border:1.5px solid rgba(148,163,184,.14);border-radius:12px;padding:.75rem .85rem;';
                row.dataset.inviteRow = 'true';
                row.dataset.inviteRole = role;
                const _i2 = 'background:#FFFFFF;border:1.5px solid rgba(148,163,184,.16);color:#1A2433;border-radius:8px;padding:.42rem .65rem;font-size:.8rem;font-family:inherit;width:100%;outline:none;';
                const _l2 = 'display:block;font-size:.68rem;font-weight:600;color:#56657A;margin-bottom:.22rem;';
                row.innerHTML = `
                    <div>
                        <label style="${_l2}">Name</label>
                        <input data-invite-field="name" type="text" style="${_i2}"
                            value="${escapeAttr(data.name || '')}" placeholder="Max Mustermann"
                            onfocus="this.style.borderColor='rgba(0,200,190,.5)'" onblur="this.style.borderColor='rgba(148,163,184,.16)'">
                    </div>
                    <div>
                        <label style="${_l2}">E-Mail</label>
                        <input data-invite-field="email" type="text" inputmode="email" style="${_i2}"
                            value="${escapeAttr(data.email || '')}" placeholder="mail@firma.ch"
                            onfocus="this.style.borderColor='rgba(0,200,190,.5)'" onblur="this.style.borderColor='rgba(148,163,184,.16)'">
                    </div>
                    <div style="display:flex;flex-direction:column;align-items:flex-end;gap:.35rem;">
                        <span style="font-size:.62rem;font-weight:700;text-transform:uppercase;letter-spacing:.1em;color:#7A8AA0;">${role}</span>
                        <button type="button" data-action="remove-invite"
                            style="padding:.42rem .55rem;border-radius:8px;background:rgba(239,68,68,.08);border:1px solid rgba(239,68,68,.2);color:#DC2626;font-size:.82rem;cursor:pointer;font-family:inherit;line-height:1;"
                            onmouseover="this.style.background='rgba(239,68,68,.16)'" onmouseout="this.style.background='rgba(239,68,68,.08)'">×</button>
                    </div>
                `;
                row.querySelector('[data-action="remove-invite"]').addEventListener('click', () => {
                    row.remove();
                    emptyEl.classList.toggle('hidden', list.children.length > 0);
                    syncDraft();
                });
                list.appendChild(row);
                emptyEl.classList.toggle('hidden', list.children.length > 0);
            };

            const teamRoleOptions = [
                { value: 'Admin', label: 'Admin' },
                { value: 'VL', label: 'Manager / Team Lead' },
                { value: 'Mitarbeiter', label: 'Sales / Mitarbeiter' },
                // Accounting/Partner werden in der Registrierung nicht mehr angeboten —
                // solche Rollen legt man später im CRM an. Team-Rollen: Admin, VL, Mitarbeiter.
            ];

            if (paidInvites.length > 0) {
                paidInvites.forEach(invite => addInviteRow(teamList, teamEmpty, teamRoleOptions, invite));
            } else if (hasTeam) {
                const count = plannedInvites > 0 ? plannedInvites : 1;
                for (let i = 0; i < count; i += 1) {
                    addInviteRow(teamList, teamEmpty, teamRoleOptions);
                }
            }

            if (partnerInvites.length > 0 && partnerList) {
                partnerInvites.forEach(invite => addFixedInviteRow(partnerList, partnerEmpty, 'Partner', invite));
            }
            if (accountingInvites.length > 0 && accountingList) {
                accountingInvites.forEach(invite => addFixedInviteRow(accountingList, accountingEmpty, 'Accounting', invite));
            }
            if (partnerEmpty) {
                partnerEmpty.classList.toggle('hidden', partnerList && partnerList.children.length > 0);
            }
            if (accountingEmpty) {
                accountingEmpty.classList.toggle('hidden', accountingList && accountingList.children.length > 0);
            }

            const syncDraft = () => {
                const collectRows = (list) => Array.from(list.querySelectorAll('[data-invite-row]')).map(row => {
                    const getValue = (selector) => row.querySelector(selector)?.value?.trim() || '';
                    return {
                        name: getValue('[data-invite-field="name"]'),
                        email: getValue('[data-invite-field="email"]').toLowerCase(),
                        role: row.dataset.inviteRole
                            || row.querySelector('[data-invite-field="role"]')?.value
                            || 'Mitarbeiter'
                    };
                }).filter(item => item.email);
                const normalizedInvites = normalizeInviteList([
                    ...collectRows(teamList),
                    ...(partnerList ? collectRows(partnerList) : []),
                    ...(accountingList ? collectRows(accountingList) : [])
                ]);
                const paidInviteCount = normalizedInvites.filter(invite => paidRoles.includes(invite.role)).length;
                const nextEmployeeCount = normalizeEmployeeCount(paidInviteCount + 1, planKey);
                state.data.teamInvites = normalizedInvites;
                state.data.employeeCount = nextEmployeeCount;
                state.data.hasTeam = nextEmployeeCount > 1;
                if (teamSizeValue) {
                    teamSizeValue.textContent = nextEmployeeCount.toString();
                }
                queueLocalSave();
                updateLivePreview();
            };
            teamList?.addEventListener('input', syncDraft);
            partnerList?.addEventListener('input', syncDraft);
            partnerList?.addEventListener('change', syncDraft);
            accountingList?.addEventListener('input', syncDraft);
            accountingList?.addEventListener('change', syncDraft);
            teamList?.addEventListener('change', syncDraft);

            card.querySelector('[data-action="add-team-invite"]')?.addEventListener('click', () => {
                addInviteRow(teamList, teamEmpty, teamRoleOptions);
            });
            card.querySelector('[data-action="add-partner-invite"]')?.addEventListener('click', () => {
                if (partnerList) {
                    addFixedInviteRow(partnerList, partnerEmpty, 'Partner');
                    syncDraft();
                }
            });
            card.querySelector('[data-action="add-accounting-invite"]')?.addEventListener('click', () => {
                if (accountingList) {
                    addFixedInviteRow(accountingList, accountingEmpty, 'Accounting');
                    syncDraft();
                }
            });

            addCard(card);
        };

        const renderJoinStep = () => {
            const join = state.data.join;
            const codeLocked = Boolean(join.code && join.codeLocked);
            const roleLocked = Boolean(join.roleLocked);
            const fromInviteLink = Boolean(join.fromInviteLink || (codeLocked && roleLocked));
            const roleOptions = [
                { value: 'Mitarbeiter', label: 'Sales / Mitarbeiter' },
                { value: 'VL', label: 'Manager / Team Lead' }
            ];
            const lockedRole = join.role || 'Mitarbeiter';
            const allowedRoles = roleLocked ? [lockedRole] : roleOptions.map(option => option.value);
            const effectiveRole = allowedRoles.includes(join.role) ? join.role : allowedRoles[0];
            const buildRoleLabel = (role) => {
                const match = roleOptions.find(option => option.value === role);
                if (match) return match.label;
                if (role === 'Admin') return 'Admin';
                if (role === 'Partner') return 'Partner';
                if (role === 'Accounting') return 'Finance / Backoffice';
                return role;
            };
            const lockNote = (codeLocked || roleLocked)
                ? '<p class="text-xs text-slate-400">Firmencode/Rolle wurden aus dem Einladungslink übernommen.</p>'
                : '';
            const contextCard = fromInviteLink
                ? `
                    <div class="join-context-card is-invite">
                        <div class="join-context-title">Einladung erkannt</div>
                        <div class="join-context-copy">Der Link hat Firmencode und Rolle bereits gesetzt. Dadurch landet dein Zugang sauber im richtigen CRM und kann schneller freigegeben werden.</div>
                    </div>
                `
                : `
                    <div class="join-context-card">
                        <div class="join-context-title">Ohne Invite-Link</div>
                        <div class="join-context-copy">Direkte Beitritte sind für Mitarbeiter und VL gedacht. Admin, Partner und Accounting sollten über einen offiziellen Invite angelegt werden.</div>
                    </div>
                `;
            const body = `
                ${contextCard}
                <div class="grid grid-cols-1 md:grid-cols-2 gap-3">
                    <div>
                        <label class="text-sm text-slate-300">Firmencode *</label>
                        <input name="join-code" type="text" class="input w-full rounded-lg px-3 py-2 mt-1" required autofocus placeholder="z.B. X9K4PZ" autocomplete="one-time-code" spellcheck="false" value="${escapeAttr(join.code)}" ${codeLocked ? 'readonly aria-readonly="true"' : ''}>
                    </div>
                    <div>
                        <label class="text-sm text-slate-300">Gewünschte Rolle *
                            <span class="feature-help ml-1 align-middle" data-tooltip="Mitarbeiter: Vertriebszugang. VL: Teamlead mit Team-Insights. Andere Rollen nur per Einladung.">i</span>
                        </label>
                        <select name="join-role" class="input w-full rounded-lg px-3 py-2 mt-1" required ${roleLocked ? 'disabled' : ''}>
                            ${allowedRoles.map(role => `
                                <option value="${role}" ${role === effectiveRole ? 'selected' : ''}>${buildRoleLabel(role)}</option>
                            `).join('')}
                        </select>
                    </div>
                </div>
                ${lockNote}
                <p class="text-xs text-slate-400">Dein Antrag wird vom Admin freigegeben. Danach wirst du automatisch weitergeleitet.</p>
            `;
            const card = createFormCard('Firmencode', body, (form) => {
                state.data.join = {
                    ...state.data.join,
                    code: form.querySelector('[name="join-code"]').value.trim().toUpperCase(),
                    role: form.querySelector('[name="join-role"]').value || effectiveRole
                };
                saveState();
                disableForm(form);
                addUserMessage(`Code ${state.data.join.code} · Rolle ${state.data.join.role}`);
                goToNextStep();
            });
            const form = card.querySelector('form');
            form.addEventListener('input', () => {
                state.data.join = {
                    ...state.data.join,
                    code: form.querySelector('[name="join-code"]').value.trim().toUpperCase(),
                    role: form.querySelector('[name="join-role"]').value || effectiveRole
                };
                queueLocalSave();
                updateLivePreview();
            });
            addCard(card);
        };

        const renderSummaryCard = () => {
            const summaryCard = document.createElement('div');
            summaryCard.className = 'chat-card chat-card--scroll chat-card--summary';
            const account = state.data.account;
            const planKey = normalizeSubscriptionPlan(state.data.subscriptionPlan);
            const modules = normalizeSubscriptionModules(state.data.subscriptionModules || resolvePlanModules(planKey));
            const company = state.data.company || {};
            const pipeline = state.data.pipeline || {};
            const products = Array.isArray(state.data.products) ? state.data.products : [];
            const employeeCount = normalizeEmployeeCount(state.data.employeeCount, planKey);
            // Keine Preis-/Abo-Berechnung mehr in der Zusammenfassung (Gratis-Testphase, kein Paket gewählt).
            const enabledModules = Object.entries(modules)
                .filter(([, value]) => value)
                .map(([key]) => SUBSCRIPTION_ADDONS[key]?.label || key);
            const summaryRows = [];
            const accountLabel = account.name || account.email || '—';
            summaryRows.push({ label: 'Konto', value: accountLabel });
            if (state.mode === 'join') {
                summaryRows.push({ label: 'Firmencode', value: state.data.join?.code || '—' });
                summaryRows.push({ label: 'Rolle', value: state.data.join?.role || '—' });
            } else {
                summaryRows.push({ label: 'Firma', value: company.name || '—' });
                summaryRows.push({ label: 'Team', value: `${employeeCount} Personen` });
                // Kein Abo/Preis/Abrechnung in der Zusammenfassung: In der Registrierung wird kein
                // Paket gewählt (Gratis-Testphase); Plan & Zahlweise folgen erst nach den 14 Tagen.
                if (Object.keys(SUBSCRIPTION_ADDONS).length) {
                    summaryRows.push({ label: 'Inklusive Module', value: enabledModules.length ? enabledModules.join(', ') : 'Alle' });
                }
                const resolvedPipelineTemplate = PIPELINE_TEMPLATES[pipeline.template] ? pipeline.template : DEFAULT_PIPELINE_TEMPLATE;
                const pipelineLabel = PIPELINE_TEMPLATES[resolvedPipelineTemplate]?.label || pipeline.template || 'Standard';
                summaryRows.push({ label: 'Pipeline', value: pipelineLabel });
                summaryRows.push({ label: 'Produkte', value: products.length ? `${products.length} erfasst` : 'Noch keine' });
            }

            const editButtons = state.mode === 'join'
                ? ['account', 'join']
                : ['account', 'company', 'pipeline', 'team', 'products', 'features'];

            // ── Statt Preisübersicht: schlanker Gratis-Testphase-Hinweis (kein Paket in der
            //    Registrierung gewählt → keine "Gesamt/Monat"-Aufstellung in der Zusammenfassung). ──
            const billingBreakdown = state.mode === 'join'
                ? `<div style="background:#FFFFFF;border:1.5px solid rgba(148,163,184,.12);border-radius:14px;padding:.9rem 1rem;">
                    <p style="font-size:.73rem;color:#7A8AA0;">Dieser Zugang wird durch die Firma abgerechnet.</p>
                   </div>`
                : `<div style="display:flex;align-items:center;gap:.7rem;background:linear-gradient(135deg,rgba(34,197,94,.08),rgba(0,200,190,.05));border:1.5px solid rgba(34,197,94,.25);border-radius:14px;padding:.8rem 1rem;">
                    <div style="width:30px;height:30px;border-radius:9px;background:rgba(34,197,94,.15);border:1px solid rgba(34,197,94,.3);display:flex;align-items:center;justify-content:center;flex-shrink:0;color:#15803D;">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" style="width:14px;height:14px;"><polyline points="20 6 9 17 4 12"/></svg>
                    </div>
                    <div>
                        <div style="font-size:.8rem;font-weight:700;color:#1A2433;">14 Tage kostenlos testen</div>
                        <div style="font-size:.67rem;color:#7A8AA0;margin-top:.1rem;">Heute CHF 0. Plan &amp; Zahlweise wählst du erst nach der Testphase — bis zu 5 Leads gratis.</div>
                    </div>
                   </div>`;

            // ── Consent ──
            const consentState = state.data.consents || DEFAULT_STATE.data.consents;
            const healthModel = buildRegistrationHealthModel();
            const blockingInsights = healthModel.openBlocking;
            const consentBlock = `
                <div style="display:flex;flex-direction:column;gap:.55rem;">
                    <label style="display:flex;align-items:flex-start;gap:.65rem;cursor:pointer;padding:.6rem .75rem;background:#FFFFFF;border:1.5px solid rgba(148,163,184,.12);border-radius:10px;">
                        <input type="checkbox" data-consent="terms" style="width:15px;height:15px;accent-color:#00C8BE;flex-shrink:0;margin-top:1px;" ${consentState.terms ? 'checked' : ''}>
                        <span style="font-size:.75rem;color:#56657A;line-height:1.45;">
                            Ich akzeptiere die <a href="/agb-crm.html" target="_blank" rel="noopener noreferrer" style="color:#00C8BE;text-decoration:underline;">AGB</a> der Appnity GmbH.
                        </span>
                    </label>
                    <label style="display:flex;align-items:flex-start;gap:.65rem;cursor:pointer;padding:.6rem .75rem;background:#FFFFFF;border:1.5px solid rgba(148,163,184,.12);border-radius:10px;">
                        <input type="checkbox" data-consent="privacy" style="width:15px;height:15px;accent-color:#00C8BE;flex-shrink:0;margin-top:1px;" ${consentState.privacy ? 'checked' : ''}>
                        <span style="font-size:.75rem;color:#56657A;line-height:1.45;">
                            Ich stimme der <a href="/datenschutz-crm.html" target="_blank" rel="noopener noreferrer" style="color:#00C8BE;text-decoration:underline;">Datenschutzerklärung</a> zu.
                        </span>
                    </label>
                </div>
            `;

            // ── Insights ──
            const summaryInsightBlock = blockingInsights.length
                ? `<div style="display:flex;flex-direction:column;gap:.4rem;">
                    ${blockingInsights.map(item => `
                        <div style="display:flex;gap:.6rem;padding:.55rem .75rem;background:rgba(245,158,11,.07);border:1px solid rgba(245,158,11,.2);border-radius:10px;">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="#F59E0B" stroke-width="2" style="width:13px;height:13px;flex-shrink:0;margin-top:1px;"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
                            <div>
                                <div style="font-size:.75rem;font-weight:600;color:#B45309;">${escapeHtml(item.label)}</div>
                                <div style="font-size:.68rem;color:#7A8AA0;margin-top:.1rem;">${escapeHtml(item.detail)}</div>
                            </div>
                        </div>
                    `).join('')}
                   </div>`
                : `<div style="display:flex;align-items:center;gap:.5rem;padding:.55rem .75rem;background:rgba(34,197,94,.06);border:1px solid rgba(34,197,94,.18);border-radius:10px;">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="#4ADE80" stroke-width="2" style="width:13px;height:13px;flex-shrink:0;"><polyline points="20 6 9 17 4 12"/></svg>
                    <span style="font-size:.75rem;color:#15803D;font-weight:600;">Setup sieht gut aus</span>
                   </div>`;

            const paymentWarning = '';

            const summaryRowsHtml = summaryRows.map(row => `
                <div style="display:flex;align-items:center;justify-content:space-between;gap:1rem;padding:.5rem 1rem;border-bottom:1px solid rgba(148,163,184,.07);">
                    <span style="font-size:.72rem;color:#7A8AA0;">${escapeHtml(row.label)}</span>
                    <span style="font-size:.75rem;font-weight:600;color:#1A2433;text-align:right;max-width:60%;">${escapeHtml(row.value)}</span>
                </div>
            `).join('');

            summaryCard.innerHTML = `
                <div class="chat-form">
                    <div class="wizard-form-body">

                        <!-- Header -->
                        <div style="display:flex;align-items:center;gap:.7rem;padding:.85rem 1rem;background:linear-gradient(135deg,rgba(0,200,190,.07),rgba(200,0,130,.04));border:1.5px solid rgba(0,200,190,.2);border-radius:14px;">
                            <div style="width:32px;height:32px;border-radius:9px;background:rgba(0,200,190,.15);border:1px solid rgba(0,200,190,.28);display:flex;align-items:center;justify-content:center;flex-shrink:0;color:#00C8BE;">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" style="width:14px;height:14px;"><polyline points="20 6 9 17 4 12"/></svg>
                            </div>
                            <div style="flex:1;">
                                <div style="font-size:.83rem;font-weight:700;color:#1A2433;">Alles bereit — bitte prüfen</div>
                                <div style="font-size:.67rem;color:#7A8AA0;margin-top:.1rem;">Klick auf "Schritt bearbeiten" um Angaben zu ändern.</div>
                            </div>
                        </div>

                        <!-- Summary rows -->
                        <div style="background:#FFFFFF;border:1.5px solid rgba(148,163,184,.1);border-radius:14px;overflow:hidden;">
                            <div style="padding:.55rem 1rem;border-bottom:1px solid rgba(148,163,184,.08);background:rgba(148,163,184,.04);">
                                <span style="font-size:.62rem;font-weight:700;text-transform:uppercase;letter-spacing:.1em;color:#7A8AA0;">Deine Angaben</span>
                            </div>
                            ${summaryRowsHtml}
                        </div>

                        ${billingBreakdown}
                        ${summaryInsightBlock}
                        ${consentBlock}
                        ${paymentWarning}

                        ${state.mode === 'join' ? '' : `
                        <div style="padding:.75rem .9rem;border-radius:12px;background:rgba(0,200,190,.06);border:1px solid rgba(0,200,190,.18);color:#56657A;font-size:.74rem;line-height:1.55;">
                            <strong style="color:#1A2433;">Keine Kreditkarte nötig.</strong> Du startest mit vollem Zugang während der Testphase und bis zu 5 Leads kostenlos. Danach aktivierst du Appnity Core, wenn du weiterarbeiten möchtest.
                        </div>
                        <div style="display:flex;flex-wrap:wrap;gap:.35rem;">
                            <span style="font-size:.63rem;font-weight:600;padding:.2rem .55rem;border-radius:99px;background:rgba(34,197,94,.06);color:#15803D;border:1px solid rgba(34,197,94,.12);">✓ Testphase & 5 Leads</span>
                            <span style="font-size:.63rem;font-weight:600;padding:.2rem .55rem;border-radius:99px;background:rgba(148,163,184,.05);color:#7A8AA0;border:1px solid rgba(148,163,184,.1);">Keine Abbuchung jetzt</span>
                            <span style="font-size:.63rem;font-weight:600;padding:.2rem .55rem;border-radius:99px;background:rgba(148,163,184,.05);color:#7A8AA0;border:1px solid rgba(148,163,184,.1);">Alle Module aktiv</span>
                        </div>`}

                        <!-- Edit chips -->
                        <div style="padding-top:.25rem;">
                            <p style="font-size:.65rem;color:#7A8AA0;margin-bottom:.35rem;">Schritt bearbeiten:</p>
                            <div style="display:flex;flex-wrap:wrap;gap:.3rem;">
                                ${editButtons.map(step => `<button type="button" class="chat-chip" data-edit-step="${step}">${stepLabel(step)}</button>`).join('')}
                            </div>
                        </div>

                    </div>

                    <div class="chat-actions">
                        <button type="button" data-action="back" class="btn-secondary" style="padding:.55rem 1rem;">Zurück</button>
                        <button type="button" data-action="submit" class="btn-primary" style="padding:.62rem 1.4rem;margin-left:auto;">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" style="width:13px;height:13px;"><polyline points="20 6 9 17 4 12"/></svg>
                            Jetzt registrieren
                        </button>
                    </div>
                </div>
            `;

            summaryCard.querySelector('[data-action="submit"]').addEventListener('click', submitRegistration);
            summaryCard.querySelector('[data-action="back"]').addEventListener('click', () => {
                goToPrevStep();
            });
            summaryCard.querySelectorAll('[data-edit-step]').forEach(button => {
                button.addEventListener('click', () => {
                    const step = button.dataset.editStep;
                    addAssistantMessage(`Alles klar, wir passen ${stepLabel(step)} an.`, { kind: 'prompt', step, context: buildAiContext() });
                    goToStep(step);
                });
            });
            summaryCard.querySelectorAll('[data-consent]').forEach(input => {
                input.addEventListener('change', () => {
                    const key = input.dataset.consent;
                    if (!state.data.consents) state.data.consents = { ...DEFAULT_STATE.data.consents };
                    state.data.consents[key] = Boolean(input.checked);
                    saveState();
                    renderSummaryCard();
                    syncSubmitAvailability();
                });
            });

            addCard(summaryCard);
            syncSubmitAvailability();
        };

        const renderVerificationScreen = (emailAddress = '') => {
            setStepLoading(false);
            setVerificationViewActive(true);
            clearChat();
            setPrompt('Bitte bestätige deine E-Mail-Adresse, damit dein CRM freigeschaltet wird.');
            if (ui.wizardStepCount) {
                ui.wizardStepCount.textContent = 'Registrierung abgeschlossen';
            }
            if (ui.wizardStepTitle) {
                ui.wizardStepTitle.textContent = 'E-Mail bestätigen';
            }

            const safeEmail = emailAddress || auth.currentUser?.email || '';
            const emailLine = safeEmail
                ? `<p>Wir haben einen Bestätigungslink an <strong>${escapeHtml(safeEmail)}</strong> gesendet.</p>`
                : '<p>Wir haben einen Bestätigungslink an deine E-Mail-Adresse gesendet.</p>';
            const nameLabel = state.data.account?.name || '';
            const welcomeLine = nameLabel ? `<p class="text-slate-400">Willkommen, ${escapeHtml(nameLabel)}!</p>` : '';

            const card = document.createElement('div');
            card.className = 'chat-card';
            card.innerHTML = `
                <div class="space-y-3 text-sm text-slate-200">
                    <h4>E-Mail bestätigen</h4>
                    ${welcomeLine}
                    ${emailLine}
                    <div class="text-xs text-slate-400 space-y-1">
                        <p>1) E-Mail öffnen und Link bestätigen.</p>
                        <p>2) Danach hier auf "Ich habe bestätigt" klicken.</p>
                        <p>Falls keine E-Mail ankommt, bitte Spam/Promotion prüfen.</p>
                    </div>
                    <div class="mt-3 text-xs text-slate-400">
                        <p class="text-slate-300 font-semibold mb-1">Nächste Schritte danach</p>
                        <p>1) Team einladen · 2) Produkte/Services ergänzen · 3) Erste Leads importieren</p>
                    </div>
                </div>
                <div class="chat-actions mt-4">
                    <button type="button" data-action="check-verification" class="btn-primary px-5 py-2 rounded-lg font-semibold">Ich habe bestätigt</button>
                    <button type="button" data-action="resend-verification" class="btn-secondary px-5 py-2 rounded-lg font-semibold">E-Mail erneut senden</button>
                </div>
            `;

            const checkButton = card.querySelector('[data-action="check-verification"]');
            const resendButton = card.querySelector('[data-action="resend-verification"]');

            if (checkButton) {
                checkButton.addEventListener('click', async () => {
                    if (!auth.currentUser) {
                        setStatus('Bitte zuerst einloggen, um den Status zu prüfen.');
                        return;
                    }
                    const label = checkButton.textContent || '';
                    checkButton.disabled = true;
                    checkButton.textContent = 'Prüfe...';
                    try {
                        await auth.currentUser.reload();
                        if (auth.currentUser.emailVerified) {
                            setStatus('E-Mail bestätigt. CRM wird geöffnet...', false);
                            window.location.href = 'dashboard.html';
                            return;
                        }
                        setStatus('E-Mail noch nicht bestätigt. Bitte Link öffnen und erneut versuchen.');
                    } catch (error) {
                        console.error('Verification check failed:', error);
                        setStatus('E-Mail-Status konnte nicht geprüft werden.');
                    } finally {
                        checkButton.disabled = false;
                        checkButton.textContent = label;
                    }
                });
            }

            if (resendButton) {
                resendButton.addEventListener('click', async () => {
                    if (!auth.currentUser) {
                        setStatus('Bitte zuerst einloggen, um die E-Mail zu senden.');
                        return;
                    }
                    const label = resendButton.textContent || '';
                    resendButton.disabled = true;
                    resendButton.textContent = 'Sende...';
                    try {
                        await sendVerificationEmailSafe();
                        setStatus('Bestätigungslink wurde erneut gesendet.', false);
                    } catch (error) {
                        console.error('Verification resend failed:', error);
                        setStatus('Bestätigungslink konnte nicht gesendet werden.');
                    } finally {
                        resendButton.disabled = false;
                        resendButton.textContent = label;
                    }
                });
            }

            addCard(card);
        };

        const renderPaymentReturnScreen = ({ title, message, actions = [], status = 'info' }) => {
            setStepLoading(false);
            clearChat();
            setPrompt(title);
            const badgeLabels = { info: 'Hinweis', success: 'Erfolg', error: 'Fehler' };
            const badgeText = badgeLabels[status] || badgeLabels.info;
            const card = document.createElement('div');
            card.className = 'chat-card';
            card.innerHTML = `
                <div class="space-y-3 text-sm text-slate-200">
                    <div class="flex items-center justify-between gap-3">
                        <h4>${escapeHtml(title)}</h4>
                        <span class="status-badge ${escapeAttr(status)}">${escapeHtml(badgeText)}</span>
                    </div>
                    <p>${escapeHtml(message)}</p>
                </div>
                ${actions.length ? `
                    <div class="chat-actions mt-4">
                        ${actions.map(action => `<button type="button" class="${action.className}" data-action="${action.id}">${action.label}</button>`).join('')}
                    </div>
                ` : ''}
            `;
            actions.forEach(action => {
                const btn = card.querySelector(`[data-action="${action.id}"]`);
                if (!btn) return;
                btn.addEventListener('click', action.onClick);
            });
            addCard(card);
        };

        const renderFinalSuccessScreen = ({ title, message, nextSteps = [] } = {}) => {
            setStepLoading(false);
            try { window.__track && window.__track('reg_complete'); } catch (e) {}
            if (successRedirectTimer) clearTimeout(successRedirectTimer);
            if (successCountdownTimer) clearInterval(successCountdownTimer);
            clearChat();
            setPrompt(title || 'Registrierung abgeschlossen');
            const nameLabel = state.data.account?.name || '';
            const headline = title || 'Registrierung abgeschlossen';
            const bodyMessage = message || (nameLabel ? `Danke ${nameLabel}! Dein CRM ist bereit.` : 'Dein CRM ist bereit.');
            const defaultSteps = [
                { title: 'Team einladen', text: 'Arbeite direkt mit deinem Team im CRM.' },
                { title: 'Produkte/Services prüfen', text: 'Lege Angebote und Provisionen fest.' },
                { title: 'Erste Leads importieren', text: 'Starte sofort mit echten Kontakten.' }
            ];
            const steps = nextSteps.length ? nextSteps : defaultSteps;
            // Inline-Styles (wie der restliche Wizard) — die früheren Klassen success-step*,
            // status-badge, space-y-3/text-slate-200 waren nirgends definiert → der Screen
            // rendere unstyled (grosse Zahlen, gestapelter Text ohne Karten).
            const stepsMarkup = `
                <div style="margin-top:.85rem;">
                    <p style="font-size:.68rem;font-weight:700;text-transform:uppercase;letter-spacing:.08em;color:#7A8AA0;margin-bottom:.55rem;">Empfohlene nächste Schritte</p>
                    <div style="display:flex;flex-direction:column;gap:.5rem;">
                        ${steps.map((step, index) => `
                            <div style="display:flex;align-items:flex-start;gap:.7rem;background:#FFFFFF;border:1.5px solid rgba(148,163,184,.14);border-radius:12px;padding:.7rem .8rem;">
                                <span style="flex-shrink:0;width:22px;height:22px;border-radius:50%;background:rgba(0,200,190,.12);color:#00A99D;border:1px solid rgba(0,200,190,.25);display:flex;align-items:center;justify-content:center;font-size:.72rem;font-weight:700;">${index + 1}</span>
                                <div>
                                    <p style="font-size:.82rem;font-weight:700;color:#1A2433;margin-bottom:.12rem;">${escapeHtml(step.title || '')}</p>
                                    <p style="font-size:.74rem;color:#7A8AA0;line-height:1.4;">${escapeHtml(step.text || '')}</p>
                                </div>
                            </div>
                        `).join('')}
                    </div>
                </div>
            `;
            const card = document.createElement('div');
            card.className = 'chat-card';
            card.innerHTML = `
                <div style="display:flex;flex-direction:column;gap:.7rem;">
                    <div style="display:flex;align-items:center;justify-content:space-between;gap:.75rem;">
                        <h4 style="margin:0;font-size:1.05rem;font-weight:800;color:#1A2433;">${escapeHtml(headline)}</h4>
                        <span style="flex-shrink:0;font-size:.62rem;font-weight:700;text-transform:uppercase;letter-spacing:.08em;padding:.2rem .55rem;border-radius:99px;background:rgba(34,197,94,.12);color:#15803D;border:1px solid rgba(34,197,94,.25);white-space:nowrap;">✓ Erfolg</span>
                    </div>
                    <p style="font-size:.85rem;color:#56657A;line-height:1.5;">${escapeHtml(bodyMessage)}</p>
                    ${stepsMarkup}
                </div>
                <div style="display:flex;align-items:center;flex-wrap:wrap;gap:.85rem;margin-top:1rem;">
                    <button type="button" data-action="go-dashboard" class="btn-primary px-5 py-2 rounded-lg font-semibold">Zum CRM</button>
                    <span id="success-countdown" style="font-size:.75rem;color:#7A8AA0;">Weiterleitung in 5 Sekunden…</span>
                </div>
            `;
            card.querySelector('[data-action="go-dashboard"]')?.addEventListener('click', () => {
                if (successRedirectTimer) clearTimeout(successRedirectTimer);
                if (successCountdownTimer) clearInterval(successCountdownTimer);
                try { sessionStorage.setItem('appnity_just_registered', '1'); } catch(_) {}
                window.location.href = 'dashboard.html';
            });
            addCard(card);
            const countdownEl = card.querySelector('#success-countdown');
            let remaining = 5;
            if (countdownEl) {
                countdownEl.textContent = `Weiterleitung in ${remaining} Sekunden…`;
            }
            successCountdownTimer = setInterval(() => {
                remaining -= 1;
                if (countdownEl) {
                    countdownEl.textContent = `Weiterleitung in ${Math.max(remaining, 0)} Sekunden…`;
                }
                if (remaining <= 0) {
                    clearInterval(successCountdownTimer);
                }
            }, 1000);
            successRedirectTimer = setTimeout(() => {
                try { sessionStorage.setItem('appnity_just_registered', '1'); } catch(_) {}
                window.location.href = 'dashboard.html';
            }, 5000);
        };

        const resumeSubscriptionCheckout = async (orgId) => {
            if (!orgId || !createSubscriptionCheckoutSessionFn) {
                setStatus('Zahlung kann gerade nicht gestartet werden.');
                return;
            }
            setStatus('Weiterleitung zu Stripe...', false);
            const orgSnap = await getDoc(doc(db, 'orgs', orgId));
            if (!orgSnap.exists) {
                setStatus('Organisation nicht gefunden.');
                return;
            }
            const orgData = orgSnap.data() || {};
            const planKey = normalizeSubscriptionPlan(orgData.subscriptionPlan);
            const addons = normalizeSubscriptionModules(orgData.subscriptionModules);
            const employeeCount = normalizeEmployeeCount(orgData.employeeCount, planKey);
            const billingCycle = normalizeBillingCycle(orgData.subscriptionBillingCycle || state.data.subscriptionBillingCycle || SUBSCRIPTION_BILLING_DEFAULT);
            const { successUrl, cancelUrl } = buildSubscriptionReturnUrls(orgId);
            const response = await createSubscriptionCheckoutSessionFn({
                orgId,
                plan: planKey,
                addons,
                employeeCount,
                billingCycle,
                successUrl,
                cancelUrl
            });
            const url = response?.data?.url;
            if (url) {
                attemptStripeRedirect(url);
                return;
            }
            setStatus('Stripe-URL konnte nicht erstellt werden.');
        };

        const attemptStripeRedirect = (url) => {
            if (!url) return;
            const currentUrl = window.location.href;
            try {
                window.location.assign(url);
            } catch (error) {
                window.location.href = url;
            }
            setTimeout(() => {
                if (window.location.href !== currentUrl) return;
                renderPaymentReturnScreen({
                    title: 'Weiterleitung blockiert',
                    message: 'Falls dein Browser die Weiterleitung blockiert, öffne die Zahlung bitte manuell.',
                    status: 'error',
                    actions: [
                        {
                            id: 'open-stripe',
                            label: 'Zahlung jetzt öffnen',
                            className: 'btn-primary px-5 py-2 rounded-lg font-semibold',
                            onClick: () => {
                                window.open(url, '_blank', 'noopener');
                                window.location.href = url;
                            }
                        }
                    ]
                });
            }, 1200);
        };

        const finalizeRegistrationAfterPayment = async (orgId) => {
            if (!orgId) return;
            try {
                await updateDoc(doc(db, 'orgs', orgId), {
                    onboardingComplete: true,
                    onboardingCompletedAt: serverTimestamp(),
                    subscriptionUpdatedAt: serverTimestamp()
                });
            } catch (error) {
                console.warn('Onboarding finalize failed:', error?.message || error);
            }
        };

        const handleSubscriptionReturn = async () => {
            if (!pendingSubscriptionReturn || processingSubscriptionReturn) return false;
            processingSubscriptionReturn = true;
            const { action, sessionId, orgId: orgParam } = pendingSubscriptionReturn;
            const stored = getPaymentState() || {};
            const orgId = orgParam || stored.orgId || '';
            if (!orgId) {
                renderPaymentReturnScreen({
                    title: 'Zahlung prüfen',
                    message: 'Wir konnten deine Organisation nicht finden. Bitte erneut registrieren.',
                    status: 'error'
                });
                processingSubscriptionReturn = false;
                return true;
            }
            if (!auth.currentUser) {
                renderPaymentReturnScreen({
                    title: 'Zahlung prüfen',
                    message: 'Bitte einloggen, damit wir die Zahlung bestätigen können.',
                    status: 'info'
                });
                processingSubscriptionReturn = false;
                return true;
            }
            if (action === 'cancel') {
                renderPaymentReturnScreen({
                    title: 'Zahlung abgebrochen',
                    message: 'Du kannst die Zahlung jederzeit fortsetzen.',
                    status: 'info',
                    actions: [
                        {
                            id: 'resume-payment',
                            label: 'Zahlung fortsetzen',
                            className: 'btn-primary px-5 py-2 rounded-lg font-semibold',
                            onClick: () => resumeSubscriptionCheckout(orgId)
                        }
                    ]
                });
                clearSubscriptionParams();
                pendingSubscriptionReturn = null;
                processingSubscriptionReturn = false;
                return true;
            }
            renderPaymentReturnScreen({
                title: 'Zahlung wird bestätigt',
                message: 'Wir prüfen gerade deine Zahlung und schliessen die Registrierung ab.',
                status: 'info'
            });
            if (!confirmSubscriptionCheckoutFn) {
                setStatus('Zahlung konnte nicht bestätigt werden.');
                processingSubscriptionReturn = false;
                return true;
            }
            try {
                const response = await confirmSubscriptionCheckoutFn({
                    orgId,
                    sessionId: sessionId || ''
                });
                if (!response?.data?.ok) {
                    setStatus('Zahlung noch nicht bestätigt. Bitte kurz warten und neu versuchen.');
                    processingSubscriptionReturn = false;
                    return true;
                }
                await finalizeRegistrationAfterPayment(orgId);
                clearPaymentState();
                clearSubscriptionParams();
                pendingSubscriptionReturn = null;
                let emailVerified = false;
                try {
                    await auth.currentUser.reload();
                    emailVerified = Boolean(auth.currentUser.emailVerified);
                } catch (error) {
                    console.warn('Email verification reload failed:', error);
                }
                if (!emailVerified) {
                    renderVerificationScreen(auth.currentUser?.email || stored.email || '');
                    processingSubscriptionReturn = false;
                    return true;
                }
                renderFinalSuccessScreen({
                    title: 'Registrierung abgeschlossen',
                    message: 'Dein CRM ist bereit. Wir öffnen jetzt dein Dashboard.',
                    nextSteps: [
                        { title: 'Team einladen', text: 'Lade Kolleg:innen ein und starte gemeinsam.' },
                        { title: 'Produkte/Services ergänzen', text: 'Lege Preise, Provisionen und Pakete fest.' },
                        { title: 'Erste Leads importieren', text: 'Starte direkt mit echten Kontakten.' }
                    ]
                });
                if (successRedirectTimer) clearTimeout(successRedirectTimer);
                successRedirectTimer = setTimeout(() => {
                    try { sessionStorage.setItem('appnity_just_registered', '1'); } catch(_) {}
                    window.location.href = 'dashboard.html';
                }, 5000);
                processingSubscriptionReturn = false;
                return true;
            } catch (error) {
                console.error('Payment confirm failed:', error);
                setStatus('Zahlung konnte nicht bestätigt werden.');
                processingSubscriptionReturn = false;
                return true;
            }
        };

        // → ausgelagert nach register.utils.js (stepLabel)

        const updateStepDots = () => {
            if (!ui.wizardStepDots) return;
            const steps = getStepSequence();
            const currentIndex = Math.max(steps.indexOf(currentStepId), 0);
            ui.wizardStepDots.innerHTML = steps.map((step, index) => {
                let cls = 'step-dot';
                if (index < currentIndex) cls += ' active';
                if (index === currentIndex) cls += ' current';
                return `<span class="${cls}" title="${escapeAttr(stepLabel(step))}"></span>`;
            }).join('');
            // Update progress bar
            const progressBar = document.getElementById('wizard-progress-bar');
            if (progressBar) {
                const percent = steps.length <= 1 ? 100 : Math.round((currentIndex / (steps.length - 1)) * 100);
                progressBar.style.width = `${percent}%`;
            }
        };

        const buildPreviewRows = () => {
            const rows = [];
            const account = state.data.account || {};
            const company = state.data.company || {};
            const planKey = normalizeSubscriptionPlan(state.data.subscriptionPlan);
            const planInfo = getSubscriptionPlanInfo(planKey);
            const modules = normalizeSubscriptionModules(state.data.subscriptionModules || resolvePlanModules(planKey));
            const enabledModules = Object.entries(modules)
                .filter(([, value]) => value)
                .map(([key]) => SUBSCRIPTION_ADDONS[key]?.label || key);
            const employeeCount = normalizeEmployeeCount(state.data.employeeCount, planKey);
            const currency = company.currency || 'CHF';
            const pipeline = state.data.pipeline || {};
            const resolvedPipelineTemplate = PIPELINE_TEMPLATES[pipeline.template] ? pipeline.template : DEFAULT_PIPELINE_TEMPLATE;
            const pipelineLabel = PIPELINE_TEMPLATES[resolvedPipelineTemplate]?.label || pipeline.template || 'Standard';
            const products = Array.isArray(state.data.products) ? state.data.products.length : 0;
            const billingCycle = normalizeBillingCycle(state.data.subscriptionBillingCycle || SUBSCRIPTION_BILLING_DEFAULT);

            rows.push({ label: 'Konto', value: account.name || account.email || '—' });
            if (state.mode === 'join') {
                rows.push({ label: 'Firmencode', value: state.data.join?.code || '—' });
                rows.push({ label: 'Rolle', value: state.data.join?.role || '—' });
            } else {
                rows.push({ label: 'Firma', value: company.name || '—' });
                rows.push({ label: 'Abo', value: `${planInfo.label} · ${formatCurrency(planInfo.price, currency)}` });
                rows.push({ label: 'Team', value: `${employeeCount} Personen` });
                if (Object.keys(SUBSCRIPTION_ADDONS).length) {
                    rows.push({ label: 'Inklusive Module', value: enabledModules.length ? enabledModules.join(', ') : 'Alle' });
                }
                rows.push({ label: 'Abrechnung', value: billingCycle === 'year' ? 'Jährlich (-10%)' : 'Monatlich' });
                rows.push({ label: 'Pipeline', value: pipelineLabel });
                rows.push({ label: 'Produkte', value: products ? `${products} erfasst` : 'Noch keine' });
            }
            return rows;
        };

        const updateLivePreview = () => {
            const rows = buildPreviewRows();
            const render = (container) => {
                if (!container) return;
                container.innerHTML = rows.map(row => `
                    <div class="preview-row">
                        <span class="preview-label">${escapeHtml(row.label)}</span>
                        <span class="preview-value">${escapeHtml(row.value)}</span>
                    </div>
                `).join('');
            };
            render(ui.livePreviewContent);
            render(ui.livePreviewContentMobile);
            const account = state.data.account || {};
            const company = state.data.company || {};
            const isReady = state.mode === 'join'
                ? Boolean(account.email && account.password && state.data.join?.code)
                : Boolean(account.email && account.password && company.name && company.billingEmail);
            const badge = currentStepId === 'summary'
                ? 'Prüfen'
                : (isReady ? 'In Arbeit' : 'Entwurf');
            const badgeClass = currentStepId === 'summary'
                ? 'is-warning'
                : (isReady ? 'is-ready' : 'is-draft');
            if (ui.livePreviewStatus) {
                ui.livePreviewStatus.textContent = badge;
                ui.livePreviewStatus.className = `live-preview-badge ${badgeClass}`;
            }
            if (ui.livePreviewStatusMobile) {
                ui.livePreviewStatusMobile.textContent = badge;
                ui.livePreviewStatusMobile.className = `live-preview-badge ${badgeClass}`;
            }
            renderRegistrationHealth();
        };

        const updateOnboardingIntro = () => {
            if (!ui.onboardingIntro) return;
            ui.onboardingIntro.classList.toggle('hidden', currentStepId !== 'mode');
        };

        const updateSidebarProgress = () => {
            const sidebar = document.getElementById('progress-sidebar');
            if (!sidebar) return;
            const steps = getStepSequence();
            const currentIndex = Math.max(steps.indexOf(currentStepId), 0);
            const icons = {
                mode:'⚡', account:'👤', company:'🏢', features:'💎',
                pipeline:'📊', products:'📦', team:'👥', join:'🔑', summary:'✅'
            };
            sidebar.innerHTML = steps.map((step, i) => {
                const done = i < currentIndex;
                const active = i === currentIndex;
                const cls = done ? 'done' : active ? 'active' : 'upcoming';
                const num = done ? '' : String(i + 1);
                return `<div class="prog-item">
                    <div class="prog-dot ${cls}">${done ? '' : num}</div>
                    <div class="prog-label">
                        <div class="prog-title${active ? ' active' : ''}">${stepLabel(step)}</div>
                    </div>
                </div>`;
            }).join('');
            const progressBar = document.getElementById('wizard-progress-bar');
            if (progressBar) {
                const pct = steps.length > 1 ? Math.round((currentIndex / (steps.length - 1)) * 100) : 0;
                progressBar.style.width = pct + '%';
            }
        };

        const updateWizardProgress = () => {
            const steps = getStepSequence();
            const index = Math.max(steps.indexOf(currentStepId), 0);
            if (ui.wizardStepCount) {
                ui.wizardStepCount.textContent = `Schritt ${index + 1} von ${steps.length}`;
            }
            if (ui.wizardStepTitle) {
                ui.wizardStepTitle.textContent = stepLabel(currentStepId);
            }
            document.body.classList.toggle('summary-wide', currentStepId === 'summary');
            updateStepDots();
            updateSidebarProgress();
            updateLivePreview();
            updateOnboardingIntro();
            // Features step no longer locked (was blocking all interactions)
        };

        // → ausgelagert nach register.utils.js (generateCode)

        const generateUniqueOrgCode = async () => {
            if (generateOrgCodeFn) {
                try {
                    const response = await generateOrgCodeFn();
                    const code = response?.data?.code || '';
                    if (code) return code.toString().trim().toUpperCase();
                } catch (error) {
                    console.warn('Org code function failed:', error);
                }
            }
            for (let attempt = 0; attempt < 6; attempt++) {
                const code = generateCode();
                const q = query(collection(db, 'orgs'), where('orgCode', '==', code));
                try {
                    const snap = await getDocs(q);
                    if (snap.empty) return code;
                } catch (error) {
                    console.warn('Org code lookup failed:', error);
                    break;
                }
            }
            throw new Error('Firmencode konnte nicht generiert werden.');
        };

        const createUserProfile = async (uid, data) => {
            // DSGVO Art. 7(1): Einwilligungs-Nachweis DAUERHAFT am Nutzer-Dokument — die
            // registration_drafts (mit der Checkbox) werden nach Abschluss gelöscht, danach
            // wäre die AGB-/Datenschutz-Zustimmung nicht mehr belegbar.
            const consents = state?.data?.consents || {};
            await setDoc(doc(db, 'users', uid), {
                ...data,
                termsAcceptedAt: consents.terms ? serverTimestamp() : null,
                privacyAcceptedAt: consents.privacy ? serverTimestamp() : null,
                legalPolicyVersion: '2026-07-20',
                createdAt: serverTimestamp(),
                updatedAt: serverTimestamp()
            });
        };

        const createAuthAccount = async (email, password) => {
            try {
                return await withTimeout(
                    createUserWithEmailAndPassword(auth, email, password),
                    25000,
                    'Kontoerstellung'
                );
            } catch (error) {
                const isTimeout = (error?.message || '').includes('Kontoerstellung dauert');
                const isInUse = error?.code === 'auth/email-already-in-use';
                if (!isTimeout && !isInUse) {
                    throw error;
                }
                try {
                    return await withTimeout(
                        signInWithEmailAndPassword(auth, email, password),
                        15000,
                        'Anmeldung'
                    );
                } catch (signError) {
                    throw error;
                }
            }
        };

        const getClientBaseUrl = () => {
            const origin = window.location.origin || '';
            if (!origin || origin === 'null') return '';
            return origin;
        };

        const sendVerificationEmailSafe = async (orgId = '') => {
            if (sendVerificationEmailFn) {
                const payload = orgId ? { orgId } : {};
                const baseUrl = getClientBaseUrl();
                if (baseUrl) payload.baseUrl = baseUrl;
                try {
                    await withTimeout(
                        sendVerificationEmailFn(payload),
                        12000,
                        'Bestätigungs-E-Mail'
                    );
                    return;
                } catch (error) {
                    console.warn('Callable verification failed, fallback to Firebase email verification.', error);
                }
            }
            if (auth.currentUser) {
                await withTimeout(
                    sendEmailVerification(auth.currentUser),
                    12000,
                    'Bestätigungs-E-Mail'
                );
            }
        };

        // → ausgelagert nach register.utils.js (normalizeJoinRole)

        // → ausgelagert nach register.utils.js (normalizeInviteList)

        const withTimeout = (promise, ms, label) => {
            return new Promise((resolve, reject) => {
                const timer = setTimeout(() => {
                    reject(new Error(`${label} dauert länger als erwartet. Bitte erneut versuchen.`));
                }, ms);
                promise
                    .then(value => {
                        clearTimeout(timer);
                        resolve(value);
                    })
                    .catch(error => {
                        clearTimeout(timer);
                        reject(error);
                    });
            });
        };

        const applyUrlPrefill = () => {
            const params = new URLSearchParams(window.location.search || '');
            const modeParam = params.get('mode');
            const codeParam = params.get('code') || params.get('org') || params.get('orgCode');
            const roleParam = params.get('role');
            let updated = false;

            if (modeParam === 'join' || codeParam) {
                state.mode = 'join';
                state.stepId = 'account';
                updated = true;
            }
            state.data.join.codeLocked = false;
            state.data.join.roleLocked = false;
            state.data.join.fromInviteLink = false;
            if (codeParam) {
                state.data.join.code = codeParam.trim().toUpperCase();
                state.data.join.codeLocked = true;
                updated = true;
            }
            if (roleParam) {
                const normalizedRole = normalizeJoinRole(roleParam);
                if (normalizedRole) {
                    state.data.join.role = normalizedRole;
                    state.data.join.roleLocked = true;
                    if (codeParam) {
                        state.data.join.fromInviteLink = true;
                    }
                    updated = true;
                }
            }
            if (updated) saveState();
        };

        const buildJoinLink = (orgCode, role) => {
            if (!orgCode) return '';
            const basePath = window.location.pathname.replace(/[^/]*$/, '');
            const params = new URLSearchParams();
            params.set('mode', 'join');
            params.set('code', orgCode);
            if (role) params.set('role', role);
            return `${window.location.origin}${basePath}register.html?${params.toString()}`;
        };

        const resolveOrgIdByCode = async (joinCode) => {
            if (resolveOrgCodeFn) {
                try {
                    const response = await resolveOrgCodeFn({ code: joinCode });
                    const orgId = response?.data?.orgId || '';
                    if (!orgId) {
                        throw new Error('Firmencode nicht gefunden.');
                    }
                    return orgId;
                } catch (error) {
                    const code = error?.code || '';
                    if (code.includes('not-found')) {
                        throw new Error('Firmencode nicht gefunden.');
                    }
                    throw new Error('Firmencode konnte nicht geprüft werden.');
                }
            }
            const orgQuery = query(collection(db, 'orgs'), where('orgCode', '==', joinCode));
            const orgSnap = await getDocs(orgQuery);
            if (orgSnap.empty) {
                throw new Error('Firmencode nicht gefunden.');
            }
            return orgSnap.docs[0].id;
        };

        const buildInviteEmailContent = (invite, orgData, joinLink) => {
            const orgName = orgData?.name || 'Firma';
            const roleLabel = invite.role || 'Mitarbeiter';
            const inviterName = state.data.account?.name || 'Dein Team';
            const greetingName = invite.name ? ` ${invite.name}` : '';
            const subject = `Einladung zu ${orgName}`;
            const body = `Hallo${greetingName},

${inviterName} hat dich zu ${orgName} eingeladen.

Rolle: ${roleLabel}
Firmencode: ${orgData?.orgCode || ''}

Registrierung: ${joinLink || ''}

Falls der Link nicht funktioniert, nutze den Firmencode bei der Registrierung und wähle die passende Rolle.

Liebe Grüsse
${orgName}`;
            return { subject, body };
        };

        const openInviteMailto = (invite, orgData) => {
            const joinLink = buildJoinLink(orgData?.orgCode || '', invite.role);
            const { subject, body } = buildInviteEmailContent(invite, orgData, joinLink);
            const mailto = `mailto:${invite.email}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
            window.open(mailto, '_blank');
        };

        const createJoinRequestsForInvites = async (orgId, invites = [], inviter = null) => {
            if (!orgId || invites.length === 0) return;
            const batch = writeBatch(db);
            invites.forEach(invite => {
                const ref = doc(collection(db, 'orgs', orgId, 'join_requests'));
                batch.set(ref, {
                    userId: null,
                    name: invite.name || '',
                    email: invite.email,
                    requestedRole: invite.role || 'Mitarbeiter',
                    status: 'invited',
                    source: 'invite',
                    invitedBy: inviter?.uid || null,
                    invitedByName: state.data.account?.name || inviter?.email || '',
                    invitedAt: serverTimestamp(),
                    seatReservedUntil: Timestamp.fromMillis(Date.now() + SEAT_RESERVATION_MS),
                    createdAt: serverTimestamp()
                });
            });
            await batch.commit();
        };

        const sendInviteEmails = async (invites = [], orgData = {}, orgId = '', inviter = null) => {
            if (invites.length === 0) return [];
            if (!sendInviteEmailFn) return invites;
            const failures = [];
            for (const invite of invites) {
                const joinLink = buildJoinLink(orgData.orgCode || '', invite.role);
                try {
                    await sendInviteEmailFn({
                        email: invite.email,
                        to: invite.email,
                        name: invite.name || '',
                        role: invite.role || 'Mitarbeiter',
                        orgId,
                        orgName: orgData.name || '',
                        orgCode: orgData.orgCode || '',
                        inviteLink: joinLink,
                        invitedBy: inviter?.uid || null,
                        invitedByName: state.data.account?.name || inviter?.email || ''
                    });
                } catch (error) {
                    console.warn('Invite email failed:', invite.email, error);
                    failures.push(invite);
                }
            }
            return failures;
        };

        const submitRegistration = async () => {
            // Re-Entry-Guard: Da eine aktive Session den Absende-Button nicht mehr deaktiviert,
            // könnte eine Tastatur-Doppelaktivierung (Enter/Space) submitRegistration während des
            // `await signOut` erneut starten → zweite Org. registrationInProgress wird im
            // Session-Zweig VOR dem await gesetzt; dieser Guard fängt den zweiten Lauf ab.
            if (registrationInProgress) return;
            setStatus('');
            let registrationSucceeded = false;
            setStepLoading(true, 'Registrierung läuft...');
            const account = state.data.account;
            const email = account.email.trim().toLowerCase();
            if (!email || !account.password) {
                setStatus('Bitte Kontoangaben prüfen.');
                setStepLoading(false);
                return;
            }
            const consents = state.data.consents || DEFAULT_STATE.data.consents;
            if (!consents.terms || !consents.privacy) {
                setStatus('Bitte AGB und Datenschutzerklärung akzeptieren.');
                syncSubmitAvailability();
                setStepLoading(false);
                return;
            }
            if (!authStateReady) {
                // Weiterfahren ohne blockierenden Check.
            }
            // Auto-Logout: Ist beim bewussten Klick auf „Registrieren" noch eine Session aktiv,
            // wird sie automatisch beendet und danach direkt das neue Konto angelegt — kein Banner,
            // keine „Bitte ausloggen"-Sperre, kein manueller Schritt. Der Konto-Wechsel passiert nur
            // nach diesem expliziten Klick (createUserWithEmailAndPassword würde die Session ohnehin
            // aufs neue Konto umschalten — hier sauber & absichtlich vorher getrennt).
            const activeUser = sessionUser || auth.currentUser;
            if (activeUser) {
                // Häufigster Testfall: man ist bereits mit GENAU dieser E-Mail eingeloggt und will
                // sie erneut „registrieren". Das ist kein neues Konto → klar melden und NICHT
                // ausloggen. Sonst wäre man ausgeloggt UND die Registrierung scheitert direkt an
                // auth/email-already-in-use (der eingegebene Login-Fallback nutzt ein evtl. anderes
                // Passwort). Für ein neues Konto braucht es eine andere E-Mail.
                if ((activeUser.email || '').toLowerCase() === email) {
                    setStatus('Mit dieser E-Mail bist du bereits registriert und eingeloggt. Für ein NEUES Konto bitte eine andere E-Mail verwenden — oder oben „Zurück zum Login".');
                    setStepLoading(false);
                    return;
                }
                // Andere aktive Session → automatisch ausloggen, dann neues Konto anlegen.
                // Flag VOR dem await setzen, damit der Re-Entry-Guard oben greift, solange
                // signOut noch läuft. Bei Fehler danach setzt der finally-Block es wieder zurück.
                registrationInProgress = true;
                setStatus('Aktuelle Sitzung wird beendet…', false);
                try {
                    await signOut(auth);
                } catch (error) {
                    console.warn('Auto-Logout vor Registrierung fehlgeschlagen:', error);
                }
                sessionUser = null;
            }
            // Kein Zahlungs-Gate: die Trial-Registrierung legt das Konto direkt an (kein Checkout nötig).
            registrationInProgress = true;
            const submitButton = document.querySelector('[data-action="submit"]');
            const submitLabel = submitButton?.textContent || '';
            if (submitButton) {
                submitButton.disabled = true;
                submitButton.textContent = 'Bitte warten...';
            }
            setStatus('Registrierung läuft. Bitte warten...', false);

            try {
                if (state.mode === 'join') {
                    const joinCode = state.data.join.code.trim().toUpperCase();
                    if (!joinCode) {
                        throw new Error('Firmencode fehlt.');
                    }

                    const orgId = await resolveOrgIdByCode(joinCode);

                    setStatus('Konto wird erstellt...', false);
                    const credential = await createAuthAccount(email, account.password);

                    const joinRequestsRef = collection(db, 'orgs', orgId, 'join_requests');
                    let invitedDoc = null;
                    let invitedRole = state.data.join.role;
                    let isInvited = false;
                    const fromInviteLink = Boolean(state.data.join?.fromInviteLink || (state.data.join?.codeLocked && state.data.join?.roleLocked));
                    try {
                        const inviteSnap = await getDocs(query(
                            joinRequestsRef,
                            where('email', '==', email),
                            where('status', '==', 'invited')
                        ));
                        invitedDoc = inviteSnap.empty ? null : inviteSnap.docs[0];
                        invitedRole = invitedDoc?.data()?.requestedRole || invitedRole;
                        isInvited = Boolean(invitedDoc);
                    } catch (error) {
                        console.warn('Join request lookup failed:', error);
                    }
                    const autoApprove = false;

                    await createUserProfile(credential.user.uid, {
                        name: account.name,
                        phone: account.phone,
                        email,
                        role: 'Pending',
                        requestedRole: invitedRole,
                        orgId,
                        // SICHERHEIT/RULES: explizit false — die users-create-Regel prüft
                        // `isOwner != true`, was bei FEHLENDEM Feld in Firestore-Rules zu einem
                        // Zugriffsfehler → Deny führt. Ohne dieses Feld scheitert JEDER Beitritt.
                        isOwner: false,
                        status: 'pending'
                    });
                    await sendVerificationEmailSafe(orgId).catch(() => {});

                    if (autoApprove && invitedDoc) {
                        await setDoc(invitedDoc.ref, {
                            userId: credential.user.uid,
                            name: account.name,
                            email,
                            phone: account.phone,
                            requestedRole: invitedRole,
                            status: 'accepted',
                            acceptedAt: serverTimestamp(),
                            updatedAt: serverTimestamp()
                        }, { merge: true });
                    }

                    const existingInviteSnap = await getDocs(query(joinRequestsRef, where('email', '==', email)));
                    const joinPayload = {
                        userId: credential.user.uid,
                        name: account.name,
                        email,
                        phone: account.phone,
                        requestedRole: invitedRole,
                        status: 'pending',
                        seatReservedUntil: Timestamp.fromMillis(Date.now() + SEAT_RESERVATION_MS),
                        updatedAt: serverTimestamp()
                    };
                    if (!existingInviteSnap.empty) {
                        await setDoc(existingInviteSnap.docs[0].ref, {
                            ...joinPayload,
                            createdAt: existingInviteSnap.docs[0].data()?.createdAt || serverTimestamp()
                        }, { merge: true });
                    } else {
                        await setDoc(doc(joinRequestsRef), {
                            ...joinPayload,
                            createdAt: serverTimestamp()
                        });
                    }

                    registrationSucceeded = true;
                    localStorage.removeItem(REGISTRATION_STORAGE_KEY);
                    window.location.href = 'pending.html';
                    return;
                }

                setStatus('Konto wird vorbereitet...', false);
                let orgCode = '';
                try {
                    orgCode = await withTimeout(generateUniqueOrgCode(), 8000, 'Firmencode');
                } catch (error) {
                    console.warn('Org code fallback:', error);
                    orgCode = generateCode();
                }
                const subscriptionPlan = normalizeSubscriptionPlan(state.data.subscriptionPlan);
                const subscriptionModules = normalizeSubscriptionModules(state.data.subscriptionModules);
                const subscriptionBillingCycle = normalizeBillingCycle(state.data.subscriptionBillingCycle || SUBSCRIPTION_BILLING_DEFAULT);
                const planInfo = getSubscriptionPlanInfo(subscriptionPlan);
                const employeeCount = normalizeEmployeeCount(state.data.employeeCount, subscriptionPlan);
                const billedSeatCount = Math.max(SUBSCRIPTION_INCLUDED_SEATS[subscriptionPlan] || 1, employeeCount);
                const teamInvites = normalizeInviteList(state.data.teamInvites || []);
                const salesTypes = Array.isArray(state.data.salesTypes) ? state.data.salesTypes : [];
                const trialModules = { financePlus: true, mobileApp: true, gamification: true };
                const features = buildSubscriptionFeatures(trialModules);
                const commissionConfig = features.commissions
                    ? {
                        roleDefaults: { ...COMMISSION_ROLE_DEFAULTS },
                        appointmentRate: COMMISSION_RULE_DEFAULTS.appointmentRate,
                        teamRate: COMMISSION_RULE_DEFAULTS.teamRate
                    }
                    : null;
                const defaultModules = { ...features };
                const company = state.data.company || {};
                const companyName = company.name || account.name || 'Neue Firma';
                const currency = company.currency || 'CHF';
                const billingEmail = (company.billingEmail || account.email || '').toLowerCase();
                const pipeline = state.data.pipeline || {};
                const resolvedPipelineTemplate = PIPELINE_TEMPLATES[pipeline.template] ? pipeline.template : DEFAULT_PIPELINE_TEMPLATE;
                const resolvedPipelineStages = Array.isArray(pipeline.stages) && pipeline.stages.length
                    ? pipeline.stages
                    : [...PIPELINE_TEMPLATES[resolvedPipelineTemplate].stages];
                const orgData = {
                    name: companyName,
                    legalForm: company.legalForm || '',
                    address: {
                        street: company.street || '',
                        zip: company.zip || '',
                        city: company.city || '',
                        country: company.country || 'Schweiz'
                    },
                    uid: company.uid || '',
                    website: company.website || '',
                    industry: company.industry || '',
                    salesTypes,
                    timezone: company.timezone || 'Europe/Zurich',
                    currency,
                    billingEmail,
                    logoUrl: company.logoUrl || '',
                    signatoryName: state.data.account.name,
                    signatoryRole: 'Owner',
                    teamInvites: [],
                    employeeCount,
                    featureFlags: defaultModules,
                    pipeline: {
                        template: resolvedPipelineTemplate,
                        stages: resolvedPipelineStages
                    },
                    commissionEnabled: features.commissions,
                    ...(commissionConfig ? { commissionConfig } : {}),
                    paymentTermMonths: 12,
                    modules: defaultModules,
                    subscriptionStatus: 'trial',
                    subscriptionActive: false,
                    trialMode: true,
                    trialLeadsMax: 5,
                    trialAllModulesEnabled: true,
                    subscriptionPlan,
                    subscriptionInitialPlan: subscriptionPlan,
                    subscriptionModules: { financePlus: true, mobileApp: true, gamification: true },
                    subscriptionBillingCycle,
                    subscriptionSeatCount: billedSeatCount,
                    subscriptionPlanPrice: planInfo.price,
                    subscriptionBasePrice: planInfo.price,
                    subscriptionCurrency: currency,
                    subscriptionCreatedAt: serverTimestamp(),
                    orgCode,
                    onboardingComplete: false,
                    createdAt: serverTimestamp(),
                    updatedAt: serverTimestamp()
                };

                setStatus('Konto wird erstellt...', false);
                const credential = await createAuthAccount(email, account.password);

                if (auth.currentUser) {
                    await withTimeout(
                        auth.currentUser.getIdToken(true),
                        10000,
                        'Authentifizierung'
                    );
                }

                setStatus('Organisation wird angelegt...', false);
                const orgRef = await withTimeout(
                    addDoc(collection(db, 'orgs'), {
                        ...orgData,
                        ownerId: credential.user.uid
                    }),
                    15000,
                    'Organisationserstellung'
                );

                await createUserProfile(credential.user.uid, {
                    name: account.name,
                    phone: account.phone,
                    email,
                    role: 'Admin',
                    isOwner: true,
                    orgId: orgRef.id,
                    status: 'active'
                });
                await sendVerificationEmailSafe(orgRef.id).catch(() => {});

                if (pendingLogoFile) {
                    try {
                        setStatus('Logo wird hochgeladen...', false);
                        const logoUpload = await uploadOrgLogo(orgRef.id, pendingLogoFile);
                        if (logoUpload?.url) {
                            await updateDoc(orgRef, {
                                logoUrl: logoUpload.url,
                                logoPath: logoUpload.path || '',
                                updatedAt: serverTimestamp()
                            });
                            state.data.company.logoUrl = logoUpload.url;
                        }
                        pendingLogoFile = null;
                    } catch (error) {
                        console.warn('Logo upload failed:', error);
                    }
                }

                const inviteNoteParts = [];
                if (teamInvites.length) {
                    try {
                        await createJoinRequestsForInvites(orgRef.id, teamInvites, credential.user);
                        if (sendInviteEmailFn) {
                            const failedInvites = await sendInviteEmails(teamInvites, { ...orgData, orgCode }, orgRef.id, credential.user);
                            if (failedInvites.length) {
                                inviteNoteParts.push('Einige Einladungen konnten nicht gesendet werden.');
                            }
                        } else {
                            inviteNoteParts.push('Einladungen wurden vorbereitet (E-Mail Versand inaktiv).');
                        }
                    } catch (error) {
                        console.warn('Invite setup failed:', error);
                        inviteNoteParts.push('Einladungen konnten nicht verarbeitet werden.');
                    }
                }

                const productsPayload = buildCatalogProductsPayload(orgData, state.data.products || []);
                if (productsPayload.length) {
                    const batch = writeBatch(db);
                    productsPayload.forEach(product => {
                        const ref = doc(collection(db, 'orgs', orgRef.id, 'products'));
                        batch.set(ref, {
                            ...product,
                            createdAt: serverTimestamp(),
                            updatedAt: serverTimestamp()
                        });
                    });
                    await batch.commit();
                }

                const inviteNote = inviteNoteParts.length ? ` · ${inviteNoteParts.join(' ')}` : '';
                registrationSucceeded = true;
                localStorage.removeItem(REGISTRATION_STORAGE_KEY);
                clearPaymentState();
                registrationInProgress = false;
                renderFinalSuccessScreen({
                    title: 'Konto erstellt — bitte E-Mail bestätigen',
                    message: `Fast fertig! Wir haben dir einen Bestätigungslink an ${email} geschickt. Öffne ihn, um dein CRM freizuschalten — danach hast du vollen Zugang während der Testphase und bis zu 5 Leads (keine Kreditkarte nötig).${inviteNote}`,
                    nextSteps: [
                        { title: 'E-Mail bestätigen', text: 'Öffne den Link in deiner E-Mail — auch den Spam-/Werbung-Ordner prüfen.' },
                        { title: 'Team einladen', text: 'Arbeite danach direkt mit deinem Team im CRM.' },
                        { title: 'Erste Leads anlegen', text: 'Starte mit bis zu 5 kostenlosen Leads.' }
                    ]
                });
                return;
            } catch (error) {
                console.error('Registrierung fehlgeschlagen:', error);
                const message = (error?.message || '').toString();
                if (message.toLowerCase().includes('firmencode')) {
                    setStatus('Firmencode nicht gefunden. Bitte prüfen und erneut versuchen.');
                } else if (error?.code === 'auth/configuration-not-found') {
                    setStatus('Firebase Auth ist nicht konfiguriert. Bitte in der Firebase Console unter Authentication -> Sign-in methods E-Mail/Passwort aktivieren und die Domain freigeben.');
                } else if (error?.code === 'auth/email-already-in-use') {
                    // Zurück zum E-Mail-Schritt, damit die Meldung im Kontext steht (die E-Mail
                    // bleibt vorausgefüllt) — statt am Seitenende zu verpuffen.
                    goToStep('account');
                    setStatus('Diese E-Mail wird bereits verwendet. Melde dich damit an (oben „Zurück zum Login") oder nimm eine andere Adresse.');
                } else if (error?.code === 'functions/unavailable') {
                    setStatus('Zahlung ist aktuell nicht erreichbar. Bitte in 1-2 Minuten erneut versuchen.');
                } else {
                    setStatus(message || 'Registrierung fehlgeschlagen.');
                }
                if (submitButton) {
                    submitButton.disabled = false;
                    submitButton.textContent = submitLabel;
                }
                // Fehlermeldung ins Sichtfeld holen — die Statuszeile sitzt am Seitenende und
                // war sonst leicht zu übersehen („es passiert nichts", obwohl ein Fehler stand).
                try { ui.formStatus?.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) {}
            } finally {
                if (!registrationSucceeded) {
                    registrationInProgress = false;
                    setStepLoading(false);
                }
            }
        };

        const startChat = () => {
            registrationInProgress = false;
            setVerificationViewActive(false);
            clearChat();
            if (pendingSubscriptionReturn) {
                handleSubscriptionReturn();
                return;
            }
            const initialStep = resolveInitialStep();
            goToStep(initialStep);
        };

        if (ui.chatReset) {
            ui.chatReset.addEventListener('click', () => {
                resetState();
                startChat();
            });
        }

        const setupFeatureHelpTooltips = () => {
            const closeAll = (keep = null) => {
                document.querySelectorAll('.feature-help.is-active').forEach(el => {
                    if (el !== keep) el.classList.remove('is-active');
                });
            };
            document.addEventListener('click', (event) => {
                const help = event.target.closest('.feature-help');
                if (!help) {
                    closeAll();
                    return;
                }
                event.preventDefault();
                event.stopPropagation();
                const willOpen = !help.classList.contains('is-active');
                closeAll(help);
                help.classList.toggle('is-active', willOpen);
            });
            document.addEventListener('keydown', (event) => {
                if (event.key === 'Escape') closeAll();
                if ((event.key === 'Enter' || event.key === ' ') && event.target.classList?.contains('feature-help')) {
                    event.preventDefault();
                    event.target.classList.toggle('is-active');
                }
            });
        };
        setupFeatureHelpTooltips();

        const legalModal = document.getElementById('legal-modal');
        const legalModalClose = document.getElementById('legal-modal-close');
        const openLegalModal = (section) => {
            if (!legalModal) return;
            legalModal.classList.remove('hidden');
            document.body.classList.add('modal-open');
            const target = section === 'privacy'
                ? document.getElementById('legal-privacy')
                : document.getElementById('legal-terms');
            target?.scrollIntoView({ block: 'start' });
        };
        const closeLegalModal = () => {
            if (!legalModal) return;
            legalModal.classList.add('hidden');
            document.body.classList.remove('modal-open');
        };
        document.addEventListener('click', (event) => {
            const opener = event.target.closest('[data-legal-open]');
            if (opener) {
                event.preventDefault();
                openLegalModal(opener.dataset.legalOpen);
                return;
            }
            if (event.target === legalModal) {
                closeLegalModal();
            }
        });
        if (legalModalClose) {
            legalModalClose.addEventListener('click', closeLegalModal);
        }
        document.addEventListener('keydown', (event) => {
            if (event.key === 'Escape' && legalModal && !legalModal.classList.contains('hidden')) {
                closeLegalModal();
            }
        });

        if (ui.draftRestore) {
            ui.draftRestore.addEventListener('click', () => {
                if (!pendingDraft) return;
                const draftData = pendingDraft.data;
                pendingDraft = null;
                setDraftOverlayVisible(false);
                hydrateState(draftData);
                saveState();
                startChat();
            });
        }

        if (ui.draftDiscard) {
            ui.draftDiscard.addEventListener('click', () => {
                resetState();
                startChat();
            });
        }

        const initRegistration = async () => {
            await restoreState();
            applyUrlPrefill();
            // Only auto-start if no draft is waiting for user decision
            if (!pendingDraft) {
                startChat();
            }
        };
        initRegistration();
